'use strict';

var React = require('react');
var warning = require('warning');
var ReactDOM = require('react-dom');
var isEqual$1 = require('lodash.isequal');

var DEFAULT_TEXT_COLOR = '#d43517';
function getValidationTextColor(theme, level) {
    if (level === void 0) { level = 'error'; }
    return ((level === 'warning' ? theme.validationsTextColorWarning : theme.validationsTextColorError) || DEFAULT_TEXT_COLOR);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var globalObject = {};

var types$1 = {};

Object.defineProperty(types$1, "__esModule", { value: true });

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isInstanceOf = exports.isBrowser = exports.setWindow = exports.globalObject = void 0;
	exports.globalObject = (typeof window === 'object' && window) ||
	    (typeof globalThis === 'object' && globalThis) ||
	    (typeof commonjsGlobal === 'object' && commonjsGlobal) ||
	    Function('return this')();
	var setWindow = function (win) { return (exports.globalObject = win); };
	exports.setWindow = setWindow;
	var isBrowser = function (obj) {
	    return typeof window !== 'undefined' && obj === exports.globalObject;
	};
	exports.isBrowser = isBrowser;
	function isInstanceOf(instance, constructor) {
	    return typeof constructor === 'function' && instance instanceof constructor;
	}
	exports.isInstanceOf = isInstanceOf;
	__exportStar(types$1, exports); 
} (globalObject));

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min$1.ContextConsumer=h;reactIs_production_min$1.ContextProvider=g;reactIs_production_min$1.Element=b;reactIs_production_min$1.ForwardRef=l;reactIs_production_min$1.Fragment=d;reactIs_production_min$1.Lazy=q;reactIs_production_min$1.Memo=p;reactIs_production_min$1.Portal=c;reactIs_production_min$1.Profiler=f;reactIs_production_min$1.StrictMode=e;reactIs_production_min$1.Suspense=m;
	reactIs_production_min$1.SuspenseList=n;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return v(a)===h};reactIs_production_min$1.isContextProvider=function(a){return v(a)===g};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min$1.isForwardRef=function(a){return v(a)===l};reactIs_production_min$1.isFragment=function(a){return v(a)===d};reactIs_production_min$1.isLazy=function(a){return v(a)===q};reactIs_production_min$1.isMemo=function(a){return v(a)===p};
	reactIs_production_min$1.isPortal=function(a){return v(a)===c};reactIs_production_min$1.isProfiler=function(a){return v(a)===f};reactIs_production_min$1.isStrictMode=function(a){return v(a)===e};reactIs_production_min$1.isSuspense=function(a){return v(a)===m};reactIs_production_min$1.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min$1.typeOf=v;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.SuspenseList = SuspenseList;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isSuspenseList = isSuspenseList;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = requireReactIs_production_min$1();
} else {
  reactIs$1.exports = requireReactIs_development$1();
}

var reactIsExports = reactIs$1.exports;

/** @class */ ((function (_super) {
    __extends(CancelationError, _super);
    function CancelationError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = 'CancelationError';
        return _this;
    }
    return CancelationError;
})(Error));
function isFunction(x) {
    return typeof x === 'function';
}
function isClassComponent(Component) {
    return Boolean(typeof Component === 'function' && Component.prototype && Component.prototype.isReactComponent);
}
function isIntrinsicElement(element) {
    return typeof element.type === 'string';
}
function isRefableElement(element) {
    return Boolean(isIntrinsicElement(element) || isClassComponent(element.type) || reactIsExports.isForwardRef(element));
}
var getRandomID = function () { return Math.random().toString(16).slice(2); };
/**
 * Проверяет, не является ли переданный аргумент null или undefined и исключает типы null и undefined из типа аргумента
 *
 * @param value Значение, которое нужно проверить и исключить из него типы
 * @returns Возвращает true, если переданный аргумент не является null или undefined иначе false
 */
var isNonNullable$1 = function (value) {
    return value !== null && value !== undefined;
};
/**
 * Checks if the value `null` or `undefined`.
 *
 * @param value Value to check for `null` and `undefined`.
 * @returns Returns `true` if `value` is `null` or `undefined`, else `false`.
 */
var isNullable$1 = function (value) {
    return value === null || value === undefined;
};
function isElement$1(el) {
    return !!el && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
}

/**
 * Converts a string theme version to the object with numbers
 * @param str A string with version (e.g. "1.0")
 * @param [separator="."] Optional major and minor string separator. By default is "."
 * @returns An object of type { major: number; minor: number } or null, if the given string is invalid
 */
var parseThemeVersion = function (str, separator) {
    if (separator === void 0) { separator = '\\.'; }
    var match = str.match(new RegExp("(\\d+)".concat(separator, "(\\d+)")));
    var major = match === null || match === void 0 ? void 0 : match[1];
    var minor = match === null || match === void 0 ? void 0 : match[2];
    if (!major || !minor) {
        return null;
    }
    return {
        major: Number(major),
        minor: Number(minor),
    };
};
/**
 * Checks if one string theme version is "greater or equal" than another one
 * @param v1 The version being compared (e.g. "1.0")
 * @param v2 The version being compared to (e.g. "2.0")
 * @returns Boolean result
 */
var isThemeVersionGTE = function (v1, v2) {
    var parsedV1 = parseThemeVersion(v1);
    var parsedV2 = parseThemeVersion(v2);
    if (!parsedV1 || !parsedV2) {
        return false;
    }
    if (parsedV1.major > parsedV2.major) {
        return true;
    }
    else if (parsedV1.major === parsedV2.major) {
        return parsedV1.minor >= parsedV2.minor;
    }
    return false;
};

/**
 * Makes all computable theme variables (getters) visible to the Object.keys(theme)
 * @param theme Theme object
 * @returns The given theme object with all getters made enumerable
 */
var exposeGetters = function (theme) {
    var descriptors = Object.getOwnPropertyDescriptors(theme);
    Object.keys(descriptors).forEach(function (key) {
        var descriptor = descriptors[key];
        if (typeof descriptor.get === 'function' && descriptor.configurable) {
            descriptor.enumerable = true;
            Object.defineProperty(theme, key, descriptor);
        }
    });
    return theme;
};
var REACT_UI_THEME_MARKERS = {
    darkTheme: {
        key: '__IS_REACT_UI_DARK_THEME__',
        value: true,
    },
    themeVersion: {
        key: '__REACT_UI_THEME_VERSION__',
        value: null,
    },
};
/**
 * Creates a marker for the theme, that will mark it with a version
 * @param version Theme version
 * @returns A marker that marks the given theme with the given version once applied
 */
var markThemeVersion = function (version) { return function (theme) {
    var _a;
    return Object.create(theme, (_a = {},
        _a[REACT_UI_THEME_MARKERS.themeVersion.key] = {
            value: version || REACT_UI_THEME_MARKERS.themeVersion.value,
            writable: false,
            enumerable: false,
            configurable: false,
        },
        _a));
}; };
/**
 * Checks if the given theme's version is "greater or equal" then the given version
 * @param theme Theme object
 * @param version A string version
 * @returns Boolean result
 */
var isThemeGTE = function (theme, version) {
    var themeVersion = 
    // @ts-expect-error: internal value.
    theme[REACT_UI_THEME_MARKERS.themeVersion.key];
    if (!themeVersion) {
        warning(true, "[ThemeHelpers]: The theme doesn't have a version. Checking for ".concat(version, "."));
        return false;
    }
    return isThemeVersionGTE(themeVersion, version);
};
/**
 * Finds the given theme's object property descriptor by its name
 * @param theme Theme object
 * @param propName The property name
 * @returns The found descriptor or an empty object
 */
function findPropertyDescriptor(theme, propName) {
    // TODO: Rewrite for loop.
    // TODO: Enable `no-param-reassign` rule.
    // eslint-disable-next-line no-param-reassign
    for (; isNonNullable$1(theme); theme = Object.getPrototypeOf(theme)) {
        if (Object.prototype.hasOwnProperty.call(theme, propName)) {
            return Object.getOwnPropertyDescriptor(theme, propName) || {};
        }
    }
    return {};
}
/**
 * Marks the given theme with the given markers
 * @param theme Theme object
 * @param markers Markers array
 * @returns The given theme marked with the given marks
 */
function applyMarkers(theme, markers) {
    return markers.reduce(function (markedTheme, marker) {
        return marker(markedTheme);
    }, Object.create(theme));
}
/**
 * Creates a theme object out of the given class with variables
 * @param options Options object
 * @param options.themeClass A class with variables
 * @param [options.prototypeTheme] An optional prototype theme, that will be the base for the new theme
 * @param [options.themeMarkers] An optional array of markers, that new them will be marked of
 * @returns The new theme object
 */
function createTheme(options) {
    var themeClass = options.themeClass, prototypeTheme = options.prototypeTheme, _a = options.themeMarkers, themeMarkers = _a === void 0 ? [] : _a;
    if (prototypeTheme) {
        Object.setPrototypeOf(themeClass, prototypeTheme);
    }
    var theme = applyMarkers(exposeGetters(themeClass), themeMarkers);
    return Object.freeze(theme);
}

function clamp(val, max) {
    if (max === void 0) { max = 1; }
    return Math.min(max, Math.max(0, val));
}
function integerFromPercent(n, size) {
    return Math.round((parseFloat(n) * size) / 100);
}
function floatFromPercent(n) {
    return parseFloat((parseFloat(n) / 100).toFixed(5));
}
function roundToPrecision(n, precision) {
    return parseFloat(n.toFixed(precision));
}
function extractColorParts(input, regex) {
    var parts = regex.exec(input);
    if (!parts) {
        throw new Error("".concat(input, " does not match color patterns: [\n      ").concat(regex, "\n    ]"));
    }
    return parts;
}
function parseRGBParts(parts) {
    var r = parseToInteger(parts[1], 255);
    var g = parseToInteger(parts[2], 255);
    var b = parseToInteger(parts[3], 255);
    var a = parts[4] ? parseToFloat(parts[4]) : 1.0;
    if (isNaN(r)) {
        throw new Error("Could not parse red=".concat(parts[1], " to number"));
    }
    if (isNaN(g)) {
        throw new Error("Could not parse green=".concat(parts[2], " to number"));
    }
    if (isNaN(b)) {
        throw new Error("Could not parse blue=".concat(parts[3], " to number"));
    }
    if (isNaN(a)) {
        throw new Error("Could not parse alpha=".concat(parts[4], " to number"));
    }
    return { r: r, g: g, b: b, a: a };
}
function parseHSLParts(parts) {
    var h = parseInt(parts[1], 10);
    var s = parseToFloat(parts[2]);
    var l = parseToFloat(parts[3]);
    var a = parts[4] ? parseToFloat(parts[4]) : 1.0;
    if (isNaN(h)) {
        throw new Error("Could not parse hue=".concat(parts[1], " to number"));
    }
    else if (isNaN(s)) {
        throw new Error("Could not parse saturation=".concat(parts[2], " to number"));
    }
    else if (isNaN(l)) {
        throw new Error("Could not parse lightness=".concat(parts[3], " to number"));
    }
    else if (isNaN(a)) {
        throw new Error("Could not parse alpha=".concat(parts[4], " to number"));
    }
    return { h: h, s: s, l: l, a: a };
}
function parseToInteger(part, size) {
    return part.endsWith('%') ? integerFromPercent(part, size) : parseInt(part, 10);
}
function parseToFloat(part) {
    return part.endsWith('%') ? floatFromPercent(part) : parseFloat(part);
}
var calculateHue = function (hue) {
    if (hue < 0) {
        return hue + 1;
    }
    if (hue > 1) {
        return hue - 1;
    }
    return hue;
};
function hue2rgb(hue, t1, t2) {
    var calculatedHue = calculateHue(hue);
    if (calculatedHue < 1 / 6) {
        return t2 + (t1 - t2) * 6 * calculatedHue;
    }
    if (calculatedHue < 1 / 2) {
        return t1;
    }
    if (calculatedHue < 2 / 3) {
        return t2 + (t1 - t2) * (2 / 3 - calculatedHue) * 6;
    }
    return t2;
}

var ColorKeywords = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgrey: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    grey: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};

var ColorObject = /** @class */ (function () {
    function ColorObject(rgb, alpha, type) {
        this.rgb = rgb;
        this.alpha = alpha;
        this.type = type;
    }
    ColorObject.prototype.luma = function () {
        var r = this.rgb[0] / 255;
        var g = this.rgb[1] / 255;
        var b = this.rgb[2] / 255;
        r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
        g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
        b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    ColorObject.prototype.toHEXString = function () {
        warning(this.alpha === 1, "There is an alpha channel=".concat(this.alpha, ", converting to HEX will discard opacity"));
        return ('#' +
            this.rgb
                .map(function (c) {
                var clamped = clamp(Math.round(c), 255);
                return (clamped < 16 ? '0' : '') + clamped.toString(16);
            })
                .join(''));
    };
    ColorObject.prototype.toRGB = function () {
        return { r: this.rgb[0], g: this.rgb[1], b: this.rgb[2], a: this.alpha };
    };
    ColorObject.prototype.toRGBString = function () {
        return this.alpha < 1
            ? "rgba(".concat(this.rgb[0], ", ").concat(this.rgb[1], ", ").concat(this.rgb[2], ", ").concat(this.alpha, ")")
            : "rgb(".concat(this.rgb[0], ", ").concat(this.rgb[1], ", ").concat(this.rgb[2], ")");
    };
    ColorObject.prototype.toHSL = function () {
        var r = this.rgb[0] / 255;
        var g = this.rgb[1] / 255;
        var b = this.rgb[2] / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var hDeg = 0;
        var s = 0;
        var l = (max + min) / 2;
        if (max !== min) {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    hDeg = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    hDeg = (b - r) / d + 2;
                    break;
                case b:
                    hDeg = (r - g) / d + 4;
                    break;
            }
            hDeg = Math.round(hDeg * 60);
        }
        return {
            h: hDeg,
            s: roundToPrecision(s, 2),
            l: roundToPrecision(l, 2),
            a: this.alpha,
        };
    };
    ColorObject.prototype.toHSLString = function () {
        var hsl = this.toHSL();
        return hsl.a < 1
            ? "hsla(".concat(hsl.h, ", ").concat(hsl.s * 100, "%, ").concat(hsl.l * 100, "%, ").concat(hsl.a, ")")
            : "hsl(".concat(hsl.h, ", ").concat(hsl.s * 100, "%, ").concat(hsl.l * 100, "%)");
    };
    ColorObject.prototype.toColorString = function (type) {
        if (type === void 0) { type = this.type; }
        switch (type) {
            case 'rgb':
            case 'rgba': {
                return this.toRGBString();
            }
            case 'hsl':
            case 'hsla': {
                return this.toHSLString();
            }
            case 'transparent': {
                return "transparent";
            }
            default:
                return this.toHEXString();
        }
    };
    ColorObject.prototype.clone = function () {
        var _a = this, rgb = _a.rgb, alpha = _a.alpha, type = _a.type;
        return new ColorObject(rgb, alpha, type);
    };
    return ColorObject;
}());

var RGB_REGEX = /(?:rgba|rgb)\(\s*(\d{1,3}(?:(?:\.\d+)?%)?)\s*,?\s*(\d{1,3}(?:(?:\.\d+)?%)?)\s*,?\s*(\d{1,3}(?:(?:\.\d+)?%)?)\s*(?:\)|(?:,|\/)?\s*(0|0\.\d+|1|1\.0+|\d{1,3}(?:(?:\.\d+)?%))\s*\))/;
var HSL_REGEX = /(?:hsla|hsl)\(\s*(\d{1,3}(?:deg)?\b)\s*,?\s*(\d{1,3}\.?\d*%|[0-1](?:\.\d*)?\b)\s*,?\s*(\d{1,3}\.?\d*%|[0-1](?:\.\d*)?\b)\s*(?:\)|(?:,|\/)?\s*(\d{1,3}\.?\d*%|\d+(?:\.\d*)?)\s*\))/;
var HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/;
var ColorFactory = /** @class */ (function () {
    function ColorFactory() {
    }
    ColorFactory.create = function (input) {
        if (!this.cache[input]) {
            this.cache[input] = Object.freeze(this.instantiate(input));
        }
        return this.cache[input];
    };
    ColorFactory.instantiate = function (input) {
        if (typeof input !== 'string') {
            warning(false, "Invalid type of input (".concat(typeof input, "), expected a string. Returning transparent color"));
            return new ColorObject([0, 0, 0], 1.0, 'transparent');
        }
        var lowercasedTrimmedInput = input.toLowerCase().trim();
        if (lowercasedTrimmedInput === 'transparent') {
            return new ColorObject([0, 0, 0], 0, 'transparent');
        }
        if (this.isKeyword(lowercasedTrimmedInput)) {
            return this.fromKeyword(lowercasedTrimmedInput);
        }
        if (lowercasedTrimmedInput.startsWith('rgb')) {
            var parts = extractColorParts(lowercasedTrimmedInput, RGB_REGEX);
            var _a = parseRGBParts(parts), r = _a.r, g = _a.g, b = _a.b, a = _a.a;
            r = clamp(r, 255);
            g = clamp(g, 255);
            b = clamp(b, 255);
            a = clamp(a, 1);
            return this.fromRGB(r, g, b, a);
        }
        if (lowercasedTrimmedInput.startsWith('hsl')) {
            var parts = extractColorParts(lowercasedTrimmedInput, HSL_REGEX);
            var _b = parseHSLParts(parts), h = _b.h, s = _b.s, l = _b.l, a = _b.a;
            h = clamp(h, 360);
            s = clamp(s, 1);
            l = clamp(l, 1);
            a = clamp(a, 1);
            return this.fromHSL(h, s, l, a);
        }
        return this.fromHex(lowercasedTrimmedInput);
    };
    ColorFactory.isKeyword = function (input) {
        return Object.prototype.hasOwnProperty.call(ColorKeywords, input);
    };
    ColorFactory.fromKeyword = function (keyword) {
        return this.fromHex(ColorKeywords[keyword], keyword);
    };
    ColorFactory.fromHex = function (hexString, type) {
        var _a;
        if (type === void 0) { type = 'hex'; }
        if (!HEX_REGEX.test(hexString)) {
            throw new Error("".concat(hexString, " is not a valid hex color string"));
        }
        var colorCode = hexString.substring(1);
        var rgb = [0, 0, 0];
        if (colorCode.length === 6) {
            (_a = colorCode.match(/.{2}/g)) === null || _a === void 0 ? void 0 : _a.forEach(function (c, i) {
                rgb[i] = parseInt(c, 16);
            });
        }
        else if (colorCode.length === 3) {
            colorCode.split('').forEach(function (c, i) {
                rgb[i] = parseInt(c + c, 16);
            });
        }
        return new ColorObject(rgb, 1.0, type);
    };
    ColorFactory.fromRGB = function (r, g, b, a) {
        if (a === void 0) { a = 1.0; }
        return new ColorObject([r, g, b], a, a < 1 ? 'rgba' : 'rgb');
    };
    ColorFactory.fromHSL = function (h, s, l, a) {
        if (a === void 0) { a = 1.0; }
        if (s === 0) {
            var gray = Math.round(l * 255);
            return new ColorObject([gray, gray, gray], a, a < 1 ? 'hsla' : 'hsl');
        }
        var hDeg = h / 360;
        var t1 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var t2 = l * 2 - t1;
        var r = hue2rgb(hDeg + 1 / 3, t1, t2);
        var g = hue2rgb(hDeg, t1, t2);
        var b = hue2rgb(hDeg - 1 / 3, t1, t2);
        var rgb = [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
        return new ColorObject(rgb, a, a < 1 ? 'hsla' : 'hsl');
    };
    ColorFactory.cache = Object.create(null);
    return ColorFactory;
}());

ColorFactory.create('#333333');
ColorFactory.create('#fff');
var ColorFunctionsCache = Object.create(null);
var buildCacheKey = function (name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return "".concat(name, "(").concat(args.join(), ")");
};
var shiftColor = function (colorString, a, sign, method) {
    if (!colorString) {
        return '';
    }
    if (colorString.toLowerCase() === 'transparent') {
        return 'transparent';
    }
    var amount;
    if (typeof a === 'string') {
        amount = a.endsWith('%') ? floatFromPercent(a) : parseFloat(a);
    }
    else {
        amount = a;
    }
    amount = clamp(amount, 1);
    var color = ColorFactory.create(colorString);
    var hsl = color.toHSL();
    if (sign === '+') {
        hsl.l += amount;
    }
    else {
        hsl.l -= amount;
    }
    hsl.l = clamp(hsl.l);
    var newColor;
    if (color.alpha < 1) {
        newColor = ColorFactory.create("hsla(".concat(hsl.h, ", ").concat(hsl.s, ", ").concat(hsl.l, ", ").concat(hsl.a, ")"));
    }
    else {
        newColor = ColorFactory.create("hsl(".concat(hsl.h, ", ").concat(hsl.s, ", ").concat(hsl.l, ")"));
    }
    return newColor.toColorString(color.type);
};
function lighten(colorString, amount, method) {
    var key = buildCacheKey('lighten', colorString, amount, method);
    if (ColorFunctionsCache[key] === undefined) {
        ColorFunctionsCache[key] = shiftColor(colorString, amount, '+');
        return ColorFunctionsCache[key];
    }
    return ColorFunctionsCache[key];
}
function darken(colorString, amount, method) {
    var key = buildCacheKey('darken', colorString, amount, method);
    if (ColorFunctionsCache[key] === undefined) {
        ColorFunctionsCache[key] = shiftColor(colorString, amount, '-');
        return ColorFunctionsCache[key];
    }
    return ColorFunctionsCache[key];
}
var fade = function (colorString, alpha) {
    var key = buildCacheKey('fade', colorString, alpha);
    if (ColorFunctionsCache[key] === undefined) {
        var color = ColorFactory.create(colorString).clone();
        color.alpha = alpha;
        ColorFunctionsCache[key] = color.toColorString(color.type === 'hex' ? 'rgba' : color.type);
    }
    return ColorFunctionsCache[key];
};

var BasicThemeClass = /** @class */ (function () {
    function BasicThemeClass() {
    }
    Object.defineProperty(BasicThemeClass, "bgSecondary", {
        get: function () {
            return this.bgDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "errorMain", {
        get: function () {
            return this.red;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "errorText", {
        get: function () {
            return this.redDark;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "errorSecondary", {
        get: function () {
            return this.redXxLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "borderColorError", {
        get: function () {
            return this.errorMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "borderColorWarning", {
        get: function () {
            return this.warningMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkHoverColor", {
        get: function () {
            return this.linkColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkSuccessColor", {
        get: function () {
            return this.green;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkSuccessHoverColor", {
        get: function () {
            return this.greenDark;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkDangerColor", {
        get: function () {
            return this.errorText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkDisabledColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkHoverTextDecorationStyle", {
        get: function () {
            return this.linkTextDecorationStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkLineHoverBorderBottomStyle", {
        get: function () {
            return this.linkLineBorderBottomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkFocusOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "linkFocusOutline", {
        get: function () {
            return "".concat(this.linkFocusOutlineWidth, " solid ").concat(this.linkFocusOutlineColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenTextColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenPaddingYDisabled", {
        get: function () {
            return this.tokenPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenPaddingXDisabled", {
        get: function () {
            return this.tokenPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenMarginYDisabled", {
        get: function () {
            return this.tokenMarginYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenMarginXDisabled", {
        get: function () {
            return this.tokenMarginXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputLineHeightSmall", {
        //#endregion Token
        //#region TokenInput
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderColor", {
        get: function () {
            return this.inputBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderColorHover", {
        get: function () {
            return this.inputBorderColorHover;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderColorFocus", {
        get: function () {
            return this.inputBorderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderColorError", {
        get: function () {
            return this.inputBorderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderColorWarning", {
        get: function () {
            return this.inputBorderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderTopColor", {
        get: function () {
            return this.inputBorderTopColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputPlaceholderColor", {
        get: function () {
            return this.inputPlaceholderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputPlaceholderColorLight", {
        get: function () {
            return this.inputPlaceholderColorLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputDisabledBg", {
        get: function () {
            return this.inputDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputDisabledBorderColor", {
        get: function () {
            return this.inputDisabledBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBorderWidth", {
        get: function () {
            return this.inputBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputOutlineWidth", {
        get: function () {
            return this.inputOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputBg", {
        get: function () {
            return this.inputBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputShadow", {
        get: function () {
            return this.inputShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputTextColor", {
        get: function () {
            return this.inputTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputTextColorDisabled", {
        get: function () {
            return this.textColorDisabledContrast;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tokenInputPlaceholderColorDisabled", {
        get: function () {
            return this.textColorDisabledContrast;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnCheckedDisabledBorderColor", {
        get: function () {
            return this.btnCheckedDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnIconGapSmallRight", {
        get: function () {
            return this.btnIconGapSmallLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnIconGapMediumRight", {
        get: function () {
            return this.btnIconGapMediumLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnIconGapLargeRight", {
        get: function () {
            return this.btnIconGapLargeLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDefaultCheckedBorderColor", {
        get: function () {
            return this.btnCheckedBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDefaultTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDefaultHoverBorderColor", {
        get: function () {
            return this.btnDefaultBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDefaultActiveBorderColor", {
        get: function () {
            return this.btnDefaultBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDangerBg", {
        get: function () {
            return this.errorMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDangerBorderColor", {
        get: function () {
            return this.btnDangerBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDangerActiveBorderColor", {
        get: function () {
            return this.btnDangerActiveBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnPayTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnPaddingYSmall", {
        get: function () {
            return this.controlPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnPaddingYMedium", {
        get: function () {
            return this.controlPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnPaddingYLarge", {
        get: function () {
            return this.controlPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnHeightSmall", {
        get: function () {
            var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
            var padding = parseInt(this.btnPaddingYSmall, 10) || 0;
            var lineHeigh = parseInt(this.btnLineHeightSmall, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnHeightMedium", {
        get: function () {
            var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
            var padding = parseInt(this.btnPaddingYMedium, 10) || 0;
            var lineHeigh = parseInt(this.btnLineHeightMedium, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnHeightLarge", {
        get: function () {
            var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
            var padding = parseInt(this.btnPaddingYLarge, 10) || 0;
            var lineHeigh = parseInt(this.btnLineHeightLarge, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkColor", {
        get: function () {
            return this.linkColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkHoverColor", {
        get: function () {
            return this.linkHoverColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkActiveColor", {
        get: function () {
            return this.linkActiveColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkHoverTextDecoration", {
        get: function () {
            return this.linkHoverTextDecoration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkTextDecorationColor", {
        get: function () {
            return this.linkTextDecorationColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkTextDecorationStyle", {
        get: function () {
            return this.linkTextDecorationStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkHoverTextDecorationStyle", {
        get: function () {
            return this.linkTextDecorationStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkTextUnderlineOffset", {
        get: function () {
            return this.linkTextUnderlineOffset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkTextDecorationThickness", {
        get: function () {
            return this.linkTextDecorationThickness;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkTextUnderlineOpacity", {
        get: function () {
            return this.linkTextUnderlineOpacity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkLineBorderBottomStyle", {
        get: function () {
            return this.linkLineBorderBottomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkHoverLineBorderBottomStyle", {
        get: function () {
            return this.btnLinkLineBorderBottomStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkLineBorderBottomWidth", {
        get: function () {
            return this.linkLineBorderBottomWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkLineBorderBottomOpacity", {
        get: function () {
            return this.linkLineBorderBottomOpacity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkIconMarginRight", {
        get: function () {
            return this.linkIconMarginRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkIconMarginLeft", {
        get: function () {
            return this.linkIconMarginRight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnErrorSecondary", {
        get: function () {
            return this.errorSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnWarningSecondary", {
        get: function () {
            return this.warningSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnOutlineColorFocus", {
        get: function () {
            return this.outlineColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnLinkDisabledColor", {
        get: function () {
            return this.linkDisabledColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnDisabledTextColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBacklessActiveBorderColor", {
        get: function () {
            return this.btnBacklessBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBacklessBorderColor", {
        get: function () {
            return this.btnDefaultBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBacklessDisabledBorderColor", {
        get: function () {
            return this.btnDisabledBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBacklessHoverBorderColor", {
        get: function () {
            return this.btnBacklessBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnBacklessTextColor", {
        get: function () {
            return this.btnDefaultTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnTextBorderColor", {
        get: function () {
            return this.btnDefaultBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnTextTextColor", {
        get: function () {
            return this.btnDefaultTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnTextHoverBorderColor", {
        get: function () {
            return this.btnTextHoverBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnWithIconPaddingLeftSmall", {
        /** @deprecated use btnWithIconPadding[Small/Medium/Large] instead */
        get: function () {
            return this.btnWithIconPaddingSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnWithIconPaddingLeftMedium", {
        get: function () {
            return this.btnWithIconPaddingMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "btnWithIconPaddingLeftLarge", {
        get: function () {
            return this.btnWithIconPaddingLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectDefaultBg", {
        //#endregion Button
        //#region Select
        get: function () {
            return this.inputBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectPlaceholderColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectPaddingYSmall", {
        get: function () {
            return this.controlPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderRadiusSmall", {
        get: function () {
            return this.inputBorderRadiusSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderRadiusMedium", {
        get: function () {
            return this.inputBorderRadiusMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderRadiusLarge", {
        get: function () {
            return this.inputBorderRadiusLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconGapSmall", {
        get: function () {
            return this.inputIconGapSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconGapMedium", {
        get: function () {
            return this.inputIconGapMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconGapLarge", {
        get: function () {
            return this.inputIconGapLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectPaddingYMedium", {
        get: function () {
            return this.controlPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectPaddingYLarge", {
        get: function () {
            return this.controlPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectMenuArrowColor", {
        get: function () {
            return this.btnMenuArrowColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectMenuArrowColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconSizeSmall", {
        get: function () {
            return this.btnIconSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconSizeMedium", {
        get: function () {
            return this.btnIconSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectIconSizeLarge", {
        get: function () {
            return this.btnIconSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectTextColorDisabled", {
        get: function () {
            return this.btnDisabledTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBgDisabled", {
        get: function () {
            return this.inputDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderColorDisabled", {
        get: function () {
            return this.btnDisabledBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectMenuOffsetY", {
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "selectBorderColorHover", {
        get: function () {
            return this.btnDefaultHoverBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipCloseBtnColor", {
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipBorder", {
        get: function () {
            return this.popupBorder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipPinSize", {
        /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
         * @see {@link tooltipPinSizeSmall `tooltipPinSizeSmall`} */
        get: function () {
            return this.popupPinSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipFontSize", {
        /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
         * @see {@link tooltipFontSizeSmall `tooltipFontSizeSmall`} */
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipLineHeight", {
        /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
         * @see {@link tooltipLineHeightSmall `tooltipLineHeightSmall`} */
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipMenuPinOffsetX", {
        //#endregion Tooltip
        //#region TooltipMenu
        get: function () {
            return this.tooltipPinOffsetX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipMenuPinOffsetY", {
        get: function () {
            return this.tooltipPinOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipMenuMargin", {
        get: function () {
            return this.popupMargin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tooltipMenuPinSize", {
        get: function () {
            return this.popupPinSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalBg", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalCloseButtonColor", {
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFixedHeaderBg", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFixedHeaderShadow", {
        get: function () {
            return this.fixedPanelShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFixedFooterShadow", {
        get: function () {
            return this.fixedPanelShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFooterBg", {
        get: function () {
            return this.modalBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalHeaderTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalHeaderAdditionalPaddingBottom", {
        get: function () {
            return this.modalHeaderPaddingBottom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFixedHeaderPaddingBottom", {
        get: function () {
            return this.modalHeaderPaddingBottom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFixedFooterPaddingTop", {
        get: function () {
            return this.modalFooterPanelPaddingTop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "modalFooterPanelPaddingBottom", {
        get: function () {
            return this.modalFooterPaddingBottom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "mobileModalWithoutHeaderCloseButtonWidth", {
        get: function () {
            return "".concat(parseInt(this.modalCloseIconSize) + 2 * parseInt(this.mobileModalWithoutHeaderCloseButtonPadding), "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageFooterPanelBg", {
        //#endregion
        //#region SidePage
        get: function () {
            return this.sidePageBgDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageHeaderTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageFooterPanelPaddingTop", {
        get: function () {
            return this.sidePageFooterPaddingTop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageFooterPanelPaddingBottom", {
        get: function () {
            return this.sidePageFooterPanelPaddingTop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageCloseButtonFixedClickAreaTop", {
        get: function () {
            return this.sidePageCloseButtonFixedClickAreaBottom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageFixedHeaderShadow", {
        get: function () {
            return this.fixedPanelShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "sidePageFixedFooterShadow", {
        get: function () {
            return this.fixedPanelShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateInputIconColor", {
        //#endregion SidePage
        //#region DateInput
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarBottomSeparatorBorderColor", {
        //#endregion DateInput
        //#region Calendar
        get: function () {
            return fade(this.calendarMonthTitleBorderBottomColor, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarBottomSeparatorBorderWidth", {
        get: function () {
            return '1px';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarBottomSeparatorBorder", {
        get: function () {
            return "".concat(this.calendarBottomSeparatorBorderWidth, " solid ").concat(this.calendarBottomSeparatorBorderColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarBg", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarCellBg", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarCellWeekendColor", {
        get: function () {
            return this.errorText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarCellWidth", {
        get: function () {
            return this.calendarCellHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarCellLineHeight", {
        get: function () {
            return "".concat(parseInt(this.calendarCellHeight) - 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "calendarMonthHeaderStickedBgColor", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "datePickerOpenBtnColor", {
        //#endregion Calendar
        //#region DatePicker
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "datePickerMenuOffsetY", {
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectMenuBg", {
        //#endregion
        //#region DateSelect
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectMenuItemBgDisabled", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectMenuItemFontSelected", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectMenuItemFontDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectTextColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectTextColorDefault", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectLinkColor", {
        get: function () {
            return this.linkColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dateSelectPopupBoxShadow", {
        get: function () {
            return this.popupBoxShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingFontSize", {
        //#endregion DateSelect
        //#region Paging
        /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0`
         * @see {@link pagingFontSizeSmall `pagingFontSizeSmall`} */
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingPageLinkColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingPageLinkActiveColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingPageForwardLinkPaddingRight", {
        /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
        get: function () {
            return this.pagingPageLinkPaddingX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingForwardIconSize", {
        /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
        get: function () {
            return this.pagingFontSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingForwardLinkColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingForwardLinkDisabledColor", {
        get: function () {
            return this.linkDisabledColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingDotsDisabledColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "pagingPageLinkHintColor", {
        get: function () {
            return this.placeholderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "hintColor", {
        //#endregion Paging
        //#region Hint
        get: function () {
            return this.textColorInvert;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "mobileHintColor", {
        get: function () {
            return this.hintColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "hintFontSize", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "hintLineHeight", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toastFontSize", {
        //#endregion Hint
        //#region Toast
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toastLineHeight", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownMenuHoverBorderColor", {
        get: function () {
            return this.btnDefaultHoverBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownMenuOffsetY", {
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownMenuMenuOffsetY", {
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownDefaultBg", {
        get: function () {
            return this.btnDefaultBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownBorderWidth", {
        get: function () {
            return this.btnBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownOutlineWidth", {
        get: function () {
            return this.btnOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownLineHeightSmall", {
        get: function () {
            return this.btnLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownFontSizeSmall", {
        get: function () {
            return this.btnFontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingXSmall", {
        get: function () {
            return this.btnPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingYSmall", {
        get: function () {
            return this.btnPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownIconSizeSmall", {
        get: function () {
            return this.btnIconSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownLineHeightMedium", {
        get: function () {
            return this.btnLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownFontSizeMedium", {
        get: function () {
            return this.btnFontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingXMedium", {
        get: function () {
            return this.btnPaddingXMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingYMedium", {
        get: function () {
            return this.btnPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownIconSizeMedium", {
        get: function () {
            return this.btnIconSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownLineHeightLarge", {
        get: function () {
            return this.btnLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownFontSizeLarge", {
        get: function () {
            return this.btnFontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingXLarge", {
        get: function () {
            return this.btnPaddingXLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownPaddingYLarge", {
        get: function () {
            return this.btnPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownIconSizeLarge", {
        get: function () {
            return this.btnIconSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownBgDisabled", {
        get: function () {
            return this.btnDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownBorderColorDisabled", {
        get: function () {
            return this.btnDisabledBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "dropdownTextColorDisabled", {
        get: function () {
            return this.btnDisabledTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuBgDefault", {
        //#endregion Dropdown
        //#region Menu
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemTextColor", {
        // menuItem
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemPaddingForIconSmall", {
        get: function () {
            return "".concat(parseInt(this.menuItemPaddingXSmall) + parseInt(this.menuItemIconWidthSmall) + parseInt(this.menuItemIconGap), "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemPaddingForIconMedium", {
        get: function () {
            return "".concat(parseInt(this.menuItemPaddingXMedium) + parseInt(this.menuItemIconWidthMedium) + parseInt(this.menuItemIconGap), "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemPaddingForIconLarge", {
        get: function () {
            return "".concat(parseInt(this.menuItemPaddingXLarge) + parseInt(this.menuItemIconWidthLarge) + parseInt(this.menuItemIconGap), "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemHoverColor", {
        get: function () {
            return this.menuItemTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemLinkColor", {
        /**
         * @deprecated
         */
        get: function () {
            return this.linkColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemCommentColor", {
        get: function () {
            return this.menuItemTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemCommentColorHover", {
        get: function () {
            return this.menuItemTextColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemLineHeightMobile", {
        get: function () {
            return this.lineHeightMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemFontSizeMobile", {
        get: function () {
            return this.fontSizeMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuItemDisabledColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageTextColor", {
        // menuMessage
        get: function () {
            return this.menuItemDisabledColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageBg", {
        get: function () {
            return this.menuItemDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessagePaddingY", {
        get: function () {
            return this.menuItemPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessagePaddingX", {
        get: function () {
            return this.menuItemPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageDisplay", {
        get: function () {
            return this.menuItemDisplay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessagePaddingMobile", {
        get: function () {
            return this.menuItemPaddingMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageLineHeightMobile", {
        get: function () {
            return this.menuItemLineHeightMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageFontSizeMobile", {
        get: function () {
            return this.menuItemFontSizeMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageFontSizeSmall", {
        get: function () {
            return this.menuItemFontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageFontSizeMedium", {
        get: function () {
            return this.menuItemFontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageFontSizeLarge", {
        get: function () {
            return this.menuItemFontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageLineHeightSmall", {
        get: function () {
            return this.menuItemLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageLineHeightMedium", {
        get: function () {
            return this.menuItemLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuMessageLineHeightLarge", {
        get: function () {
            return this.menuItemLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterColor", {
        //menuFooter
        get: function () {
            return this.menuHeaderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterLineHeightSmall", {
        get: function () {
            return this.menuHeaderLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterLineHeightMedium", {
        get: function () {
            return this.menuHeaderLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterLineHeightLarge", {
        get: function () {
            return this.menuHeaderLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterFontSizeSmall", {
        get: function () {
            return this.menuHeaderFontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterFontSizeMedium", {
        get: function () {
            return this.menuHeaderFontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterFontSizeLarge", {
        get: function () {
            return this.menuHeaderFontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingXSmall", {
        get: function () {
            return this.menuHeaderPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingXMedium", {
        get: function () {
            return this.menuHeaderPaddingXMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingXLarge", {
        get: function () {
            return this.menuHeaderPaddingXLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingTopSmall", {
        get: function () {
            return this.menuHeaderPaddingBottomSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingTopMedium", {
        get: function () {
            return this.menuHeaderPaddingBottomMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingTopLarge", {
        get: function () {
            return this.menuHeaderPaddingBottomLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingBottomSmall", {
        get: function () {
            return this.menuHeaderPaddingTopSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingBottomMedium", {
        get: function () {
            return this.menuHeaderPaddingTopMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "menuFooterPaddingBottomLarge", {
        get: function () {
            return this.menuHeaderPaddingTopLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleLineHeightSmall", {
        //#endregion Menu
        //#region Toggle
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleHandleBorderRadiusSmall", {
        get: function () {
            var height = parseInt(this.toggleHeightSmall, 10) || 0;
            var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
            var handleSize = height - 2 * borderWidth;
            return "".concat(handleSize / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleHandleBorderRadiusMedium", {
        get: function () {
            var height = parseInt(this.toggleHeightMedium, 10) || 0;
            var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
            var handleSize = height - 2 * borderWidth;
            return "".concat(handleSize / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleHandleBorderRadiusLarge", {
        get: function () {
            var height = parseInt(this.toggleHeightLarge, 10) || 0;
            var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
            var handleSize = height - 2 * borderWidth;
            return "".concat(handleSize / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderRadiusSmall", {
        get: function () {
            return "calc(".concat(this.toggleHeightSmall, " * 0.5)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderRadiusMedium", {
        get: function () {
            return "calc(".concat(this.toggleHeightMedium, " * 0.5)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderRadiusLarge", {
        get: function () {
            return "calc(".concat(this.toggleHeightLarge, " * 0.5)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleOutlineWidth", {
        get: function () {
            var outlineWidth = parseInt(this.controlOutlineWidth, 10) || 0;
            var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
            return "".concat(outlineWidth + borderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderColorDisabled", {
        get: function () {
            return this.toggleBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleShadowColorError", {
        get: function () {
            return this.errorMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleShadowColorWarning", {
        get: function () {
            return this.warningMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleFocusShadowColor", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleOutlineColorFocus", {
        get: function () {
            return this.outlineColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleContainerBgHover", {
        get: function () {
            return this.toggleBgHover;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleContainerBgChecked", {
        get: function () {
            return this.toggleBgChecked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBgDisabled", {
        get: function () {
            return this.bgDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "toggleBorderColorDisabledChecked", {
        get: function () {
            return this.toggleBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "popupTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "popupBackground", {
        get: function () {
            return this.bgSecondary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputTextColor", {
        //#endregion
        //#region Input
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputIconColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFocusedIconColor", {
        get: function () {
            return this.inputIconColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputTextColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPlaceholderColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputHeightSmall", {
        get: function () {
            var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
            var padding = parseInt(this.inputPaddingYSmall, 10) || 0;
            var lineHeigh = parseInt(this.inputLineHeightSmall, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputHeightMedium", {
        get: function () {
            var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
            var padding = parseInt(this.inputPaddingYMedium, 10) || 0;
            var lineHeigh = parseInt(this.inputLineHeightMedium, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputHeightLarge", {
        get: function () {
            var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
            var padding = parseInt(this.inputPaddingYLarge, 10) || 0;
            var lineHeigh = parseInt(this.inputLineHeightLarge, 10) || 0;
            return "".concat(2 * borderWidth + 2 * padding + lineHeigh, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPaddingYSmall", {
        get: function () {
            return this.controlPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPaddingYMedium", {
        get: function () {
            return this.controlPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPaddingYLarge", {
        get: function () {
            return this.controlPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFocusShadow", {
        get: function () {
            return "0 0 0 ".concat(this.inputOutlineWidth, " ").concat(this.borderColorFocus);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFocusedBg", {
        get: function () {
            return this.inputBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputDisabledBg", {
        get: function () {
            return this.bgDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputDisabledBorderColor", {
        get: function () {
            return this.borderColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputFocusOutline", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputOutlineWidth", {
        get: function () {
            return "calc(".concat(this.controlOutlineWidth, " - 1px)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderColorHover", {
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputBorderTopColor", {
        get: function () {
            return this.inputBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPlaceholderColor", {
        get: function () {
            return this.placeholderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "inputPlaceholderColorLight", {
        get: function () {
            return this.placeholderColorLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxFontSizeSmall", {
        //#endregion Input
        //#region Checkbox
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxPaddingYSmall", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightSmall, 10) || 0;
            var lineHeight = parseInt(this.checkboxLineHeightSmall, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxPaddingYMedium", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightMedium, 10) || 0;
            var lineHeight = parseInt(this.checkboxLineHeightMedium, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxPaddingYLarge", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightLarge, 10) || 0;
            var lineHeight = parseInt(this.checkboxLineHeightLarge, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxTextColorDefault", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxTextColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxShadowDisabled", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " rgba(0, 0, 0, 0.1)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxShadow", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " rgba(0, 0, 0, 0.15)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxShadowHover", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " #c3c3c3");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxOutlineColorFocus", {
        get: function () {
            return this.outlineColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxCheckedHoverShadow", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " ").concat(this.checkboxCheckedHoverBg);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxCheckedShadow", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " ").concat(this.checkboxCheckedBg);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxCheckedActiveShadow", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " ").concat(this.checkboxCheckedActiveBg);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxHoverBg", {
        get: function () {
            return this.btnDefaultHoverBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxActiveBg", {
        get: function () {
            return this.btnDefaultActiveBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxCheckedBg", {
        get: function () {
            return this.bgChecked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxBgDisabled", {
        get: function () {
            return this.bgDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxCheckedActiveBg", {
        get: function () {
            return darken(this.checkboxCheckedBg, '15%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "checkboxShadowActive", {
        get: function () {
            return "0 0 0 ".concat(this.checkboxBorderWidth, " #c3c3c3");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaTextColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPlaceholderColorLight", {
        get: function () {
            return this.placeholderColorLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPlaceholderColor", {
        get: function () {
            return this.placeholderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPlaceholderColorDisabled", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaOutlineWidth", {
        get: function () {
            var outlineWidth = parseInt(this.controlOutlineWidth, 10) || 0;
            var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
            return "".concat(outlineWidth - borderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaMinHeightSmall", {
        get: function () {
            var lineHeight = parseInt(this.textareaLineHeightSmall, 10) || 0;
            var paddingY = parseInt(this.textareaPaddingYSmall, 10) || 0;
            var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
            return "".concat(lineHeight + paddingY * 2 + borderWidth * 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaMinHeightMedium", {
        get: function () {
            var lineHeight = parseInt(this.textareaLineHeightMedium, 10) || 0;
            var paddingY = parseInt(this.textareaPaddingYMedium, 10) || 0;
            var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
            return "".concat(lineHeight + paddingY * 2 + borderWidth * 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaMinHeightLarge", {
        get: function () {
            var lineHeight = parseInt(this.textareaLineHeightLarge, 10) || 0;
            var paddingY = parseInt(this.textareaPaddingYLarge, 10) || 0;
            var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
            return "".concat(lineHeight + paddingY * 2 + borderWidth * 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPaddingYSmall", {
        get: function () {
            return this.controlPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPaddingYMedium", {
        get: function () {
            return this.controlPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaPaddingYLarge", {
        get: function () {
            return this.controlPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderColor", {
        get: function () {
            return this.borderColorGrayLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderColorHover", {
        get: function () {
            return this.inputBorderColorHover;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaDisabledBg", {
        get: function () {
            return this.inputDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaDisabledBorderColor", {
        get: function () {
            return this.borderColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaCounterColor", {
        get: function () {
            return this.gray;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaCounterBg", {
        get: function () {
            return fade(this.textareaBg, 0.9);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaCounterErrorColor", {
        get: function () {
            return this.errorText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "textareaCounterHelpIconColor", {
        get: function () {
            return this.linkColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioPaddingYSmall", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightSmall, 10) || 0;
            var lineHeight = parseInt(this.radioLineHeightSmall, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioPaddingYMedium", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightMedium, 10) || 0;
            var lineHeight = parseInt(this.radioLineHeightMedium, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioPaddingYLarge", {
        get: function () {
            var controlHeight = parseInt(this.controlHeightLarge, 10) || 0;
            var lineHeight = parseInt(this.radioLineHeightLarge, 10) || 0;
            return "".concat((controlHeight - lineHeight) / 2, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioHoverBg", {
        get: function () {
            return this.checkboxHoverBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioActiveBg", {
        get: function () {
            return this.checkboxActiveBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorderColor", {
        get: function () {
            return this.borderColorGrayLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorder", {
        get: function () {
            return "".concat(this.radioBorderWidth, " solid ").concat(this.radioBorderColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioFocusShadow", {
        get: function () {
            return "inset 0 0 0 1px ".concat(this.outlineColorFocus);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioCheckedBgColor", {
        get: function () {
            return this.checkboxCheckedBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioCheckedHoverBgColor", {
        get: function () {
            return darken(this.checkboxCheckedBg, '5%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioDisabledShadow", {
        get: function () {
            return "0 0 0 ".concat(this.radioBorderWidth, " rgba(0, 0, 0, 0.1)");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "radioCheckedDisabledBulletBg", {
        get: function () {
            return this.gray;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabFontSizeSmall", {
        //#endregion
        //#region Tabs
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabPaddingYSmall", {
        get: function () {
            var paddingY = parseInt(this.controlPaddingYSmall);
            var borderWidth = parseInt(this.controlBorderWidth);
            return "".concat(paddingY + borderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabPaddingYMedium", {
        get: function () {
            var paddingY = parseInt(this.controlPaddingYMedium);
            var borderWidth = parseInt(this.controlBorderWidth);
            return "".concat(paddingY + borderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabPaddingYLarge", {
        get: function () {
            var paddingY = parseInt(this.controlPaddingYLarge);
            var borderWidth = parseInt(this.controlBorderWidth);
            return "".concat(paddingY + borderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabOutlineWidth", {
        get: function () {
            return this.controlOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabTextColorDefault", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorError", {
        get: function () {
            return this.btnDangerBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorWarning", {
        get: function () {
            return this.btnPayBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorSuccess", {
        get: function () {
            return this.btnSuccessBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorPrimary", {
        get: function () {
            return this.btnPrimaryBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorHoverError", {
        get: function () {
            return lighten(this.tabColorError, '25%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorHoverWarning", {
        get: function () {
            return lighten(this.tabColorWarning, '25%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorHoverSuccess", {
        get: function () {
            return lighten(this.tabColorSuccess, '25%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "tabColorHoverPrimary", {
        get: function () {
            return lighten(this.tabColorPrimary, '25%');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerBgColor", {
        //#endregion Tabs
        //#region Spinner
        get: function () {
            return this.grayXLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerColor", {
        get: function () {
            return this.red;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerDimmedColor", {
        get: function () {
            return this.gray;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerCaptionColor", {
        get: function () {
            return this.gray;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "spinnerLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherTextColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherOutlineWidth", {
        get: function () {
            return this.btnOutlineWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionFontSizeSmall", {
        get: function () {
            return this.btnFontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionFontSizeMedium", {
        get: function () {
            return this.btnFontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionFontSizeLarge", {
        get: function () {
            return this.btnFontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionLineHeightSmall", {
        get: function () {
            return this.btnLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionLineHeightMedium", {
        get: function () {
            return this.btnLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionLineHeightLarge", {
        get: function () {
            return this.btnLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionGapSmall", {
        get: function () {
            return this.btnPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionGapMedium", {
        get: function () {
            return this.btnPaddingXMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherCaptionGapLarge", {
        get: function () {
            return this.btnPaddingXLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonPaddingYSmall", {
        get: function () {
            return this.btnPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonPaddingYMedium", {
        get: function () {
            return this.btnPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonPaddingYLarge", {
        get: function () {
            return this.btnPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonLineHeightSmall", {
        get: function () {
            return this.btnLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonLineHeightMedium", {
        get: function () {
            return this.btnLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonLineHeightLarge", {
        get: function () {
            return this.btnLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonFontSizeSmall", {
        get: function () {
            return this.btnFontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonFontSizeMedium", {
        get: function () {
            return this.btnFontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonFontSizeLarge", {
        get: function () {
            return this.btnFontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonBorderRadiusSmall", {
        get: function () {
            return this.btnBorderRadiusSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonBorderRadiusMedium", {
        get: function () {
            return this.btnBorderRadiusMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonBorderRadiusLarge", {
        get: function () {
            return this.btnBorderRadiusLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonBorderWidth", {
        get: function () {
            return this.btnBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonDisabledBorderColor", {
        get: function () {
            return this.switcherBtnDisabledBorderColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "switcherButtonCheckedDisabledShadow", {
        get: function () {
            return this.btnCheckedDisabledShadow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "mobilePopupHeaderFontSize", {
        get: function () {
            return this.fontSizeMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "mobilePopupHeaderLineHeight", {
        get: function () {
            return this.lineHeightMobile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "globalLoaderColor", {
        //#endregion
        //#region GlobalLoader
        get: function () {
            return this.blueLight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingYSmall", {
        get: function () {
            return this.controlPaddingYSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingYMedium", {
        get: function () {
            return this.controlPaddingYMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingYLarge", {
        get: function () {
            return this.controlPaddingYLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingXSmall", {
        get: function () {
            return this.inputPaddingXSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingXMedium", {
        get: function () {
            return this.inputPaddingXMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderPaddingXLarge", {
        get: function () {
            return this.inputPaddingXLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderTileIconActionPositionSmall", {
        get: function () {
            return "".concat(parseInt(this.fileUploaderTilePaddingSmall) + 1, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderTileIconActionPositionMedium", {
        get: function () {
            return "".concat(parseInt(this.fileUploaderTilePaddingMedium) + 1, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderTileIconActionPositionLarge", {
        get: function () {
            return "".concat(parseInt(this.fileUploaderTilePaddingLarge) + 1, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFontSizeSmall", {
        get: function () {
            return this.fontSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFontSizeMedium", {
        get: function () {
            return this.fontSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFontSizeLarge", {
        get: function () {
            return this.fontSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderLineHeightSmall", {
        get: function () {
            return this.controlLineHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderLineHeightMedium", {
        get: function () {
            return this.controlLineHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderLineHeightLarge", {
        get: function () {
            return this.controlLineHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderTextColorDefault", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderBorderWidth", {
        get: function () {
            return this.controlBorderWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledBorder", {
        get: function () {
            return "".concat(this.fileUploaderBorderWidth, " ").concat(this.fileUploaderBorderStyle, " ").concat(this.fileUploaderDisabledBorderColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderLinkColor", {
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderBorderColorError", {
        get: function () {
            return this.borderColorError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderBorderColorWarning", {
        get: function () {
            return this.borderColorWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledBg", {
        get: function () {
            return this.btnDisabledBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledTextColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledLinkColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledIconColor", {
        get: function () {
            return this.textColorDisabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderErrorColor", {
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderErrorTextColor", {
        get: function () {
            return this.redDark;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderWarningTextColor", {
        get: function () {
            return this.yellowDark;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDragOverBorderColor", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderIconSizeSmall", {
        get: function () {
            return this.btnIconSizeSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderIconSizeMedium", {
        get: function () {
            return this.btnIconSizeMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderIconSizeLarge", {
        get: function () {
            return this.btnIconSizeLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFileTypeErrorIconColor", {
        get: function () {
            return this.red;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFileTypeWarningIconColor", {
        get: function () {
            return this.yellow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderFileTypePdfIconColor", {
        get: function () {
            return this.red;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "fileUploaderDisabledFileTypeIcon", {
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconWidthSmall", {
        //#endregion FileUploader
        //#region ClearCrossIcon
        get: function () {
            return this.inputHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconWidthMedium", {
        get: function () {
            return this.inputHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconWidthLarge", {
        get: function () {
            return this.inputHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconHeightSmall", {
        get: function () {
            return this.inputHeightSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconHeightMedium", {
        get: function () {
            return this.inputHeightMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconHeightLarge", {
        get: function () {
            return this.inputHeightLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconRightMarginSmall", {
        get: function () {
            var inputPaddingXSmall = parseInt(this.inputPaddingXSmall);
            var inputBorderWidth = parseInt(this.inputBorderWidth);
            return "-".concat(inputPaddingXSmall + inputBorderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconRightMarginMedium", {
        get: function () {
            var inputPaddingXMedium = parseInt(this.inputPaddingXMedium);
            var inputBorderWidth = parseInt(this.inputBorderWidth);
            return "-".concat(inputPaddingXMedium + inputBorderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconRightMarginLarge", {
        get: function () {
            var inputPaddingXLarge = parseInt(this.inputPaddingXLarge);
            var inputBorderWidth = parseInt(this.inputBorderWidth);
            return "-".concat(inputPaddingXLarge + inputBorderWidth, "px");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconBorderRadiusSmall", {
        get: function () {
            return this.inputBorderRadiusSmall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconBorderRadiusMedium", {
        get: function () {
            return this.inputBorderRadiusMedium;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "clearCrossIconBorderRadiusLarge", {
        get: function () {
            return this.inputBorderRadiusLarge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "closeBtnIconColor", {
        //#endregion ClearCrossIcon
        //#region CloseIcon
        get: function () {
            return this.closeGrayColor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "closeBtnIconFocusShadow", {
        get: function () {
            return "inset 0 0 0 1px ".concat(this.borderColorFocus, ", inset 0 0 0 2px ").concat(this.outlineColorFocus);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "autocompleteMenuOffsetY", {
        //#endregion CloseIcon
        //#region Autocomplete
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "comboboxMenuOffsetY", {
        //#endregion Autocomplete
        //#region Combobox
        get: function () {
            return this.menuOffsetY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicThemeClass, "validationsTextColorError", {
        //#endregion MiniModal
        //#region react-ui-validations
        get: function () {
            return this.errorText;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = BasicThemeClass;
    //#region Common variables
    BasicThemeClass.baseFontFamily = '"Lab Grotesque", "Lab Grotesque K", Arial, sans-serif';
    BasicThemeClass.labGrotesqueBaselineCompensation = '1';
    BasicThemeClass.brand = '#2291ff';
    BasicThemeClass.white = '#fff';
    BasicThemeClass.grayXLight = '#ebebeb';
    BasicThemeClass.gray = '#858585';
    BasicThemeClass.grayDark = '#333';
    BasicThemeClass.black = '#000';
    BasicThemeClass.blueXxLight = '#cdedff';
    BasicThemeClass.blueLight = '#1f87ef';
    BasicThemeClass.blue = '#1874cf';
    BasicThemeClass.greenXxLight = '#C7F9CC';
    BasicThemeClass.green = '#1C8A3F';
    BasicThemeClass.greenDark = '#197F39';
    BasicThemeClass.red = '#FE4C4C';
    BasicThemeClass.redXxLight = '#FFEBEB';
    BasicThemeClass.redDark = '#CC2626';
    BasicThemeClass.yellowXxLight = '#ffeec2';
    BasicThemeClass.yellow = '#fcb73e';
    BasicThemeClass.yellowDark = '#ef8b17';
    BasicThemeClass.bgDefault = '#fff';
    BasicThemeClass.bgDisabled = '#F0F0F0';
    BasicThemeClass.warningMain = '#fcb73e';
    BasicThemeClass.warningSecondary = '#fff0bc';
    BasicThemeClass.warningText = '#d97e00';
    BasicThemeClass.closeGrayColor = 'rgba(0, 0, 0, 0.32)';
    BasicThemeClass.borderColorFocusLight = '#cdedff';
    BasicThemeClass.borderColorGrayDark = 'rgba(0, 0, 0, 0.28)';
    BasicThemeClass.borderColorGrayLight = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.borderColorDisabled = 'rgba(0, 0, 0, 0.10)';
    BasicThemeClass.placeholderColor = '#adadad';
    BasicThemeClass.outlineColorFocus = '#fff';
    BasicThemeClass.placeholderColorLight = '#cdcdcd';
    BasicThemeClass.blinkColor = 'rgba(0, 136, 255, 0.2)';
    BasicThemeClass.controlBorderWidth = '1px';
    BasicThemeClass.controlOutlineWidth = '2px';
    BasicThemeClass.controlLineHeightSmall = '20px';
    BasicThemeClass.controlLineHeightMedium = '22px';
    BasicThemeClass.controlLineHeightLarge = '24px';
    BasicThemeClass.controlPaddingYSmall = '5px';
    BasicThemeClass.controlPaddingYMedium = '8px';
    BasicThemeClass.controlPaddingYLarge = '11px';
    BasicThemeClass.textColorDefault = '#222222';
    BasicThemeClass.textColorInvert = '#fff';
    BasicThemeClass.textColorDisabled = '#adadad';
    BasicThemeClass.textColorDisabledContrast = '#858585';
    BasicThemeClass.fontSizeSmall = '14px';
    BasicThemeClass.fontSizeMedium = '16px';
    BasicThemeClass.fontSizeLarge = '18px';
    BasicThemeClass.fontSizeMobile = '18px';
    BasicThemeClass.lineHeightMobile = '24px';
    BasicThemeClass.specificityLevel = '0';
    BasicThemeClass.fixedPanelShadow = 'none';
    BasicThemeClass.bgActive = '#141414';
    BasicThemeClass.bgChecked = '#3D3D3D';
    BasicThemeClass.borderColorFocus = '#3D3D3D';
    BasicThemeClass.controlHeightSmall = '32px';
    BasicThemeClass.controlHeightMedium = '40px';
    BasicThemeClass.controlHeightLarge = '48px';
    BasicThemeClass.mobileMediaQuery = '(max-width: 576px) and (pointer: coarse)';
    BasicThemeClass.transitionDuration = '100ms';
    BasicThemeClass.transitionTimingFunction = 'cubic-bezier(0.5, 1, 0.89, 1)';
    //#endregion Common variables
    //#region Link
    BasicThemeClass.linkColor = '#222222';
    BasicThemeClass.linkTextDecoration = 'underline';
    BasicThemeClass.linkActiveColor = '#141414';
    BasicThemeClass.linkHoverTextDecoration = 'none';
    BasicThemeClass.linkSuccessActiveColor = '#167333';
    BasicThemeClass.linkDangerHoverColor = '#BB1919';
    BasicThemeClass.linkDangerActiveColor = '#AB0D0D';
    BasicThemeClass.linkIconMarginRight = '4px';
    BasicThemeClass.linkIconMarginLeft = '4px';
    BasicThemeClass.linkGrayedColor = '#858585';
    BasicThemeClass.linkGrayedHoverColor = '#292929';
    BasicThemeClass.linkGrayedActiveColor = '#141414';
    BasicThemeClass.linkButtonLineHeight = '34px';
    BasicThemeClass.linkButtonPaddingX = '10px';
    BasicThemeClass.linkTextDecorationStyle = 'solid';
    BasicThemeClass.linkTextDecorationThickness = '1px';
    BasicThemeClass.linkTextUnderlineOffset = '4px';
    BasicThemeClass.linkTextUnderlineOpacity = '0.5';
    BasicThemeClass.linkTextDecorationColor = "color-mix(in srgb, currentColor ".concat(parseFloat(_a.linkTextUnderlineOpacity) * 100, "%, transparent)");
    BasicThemeClass.linkLineBorderBottomStyle = 'solid';
    BasicThemeClass.linkLineBorderBottomWidth = '1px';
    BasicThemeClass.linkLineBorderBottomOpacity = '0.5';
    BasicThemeClass.linkLineBorderBottomColor = "color-mix(in srgb, currentColor ".concat(parseFloat(_a.linkLineBorderBottomOpacity) * 100, "%, transparent)");
    BasicThemeClass.linkFocusOutlineColor = '#3D3D3D';
    //#endregion Link
    //#region Token
    BasicThemeClass.tokenDisabledBg = 'rgba(0, 0, 0, 0.05)';
    BasicThemeClass.tokenMarginYSmall = '2px';
    BasicThemeClass.tokenMarginXSmall = '1px';
    BasicThemeClass.tokenMarginYMedium = '2px';
    BasicThemeClass.tokenMarginXMedium = '2px';
    BasicThemeClass.tokenMarginYLarge = '2px';
    BasicThemeClass.tokenMarginXLarge = '3px';
    BasicThemeClass.tokenPaddingYSmall = '1px';
    BasicThemeClass.tokenPaddingXSmall = '3px';
    BasicThemeClass.tokenPaddingYMedium = '2px';
    BasicThemeClass.tokenPaddingXMedium = '5px';
    BasicThemeClass.tokenPaddingYLarge = '3px';
    BasicThemeClass.tokenPaddingXLarge = '7px';
    BasicThemeClass.tokenMarginBeforeIcon = '4px';
    BasicThemeClass.tokenRemoveIconSize = '16px';
    BasicThemeClass.tokenRemoveIconPaddingY = '0px';
    BasicThemeClass.tokenRemoveIconPaddingX = '0px';
    BasicThemeClass.tokenRemoveIconGap = '4px';
    BasicThemeClass.tokenRemoveIconBoxSizing = 'content-box';
    BasicThemeClass.tokenBorderRadius = '2px';
    BasicThemeClass.tokenBorderWidth = '1px';
    BasicThemeClass.tokenBorderColorDisabled = 'transparent';
    BasicThemeClass.tokenOutlineWidth = '1px';
    BasicThemeClass.tokenShadowDisabled = '';
    BasicThemeClass.tokenBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.tokenColor = '#222222';
    BasicThemeClass.tokenBorderColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.tokenBgHover = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.tokenColorHover = '#222222';
    BasicThemeClass.tokenBorderColorHover = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.tokenBgActive = '#3D3D3D';
    BasicThemeClass.tokenColorActive = '#FFFFFF';
    BasicThemeClass.tokenBorderColorActive = 'transparent';
    BasicThemeClass.tokenInputBorderRadius = '2px';
    BasicThemeClass.tokenInputMenuPopupBg = 'transparent';
    BasicThemeClass.tokenInputPaddingYSmall = '1px';
    BasicThemeClass.tokenInputPaddingXSmall = '2px';
    BasicThemeClass.tokenInputPaddingYMedium = '3px';
    BasicThemeClass.tokenInputPaddingXMedium = '3px';
    BasicThemeClass.tokenInputPaddingYLarge = '5px';
    BasicThemeClass.tokenInputPaddingXLarge = '4px';
    BasicThemeClass.tokenInputPopupOffset = '2px';
    BasicThemeClass.tokenInputPopupMarginSmall = '7px';
    BasicThemeClass.tokenInputPopupMarginMedium = '10px';
    BasicThemeClass.tokenInputPopupMarginLarge = '13px';
    //#endregion TokenInput
    //#region Loader
    BasicThemeClass.loaderBg = 'rgba(255, 255, 255, 0.8)';
    BasicThemeClass.loaderOpacity = '0.8';
    BasicThemeClass.loaderBorderRadius = '0px';
    //#endregion
    //#region Button
    BasicThemeClass.btnBackgroundClip = 'padding-box';
    BasicThemeClass.btnLinkBorderRadius = '2px';
    BasicThemeClass.btnFocusShadowWidth = '2px';
    BasicThemeClass.btnBorderColorTransition = '';
    BasicThemeClass.btnDisabledBorderColor = 'rgba(0, 0, 0, 0.10)';
    BasicThemeClass.btnCheckedBg = '#3D3D3D';
    BasicThemeClass.btnCheckedDisabledBg = '#ADADAD';
    BasicThemeClass.btnCheckedDisabledColor = '#E6E6E6';
    BasicThemeClass.btnCheckedTextColor = '#fff';
    BasicThemeClass.btnCheckedShadow = 'none';
    BasicThemeClass.btnCheckedDisabledShadow = 'none';
    BasicThemeClass.btnBorderRadiusSmall = '8px';
    BasicThemeClass.btnBorderRadiusMedium = '8px';
    BasicThemeClass.btnBorderRadiusLarge = '8px';
    BasicThemeClass.btnInsetWidth = '1px';
    BasicThemeClass.btnPaddingXSmall = '12px';
    BasicThemeClass.btnPaddingXMedium = '16px';
    BasicThemeClass.btnPaddingXLarge = '20px';
    BasicThemeClass.btnIconGapSmallLeft = '4px';
    BasicThemeClass.btnIconGapMediumLeft = '6px';
    BasicThemeClass.btnIconGapLargeLeft = '8px';
    BasicThemeClass.btnIconSizeSmall = '16px';
    BasicThemeClass.btnIconSizeMedium = '20px';
    BasicThemeClass.btnIconSizeLarge = '24px';
    BasicThemeClass.btnDefaultBg = '#fff';
    BasicThemeClass.btnDefaultBgStart = 'none';
    BasicThemeClass.btnDefaultBgEnd = 'none';
    BasicThemeClass.btnDefaultHoverBg = '#F0F0F0';
    BasicThemeClass.btnDefaultHoverBgStart = 'none';
    BasicThemeClass.btnDefaultHoverBgEnd = 'none';
    BasicThemeClass.btnDefaultActiveBg = '#E6E6E6';
    BasicThemeClass.btnDefaultHoverTextColor = '';
    BasicThemeClass.btnDefaultBorderColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.btnDefaultActiveShadow = 'none';
    BasicThemeClass.btnSuccessBg = '#26AD50';
    BasicThemeClass.btnSuccessBorderColor = '#26AD50';
    BasicThemeClass.btnSuccessHoverBg = '#23A14A';
    BasicThemeClass.btnSuccessHoverBorderColor = '#23A14A';
    BasicThemeClass.btnSuccessHoverTextColor = '';
    BasicThemeClass.btnSuccessBgStart = 'none';
    BasicThemeClass.btnSuccessBgEnd = 'none';
    BasicThemeClass.btnSuccessTextColor = '#fff';
    BasicThemeClass.btnSuccessHoverBgStart = 'none';
    BasicThemeClass.btnSuccessHoverBgEnd = 'none';
    BasicThemeClass.btnSuccessActiveBg = '#209644';
    BasicThemeClass.btnSuccessActiveBorderColor = '#209644';
    BasicThemeClass.btnSuccessActiveShadow = 'none';
    BasicThemeClass.btnPrimaryBg = '#3D3D3D';
    BasicThemeClass.btnPrimaryHoverBg = '#292929';
    BasicThemeClass.btnPrimaryActiveBg = '#141414';
    BasicThemeClass.btnPrimaryHoverTextColor = '';
    BasicThemeClass.btnPrimaryBorderColor = '#3D3D3D';
    BasicThemeClass.btnPrimaryHoverBorderColor = '#292929';
    BasicThemeClass.btnPrimaryActiveBorderColor = '#141414';
    BasicThemeClass.btnPrimaryBgStart = 'none';
    BasicThemeClass.btnPrimaryBgEnd = 'none';
    BasicThemeClass.btnPrimaryTextColor = '#fff';
    BasicThemeClass.btnPrimaryHoverBgStart = 'none';
    BasicThemeClass.btnPrimaryHoverBgEnd = 'none';
    BasicThemeClass.btnPrimaryActiveShadow = 'none';
    BasicThemeClass.btnDangerHoverBg = '#ED3F3F';
    BasicThemeClass.btnDangerHoverBorderColor = '#ED3F3F';
    BasicThemeClass.btnDangerHoverTextColor = '';
    BasicThemeClass.btnDangerBgStart = 'none';
    BasicThemeClass.btnDangerBgEnd = 'none';
    BasicThemeClass.btnDangerTextColor = '#fff';
    BasicThemeClass.btnDangerHoverBgStart = 'none';
    BasicThemeClass.btnDangerHoverBgEnd = 'none';
    BasicThemeClass.btnDangerActiveBg = '#DD3333';
    BasicThemeClass.btnDangerActiveShadow = 'none';
    BasicThemeClass.btnPayBg = '#fcb73e';
    BasicThemeClass.btnPayHoverBg = '#fda70c';
    BasicThemeClass.btnPayHoverBorderColor = '#fda70c';
    BasicThemeClass.btnPayHoverTextColor = '';
    BasicThemeClass.btnPayBorderColor = '#fcb73e';
    BasicThemeClass.btnPayBgStart = 'none';
    BasicThemeClass.btnPayBgEnd = 'none';
    BasicThemeClass.btnPayHoverBgStart = 'none';
    BasicThemeClass.btnPayHoverBgEnd = 'none';
    BasicThemeClass.btnPayActiveBg = '#f69912';
    BasicThemeClass.btnPayActiveBorderColor = '#f69912';
    BasicThemeClass.btnPayActiveShadow = 'none';
    BasicThemeClass.btnMenuArrowColor = '#a6a6a6';
    BasicThemeClass.btnDisabledBg = 'rgba(0, 0, 0, 0.06)';
    BasicThemeClass.btnInsetColor = '#fff';
    BasicThemeClass.btnBacklessBg = 'transparent';
    BasicThemeClass.btnBacklessHoverBg = 'rgba(0, 0, 0, 0.06)';
    BasicThemeClass.btnBacklessActiveBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.btnBacklessHoverTextColor = '';
    BasicThemeClass.btnTextBg = 'transparent';
    BasicThemeClass.btnTextHoverBg = 'rgba(0, 0, 0, 0.06)';
    BasicThemeClass.btnTextActiveBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.btnTextHoverTextColor = '';
    BasicThemeClass.btnWithIconPaddingSmall = '8px';
    BasicThemeClass.btnWithIconPaddingMedium = '10px';
    BasicThemeClass.btnWithIconPaddingLarge = '12px';
    BasicThemeClass.btnIconColor = '';
    BasicThemeClass.btnIconHoverColor = '';
    BasicThemeClass.btnIconDisabledColor = '';
    BasicThemeClass.selectPlaceholderColor = '#adadad';
    BasicThemeClass.selectPaddingXSmall = '7px';
    BasicThemeClass.selectPaddingXMedium = '11px';
    BasicThemeClass.selectPaddingXLarge = '15px';
    BasicThemeClass.selectRootWidthMobile = 'auto';
    BasicThemeClass.mobileSelectMaxWidth = '100%';
    BasicThemeClass.selectBorderColorTransition = "box-shadow ".concat(_a.transitionDuration, " ").concat(_a.transitionTimingFunction, ";");
    //#endregion Select
    //#region Tooltip
    /** @deprecated Эта переменная устарела при появлении размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipPaddingYSmall `tooltipPaddingYSmall`} */
    BasicThemeClass.tooltipPaddingY = '16px';
    /** @deprecated Эта переменная устарела при появлении размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipPaddingXSmall `tooltipPaddingXSmall`} */
    BasicThemeClass.tooltipPaddingX = '16px';
    BasicThemeClass.tooltipPaddingYSmall = '16px';
    BasicThemeClass.tooltipPaddingXSmall = '16px';
    BasicThemeClass.tooltipPaddingYMedium = '20px';
    BasicThemeClass.tooltipPaddingXMedium = '20px';
    BasicThemeClass.tooltipPaddingYLarge = '24px';
    BasicThemeClass.tooltipPaddingXLarge = '24px';
    /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipCloseBtnPaddingSmall `tooltipCloseBtnPaddingSmall`} */
    BasicThemeClass.tooltipCloseBtnPadding = '4px';
    BasicThemeClass.tooltipCloseBtnPaddingSmall = '4px';
    BasicThemeClass.tooltipCloseBtnPaddingMedium = '6px';
    BasicThemeClass.tooltipCloseBtnPaddingLarge = '8px';
    BasicThemeClass.tooltipCloseBtnSide = '16px';
    BasicThemeClass.tooltipCloseBtnHoverColor = 'rgba(0, 0, 0, 0.5)';
    BasicThemeClass.tooltipBg = '#fff';
    /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipBorderRadiusSmall `tooltipBorderRadiusSmall`} */
    BasicThemeClass.tooltipBorderRadius = '8px';
    BasicThemeClass.tooltipBorderRadiusSmall = '8px';
    BasicThemeClass.tooltipBorderRadiusMedium = '10px';
    BasicThemeClass.tooltipBorderRadiusLarge = '12px';
    /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipPinOffsetYSmall `tooltipPinOffsetYSmall`} */
    BasicThemeClass.tooltipPinOffsetY = '18px';
    BasicThemeClass.tooltipPinOffsetYSmall = '18px';
    BasicThemeClass.tooltipPinOffsetYMedium = '21px';
    BasicThemeClass.tooltipPinOffsetYLarge = '24px';
    /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipPinOffsetXSmall `tooltipPinOffsetXSmall` */
    BasicThemeClass.tooltipPinOffsetX = '16px';
    BasicThemeClass.tooltipPinOffsetXSmall = '16px';
    BasicThemeClass.tooltipPinOffsetXMedium = '20px';
    BasicThemeClass.tooltipPinOffsetXLarge = '24px';
    /** @deprecated Переменная устарела с появлением размеров у `Tooltip` и будет удалена в `6.0`.
     * @see {@link tooltipMarginSmall `tooltipMarginSmall`} */
    BasicThemeClass.tooltipMargin = '10px';
    BasicThemeClass.tooltipMarginSmall = '10px';
    BasicThemeClass.tooltipMarginMedium = '12px';
    BasicThemeClass.tooltipMarginLarge = '14px';
    BasicThemeClass.tooltipPinSizeSmall = '8px';
    BasicThemeClass.tooltipPinSizeMedium = '10px';
    BasicThemeClass.tooltipPinSizeLarge = '12px';
    //#endregion
    //#region Kebab
    BasicThemeClass.kebabMargin = '4px';
    BasicThemeClass.kebabBackground = 'transparent';
    BasicThemeClass.kebabBackgroundHover = 'rgba(0, 0, 0, 0.06)';
    BasicThemeClass.kebabBackgroundActive = 'rgba(0, 0, 0, 0.10)';
    BasicThemeClass.kebabBorderRadius = '50%';
    BasicThemeClass.kebabBorder = '2px solid transparent';
    BasicThemeClass.kebabSizeSmall = '24px';
    BasicThemeClass.kebabSizeMedium = '32px';
    BasicThemeClass.kebabSizeLarge = '40px';
    BasicThemeClass.kebabIconSizeSmall = '16px';
    BasicThemeClass.kebabIconSizeMedium = '20px';
    BasicThemeClass.kebabIconSizeLarge = '24px';
    BasicThemeClass.kebabIconColor = '#757575';
    //#endregion
    //#region Modal
    BasicThemeClass.modalWindowShadow = '0px 16px 32px 0px rgba(0, 0, 0, 0.06)';
    BasicThemeClass.modalBackBg = '#000';
    BasicThemeClass.modalBackOpacity = '0.16';
    BasicThemeClass.modalCloseButtonDisabledColor = '#8b8b8b';
    BasicThemeClass.modalCloseButtonHoverColor = 'rgba(0, 0, 0, 0.865)';
    BasicThemeClass.modalCloseButtonPadding = '32px';
    BasicThemeClass.modalCloseButtonBottomPadding = '20px';
    /** @deprecated use modalCloseButtonClickArea[Top/Bottom/Left/Right] instead */
    BasicThemeClass.modalCloseButtonClickArea = '6px';
    BasicThemeClass.modalCloseButtonClickAreaTop = '6px';
    BasicThemeClass.modalCloseButtonClickAreaBottom = '6px';
    BasicThemeClass.modalCloseButtonClickAreaLeft = '6px';
    BasicThemeClass.modalCloseButtonClickAreaRight = '6px';
    BasicThemeClass.modalCloseIconSize = '20px';
    BasicThemeClass.modalBorderRadius = '16px';
    BasicThemeClass.modalFixedHeaderBorder = 'none';
    BasicThemeClass.modalFixedFooterBorder = 'none';
    BasicThemeClass.modalFixedPanelShadow = 'none';
    BasicThemeClass.modalAdaptiveThreshold = '425px';
    BasicThemeClass.modalPaddingTop = '24px';
    BasicThemeClass.modalPaddingLeft = '32px';
    BasicThemeClass.modalPaddingRight = '32px';
    BasicThemeClass.modalHeaderFontSize = '24px';
    BasicThemeClass.modalHeaderFontWeight = '700';
    BasicThemeClass.modalHeaderLineHeight = '32px';
    BasicThemeClass.modalHeaderPaddingBottom = '16px';
    BasicThemeClass.modalHeaderPaddingTop = '24px';
    BasicThemeClass.modalFixedHeaderMarginBottom = '0px';
    BasicThemeClass.modalFixedFooterMarginTop = '0px';
    BasicThemeClass.modalSeparatorBorderBottom = '1px solid #E6E6E6';
    BasicThemeClass.modalSeparatorMargin = '0 32px';
    BasicThemeClass.modalSeparatorFixedMargin = '0 16px';
    BasicThemeClass.modalBodyTextColor = 'inherit';
    BasicThemeClass.modalFooterTextColor = 'inherit';
    BasicThemeClass.modalBodyPaddingTop = '0';
    BasicThemeClass.modalBodyPaddingBottom = '20px';
    BasicThemeClass.modalBodyBorderRadius = '0px';
    BasicThemeClass.modalFooterPaddingTop = '0px';
    BasicThemeClass.modalFooterPaddingBottom = '20px';
    BasicThemeClass.modalPaddingBottom = '40px';
    BasicThemeClass.modalFooterPanelPaddingTop = '20px';
    BasicThemeClass.mobileModalCloseButtonRightPadding = '16px';
    BasicThemeClass.mobileModalCloseButtonTopPadding = '8px';
    BasicThemeClass.mobileModalCloseButtonClickArea = '16px';
    BasicThemeClass.mobileModalWithoutHeaderCloseButtonPadding = '10px';
    BasicThemeClass.mobileModalCloseIconSize = '20px';
    BasicThemeClass.mobileModalHeaderFontSize = '24px';
    BasicThemeClass.mobileModalHeaderLineHeight = '32px';
    BasicThemeClass.mobileModalHeaderPadding = '16px';
    BasicThemeClass.mobileModalBodyPadding = '0 16px 16px 16px';
    BasicThemeClass.mobileModalBodyPaddingTop = '16px';
    BasicThemeClass.mobileModalBodyPaddingBottom = '16px';
    BasicThemeClass.mobileModalBodyFontSize = '16px';
    BasicThemeClass.mobileModalFooterPadding = '16px';
    BasicThemeClass.mobileModalPaddingBottom = '16px';
    BasicThemeClass.mobileModalContainerHeight = '100%';
    BasicThemeClass.mobileModalContainerMarginTop = '0';
    BasicThemeClass.mobileModalContainerMarginRight = '0';
    BasicThemeClass.mobileModalContainerMarginBottom = '0';
    BasicThemeClass.mobileModalContainerMarginLeft = '0';
    BasicThemeClass.sidePageBackingBg = '#000';
    BasicThemeClass.sidePageBackingBgOpacity = '0.16';
    BasicThemeClass.sidePageCloseButtonColor = 'rgba(0, 0, 0, 0.374)';
    BasicThemeClass.sidePageCloseButtonHoverColor = 'rgba(0, 0, 0, 0.5)';
    BasicThemeClass.sidePageContainerShadow = '0 5px 10px rgba(0, 0, 0, 0.2)';
    BasicThemeClass.mobileSidePagePaddingLeft = '16px';
    BasicThemeClass.mobileSidePagePaddingRight = '16px';
    BasicThemeClass.mobileSidePagePaddingTop = '16px';
    BasicThemeClass.mobileSidePagePaddingBottom = '16px';
    BasicThemeClass.mobileSidePageFooterPadding = '16px';
    BasicThemeClass.sidePagePaddingLeft = '32px';
    BasicThemeClass.sidePagePaddingRight = '36px';
    BasicThemeClass.sidePagePaddingTop = '24px';
    BasicThemeClass.sidePagePaddingBottom = '40px';
    BasicThemeClass.sidePageFooterPaddingTop = '20px';
    BasicThemeClass.sidePageFooterPaddingBottom = '20px';
    BasicThemeClass.sidePageBgDefault = '#fff';
    BasicThemeClass.sidePageBodyTextColor = 'inherit';
    BasicThemeClass.sidePageFooterTextColor = 'inherit';
    BasicThemeClass.sidePageHeaderFontSize = '24px';
    BasicThemeClass.sidePageHeaderLineHeight = '32px';
    BasicThemeClass.sidePageHeaderPaddingBottom = '16px';
    BasicThemeClass.sidePageHeaderPaddingTop = '24px';
    BasicThemeClass.sidePageHeaderFixedFontSize = '18px';
    BasicThemeClass.sidePageHeaderFixedLineHeight = '28px';
    BasicThemeClass.sidePageHeaderFixedPaddingY = '10px';
    BasicThemeClass.sidePageHeaderStickyOffset = '9px';
    /** @deprecated use sidePageCloseButtonClickAreaLeft and sidePageCloseButtonClickAreaRight instead */
    BasicThemeClass.sidePageCloseButtonPadding = '32px';
    BasicThemeClass.mobileSidePageCloseButtonPadding = '16px';
    BasicThemeClass.sidePageCloseIconSize = '20px';
    /** @deprecated use sidePageCloseButtonClickArea[Top/Bottom/Left/Right] instead */
    BasicThemeClass.sidePageCloseButtonClickArea = '6px';
    BasicThemeClass.sidePageCloseButtonClickAreaTop = '6px';
    BasicThemeClass.sidePageCloseButtonClickAreaBottom = '6px';
    BasicThemeClass.sidePageCloseButtonClickAreaLeft = '6px';
    BasicThemeClass.sidePageCloseButtonClickAreaRight = '6px';
    BasicThemeClass.sidePageCloseButtonFixedClickAreaBottom = '14px';
    BasicThemeClass.mobileSidePageCloseButtonClickArea = '16px';
    BasicThemeClass.sidePageFixedPanelShadow = 'none';
    BasicThemeClass.mobileSidePageHeaderFontSize = '24px';
    BasicThemeClass.mobileSidePageHeaderLineHeight = '32px';
    BasicThemeClass.mobileSidePageHeaderPaddingBottom = '16px';
    BasicThemeClass.mobileSidePageHeaderPaddingTop = '16px';
    /** @deprecated use mobileSidePageCloseButtonPadding instead */
    BasicThemeClass.mobileSidePageCloseButtonRightPadding = '12px';
    BasicThemeClass.sidePageHeaderFontWeight = 'bold';
    BasicThemeClass.sidePageCloseButtonWrapperOffsetTop = '4px';
    BasicThemeClass.sidePageCloseButtonWrapperFixedOffsetTop = '4px';
    BasicThemeClass.dateInputMaskColor = '#b8b8b8';
    BasicThemeClass.dateInputComponentSelectedBgColor = '';
    BasicThemeClass.dateInputComponentSelectedTextColor = '';
    BasicThemeClass.calendarBorderRadius = '8px';
    BasicThemeClass.calendarCellHoverColor = '';
    BasicThemeClass.calendarCellActiveHoverColor = '';
    BasicThemeClass.calendarCellTodayBorder = '1px solid';
    BasicThemeClass.calendarCellBorderRadius = '9999px';
    BasicThemeClass.calendarCellSelectedBgColor = '#E6E6E6';
    BasicThemeClass.calendarCellSelectedFontColor = 'inherit';
    BasicThemeClass.calendarCellHeight = '32px';
    BasicThemeClass.calendarCellFontSize = '14px';
    BasicThemeClass.calendarMonthTitleBorderBottomColor = '#dfdede';
    BasicThemeClass.calendarCellHoverBgColor = '#F0F0F0';
    BasicThemeClass.calendarPaddingX = '18px';
    BasicThemeClass.calendarMonthTitleLineHeight = '20px';
    BasicThemeClass.calendarMonthTitlePaddingTop = '12px';
    BasicThemeClass.calendarMonthTitlePaddingBottom = '8px';
    BasicThemeClass.calendarMonthTitleMarginX = '6px';
    BasicThemeClass.calendarMonthTitleMarginBottom = '6px';
    BasicThemeClass.calendarWrapperHeight = ' 330px';
    BasicThemeClass.calendarMonthMarginBottom = '6px';
    BasicThemeClass.calendarMaxMonthsToAppendOnScroll = '5';
    BasicThemeClass.calendarGridRowSpacing = '0px';
    BasicThemeClass.pickerShadow = '0px 32px 32px -16px rgba(0, 0, 0, 0.08), 0px 0px 24px 0px rgba(0, 0, 0, 0.12)';
    BasicThemeClass.mobileCalendarPaddingX = '16px';
    BasicThemeClass.mobileCalendarCellWidth = '40px';
    BasicThemeClass.mobileCalendarCellHeight = '40px';
    BasicThemeClass.mobileCalendarCellBorderRadius = '20px';
    BasicThemeClass.mobileCalendarCellFontSize = '16px';
    BasicThemeClass.mobileCalendarGridRowSpacing = '8px';
    BasicThemeClass.mobileCalendarWrapperHeight = '304px';
    //#endregion DatePicker
    //#region DateRangePicker
    BasicThemeClass.rangeCalendarCellBg = '#f0f0f0';
    BasicThemeClass.rangeCalendarCellEndBg = '#1e1e1e';
    BasicThemeClass.rangeCalendarCellEndColor = 'white';
    BasicThemeClass.rangeCalendarCellHoverBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.rangeCalendarWrapperHeight = '450px';
    BasicThemeClass.mobileRangeCalendarCellHeight = '42px';
    BasicThemeClass.mobileRangeCalendarCellWidth = '42px';
    BasicThemeClass.mobileRangeCalendarGridRowSpacing = '0px';
    BasicThemeClass.mobileRangeCalendarWrapperHeight = '400px';
    BasicThemeClass.dateSelectMenuItemBgActive = '#F0F0F0';
    BasicThemeClass.dateSelectMenuItemFontActive = '';
    BasicThemeClass.dateSelectLineHeight = '20px';
    BasicThemeClass.dateSelectFontSize = '14px';
    BasicThemeClass.dateSelectFontWeight = 'bold';
    BasicThemeClass.dateSelectMenuItemBgSelected = '#ececec';
    BasicThemeClass.dateSelectTextColorInvert = '';
    BasicThemeClass.mobileDateSelectFontSize = '16px';
    BasicThemeClass.mobileDateSelectLineHeight = '20px';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0`
     * @see {@link pagingLineHeightSmall `pagingLineHeightSmall`} */
    BasicThemeClass.pagingLineHeight = '22px';
    BasicThemeClass.pagingPageLinkBoxSizing = 'border-box';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
    BasicThemeClass.pagingPageLinkMinWidth = '0.75em';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0`
     * @see {@link pagingPageLinkPaddingYSmall `pagingPageLinkPaddingYSmall`} */
    BasicThemeClass.pagingPageLinkPaddingY = '0.3125em';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0`
     * @see {@link pagingPageLinkPaddingXSmall `pagingPageLinkPaddingXSmall`} */
    BasicThemeClass.pagingPageLinkPaddingX = '12px';
    BasicThemeClass.pagingPageLinkPaddingYSmall = '6px';
    BasicThemeClass.pagingPageLinkPaddingXSmall = '11.5px';
    BasicThemeClass.pagingPageLinkPaddingYMedium = '9px';
    BasicThemeClass.pagingPageLinkPaddingXMedium = '15px';
    BasicThemeClass.pagingPageLinkPaddingYLarge = '12px';
    BasicThemeClass.pagingPageLinkPaddingXLarge = '18.5px';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
    BasicThemeClass.pagingPageLinkMargin = '0px 1px';
    BasicThemeClass.pagingPageLinkBorderRadius = '9999px';
    BasicThemeClass.pagingPageLinkActiveBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.pagingPageLinkDisabledActiveBg = 'rgba(0, 0, 0, 0.04)';
    BasicThemeClass.pagingPageLinkHoverBg = 'rgba(0, 0, 0, 0.06)';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
    BasicThemeClass.pagingPageForwardLinkMarginTop = '';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0` */
    BasicThemeClass.pagingPageForwardLinkMarginLeft = '0px';
    BasicThemeClass.pagingForwardLinkPaddingSmall = '6px 8px 6px 12px';
    BasicThemeClass.pagingForwardLinkPaddingMedium = '9px 12px 9px 16px';
    BasicThemeClass.pagingForwardLinkPaddingLarge = '12px 16px 12px 20px';
    BasicThemeClass.pagingForwardLinkPaddingMediumMobile = '10px';
    BasicThemeClass.pagingForwardLinkPaddingLargeMobile = '12px';
    /** @deprecated Это переменная старого размера `Paging` и будет удалена в `6.0`
     * @see {@link pagingDotsPaddingSmall `pagingDotsPaddingSmall`} */
    BasicThemeClass.pagingDotsPadding = '0.375em 0.625em 0';
    BasicThemeClass.pagingDotsPaddingSmall = '11px 8px 5px 8px';
    BasicThemeClass.pagingDotsPaddingMedium = '14px 12px 10px 12px';
    BasicThemeClass.pagingDotsPaddingLarge = '19px 16px 13px 16px';
    BasicThemeClass.pagingDotsColor = '#ADADAD';
    BasicThemeClass.pagingPageLinkHintFontSize = '12px';
    BasicThemeClass.pagingPageLinkHintLineHeight = '16px';
    BasicThemeClass.pagingPageLinkHintMargin = '4px -20px 0px';
    BasicThemeClass.hintMaxWidth = '200px';
    BasicThemeClass.hintPaddingY = '4px';
    BasicThemeClass.hintPaddingX = '8px';
    BasicThemeClass.hintTextAlign = 'center';
    BasicThemeClass.hintBgColor = 'rgba(0, 0, 0, 0.76)';
    BasicThemeClass.hintBorder = 'none';
    BasicThemeClass.hintBorderRadius = '6px';
    BasicThemeClass.hintMargin = '8px';
    BasicThemeClass.toastPaddingY = '10px';
    BasicThemeClass.toastPaddingX = '16px';
    BasicThemeClass.toastBorderRadius = '8px';
    BasicThemeClass.toastBorder = 'none';
    BasicThemeClass.toastTop = '24px';
    BasicThemeClass.toastBg = 'rgba(0, 0, 0, 0.76)';
    BasicThemeClass.toastErrorBg = '#F63B3F';
    BasicThemeClass.toastColor = 'white';
    BasicThemeClass.toastColorError = '#fff';
    BasicThemeClass.toastLinkColor = '#fff';
    BasicThemeClass.toastLinkColorError = '#fff';
    BasicThemeClass.toastLinkTextDecorationHover = '';
    BasicThemeClass.toastLinkBgHover = 'rgba(255, 255, 255, 0.12)';
    BasicThemeClass.toastLinkBgHoverError = 'rgba(255, 255, 255, 0.08)';
    BasicThemeClass.toastLinkBgActive = 'rgba(0, 0, 0, 0.87)';
    BasicThemeClass.toastLinkBgActiveError = 'rgba(255, 255, 255, 0.04)';
    BasicThemeClass.toastLinkColorActiveError = 'rgba(255, 255, 255, 0.64)';
    BasicThemeClass.toastLinkPadding = '12px';
    BasicThemeClass.toastClosePadding = '16px';
    BasicThemeClass.toastCloseColor = 'rgba(255, 255, 255, 0.6)';
    BasicThemeClass.toastCloseColorError = 'rgba(255, 255, 255, 0.6)';
    BasicThemeClass.toastCloseHoverColor = 'white';
    BasicThemeClass.toastCloseHoverColorError = 'white';
    BasicThemeClass.toastCloseSize = '16px';
    //#endregion Toast
    //#region Dropdown
    BasicThemeClass.dropdownMenuBorderColorTransition = '';
    BasicThemeClass.dropdownMenuMenuBoxSizing = 'content-box';
    BasicThemeClass.dropdownButtonBorderRadiusSmall = '8px';
    BasicThemeClass.dropdownButtonBorderRadiusMedium = '8px';
    BasicThemeClass.dropdownButtonBorderRadiusLarge = '8px';
    BasicThemeClass.menuBorderRadius = '8px';
    BasicThemeClass.menuBorder = 'none';
    BasicThemeClass.menuShadow = '0px 32px 32px -16px rgba(0, 0, 0, 0.08), 0px 0px 24px 0px rgba(0, 0, 0, 0.12)';
    BasicThemeClass.menuPaddingY = '0px';
    BasicThemeClass.menuScrollContainerContentWrapperPaddingY = '4px';
    BasicThemeClass.mobileMenuPaddingY = '0px';
    BasicThemeClass.mobileMenuScrollContainerContentWrapperPaddingY = '0px';
    BasicThemeClass.menuPaddingX = '4px';
    BasicThemeClass.mobileMenuPaddingX = '8px';
    BasicThemeClass.menuOffsetY = '4px';
    BasicThemeClass.menuBoxSizing = 'border-box';
    BasicThemeClass.menuItemSelectedBg = '#E6E6E6';
    BasicThemeClass.menuItemHoverBg = '#F0F0F0';
    BasicThemeClass.menuItemIconWidthSmall = '16px';
    BasicThemeClass.menuItemIconWidthMedium = '20px';
    BasicThemeClass.menuItemIconWidthLarge = '24px';
    BasicThemeClass.menuItemIconGap = '4px';
    BasicThemeClass.menuItemPaddingXSmall = '8px';
    BasicThemeClass.menuItemPaddingYSmall = '6px';
    BasicThemeClass.menuItemPaddingXMedium = '12px';
    BasicThemeClass.menuItemPaddingYMedium = '9px';
    BasicThemeClass.menuItemPaddingXLarge = '16px';
    BasicThemeClass.menuItemPaddingYLarge = '12px';
    BasicThemeClass.menuItemBorderRadius = '6px';
    BasicThemeClass.menuItemCommentOpacity = '0.6';
    BasicThemeClass.menuItemCommentOpacityHover = '0.6';
    BasicThemeClass.menuItemDisplay = 'block';
    BasicThemeClass.menuItemPaddingMobile = '12px 16px';
    BasicThemeClass.menuItemDisabledBg = 'transparent';
    BasicThemeClass.menuItemGap = '1px';
    //menuHeader
    BasicThemeClass.menuHeaderColor = '#757575';
    BasicThemeClass.menuHeaderLineHeightSmall = '16px';
    BasicThemeClass.menuHeaderLineHeightMedium = '20px';
    BasicThemeClass.menuHeaderLineHeightLarge = '22px';
    BasicThemeClass.menuHeaderFontSizeSmall = '12px';
    BasicThemeClass.menuHeaderFontSizeMedium = '14px';
    BasicThemeClass.menuHeaderFontSizeLarge = '16px';
    BasicThemeClass.menuHeaderPaddingXSmall = '8px';
    BasicThemeClass.menuHeaderPaddingTopSmall = '12px';
    BasicThemeClass.menuHeaderPaddingBottomSmall = '4px';
    BasicThemeClass.menuHeaderPaddingXMedium = '12px';
    BasicThemeClass.menuHeaderPaddingTopMedium = '14px';
    BasicThemeClass.menuHeaderPaddingBottomMedium = '6px';
    BasicThemeClass.menuHeaderPaddingXLarge = '16px';
    BasicThemeClass.menuHeaderPaddingTopLarge = '18px';
    BasicThemeClass.menuHeaderPaddingBottomLarge = '8px';
    BasicThemeClass.menuHeaderTotalCountPaddingTopSmall = '4px';
    BasicThemeClass.menuHeaderTotalCountPaddingTopMedium = '6px';
    BasicThemeClass.menuHeaderTotalCountPaddingTopLarge = '8px';
    BasicThemeClass.menuHeaderTotalCountPaddingBottomSmall = '12px';
    BasicThemeClass.menuHeaderTotalCountPaddingBottomMedium = '14px';
    BasicThemeClass.menuHeaderTotalCountPaddingBottomLarge = '18px';
    //menuSeparator
    BasicThemeClass.menuSeparatorBorderColor = '#ebebeb';
    BasicThemeClass.menuSeparatorMarginY = '2px';
    BasicThemeClass.menuSeparatorMarginX = '8px';
    BasicThemeClass.menuSeparatorBorderWidth = '1px';
    // mobileMenuSeparator
    BasicThemeClass.mobileMenuSeparatorMarginY = '4px';
    BasicThemeClass.mobileMenuSeparatorMarginX = '24px';
    BasicThemeClass.toggleHandleActiveWidthIncrement = '0px';
    BasicThemeClass.toggleHeightSmall = '20px';
    BasicThemeClass.toggleWidthSmall = '32px';
    BasicThemeClass.toggleHeightMedium = '22px';
    BasicThemeClass.toggleWidthMedium = '34px';
    BasicThemeClass.toggleHeightLarge = '24px';
    BasicThemeClass.toggleWidthLarge = '36px';
    BasicThemeClass.toggleBaseBg = '#fff';
    BasicThemeClass.toggleBgHover = '#F0F0F0';
    BasicThemeClass.toggleBorderColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.toggleHandleSizeSmall = '14px';
    BasicThemeClass.toggleHandleSizeMedium = '16px';
    BasicThemeClass.toggleHandleSizeLarge = '18px';
    BasicThemeClass.toggleHandleLeft = '3px';
    BasicThemeClass.toggleHandleTop = '3px';
    BasicThemeClass.toggleBgFocus = 'linear-gradient(-180deg, #f1f1f1, #dedede)';
    BasicThemeClass.toggleCaptionGap = '8px';
    BasicThemeClass.toggleButtonOffsetY = '0px';
    BasicThemeClass.toggleContainerBg = '#FFFFFF';
    BasicThemeClass.toggleHandleBg = '#FFFFFF';
    BasicThemeClass.toggleHandleBoxShadow = '0 0 0 1px rgba(0, 0, 0, 0.16)';
    BasicThemeClass.toggleContainerBoxShadow = 'inset 0 0 0 1px rgba(0, 0, 0, 0.16)';
    // idle :hover
    BasicThemeClass.toggleContainerBoxShadowHover = 'inset 0 0 0 1px rgba(0, 0, 0, 0.16)';
    BasicThemeClass.toggleHandleBgHover = '#FFFFFF';
    BasicThemeClass.toggleHandleBoxShadowHover = '0 0 0 1px rgba(0, 0, 0, 0.16)';
    // checked
    BasicThemeClass.toggleContainerBoxShadowChecked = 'none';
    BasicThemeClass.toggleHandleBoxShadowChecked = 'none';
    BasicThemeClass.toggleHandleBgChecked = '#FFFFFF';
    BasicThemeClass.toggleBgChecked = '#3D3D3D';
    BasicThemeClass.toggleCheckedBg = '#fff';
    BasicThemeClass.toggleCheckedBgHover = '#fff';
    // checked :hover
    BasicThemeClass.toggleContainerBoxShadowCheckedHover = 'none';
    BasicThemeClass.toggleContainerBgCheckedHover = '#292929';
    BasicThemeClass.toggleHandleBoxShadowCheckedHover = 'none';
    BasicThemeClass.toggleHandleBgCheckedHover = '#F0F0F0';
    // disabled
    BasicThemeClass.toggleContainerBgDisabled = '#F0F0F0';
    BasicThemeClass.toggleHandleBgDisabled = 'transparent';
    BasicThemeClass.toggleContainerBoxShadowDisabled = 'inset 0 0 0 1px rgba(0, 0, 0, 0.1)';
    BasicThemeClass.toggleHandleBoxShadowDisabled = '0 0 0 1px rgba(0, 0, 0, 0.1)';
    BasicThemeClass.toggleDisabledHandleBg = '#fff';
    // disabled checked
    BasicThemeClass.toggleContainerBgDisabledChecked = '#D6D6D6';
    BasicThemeClass.toggleHandleBgDisabledChecked = '#F0F0F0';
    BasicThemeClass.toggleContainerBoxShadowDisabledChecked = 'none';
    BasicThemeClass.toggleHandleBoxShadowDisabledChecked = 'none';
    BasicThemeClass.toggleBgDisabledChecked = '#dadada';
    //#endregion Toggle
    //#region Popup
    BasicThemeClass.popupBorder = 'none';
    BasicThemeClass.popupBorderRadius = '8px';
    BasicThemeClass.popupBorderColor = 'transparent';
    BasicThemeClass.popupDropShadow = 'drop-shadow(0px 32px 32px rgba(0, 0, 0, 0.08)) drop-shadow(0px 0px 24px rgba(0, 0, 0, 0.12))';
    BasicThemeClass.popupBoxShadow = '0px 32px 32px -16px rgba(0, 0, 0, 0.08), 0px 0px 24px 0px rgba(0, 0, 0, 0.12)';
    BasicThemeClass.popupPinOffsetX = '16px';
    BasicThemeClass.popupPinOffsetY = '16px';
    BasicThemeClass.popupMargin = '10px';
    BasicThemeClass.popupPinSize = '8px';
    BasicThemeClass.popupMenuMenuOffsetY = '0px';
    BasicThemeClass.inputShadow = 'none';
    BasicThemeClass.inputBg = 'white';
    BasicThemeClass.inputIconColor = '#858585';
    BasicThemeClass.inputColor = 'inherit';
    BasicThemeClass.inputWidth = '200px';
    BasicThemeClass.inputPaddingXSmall = '7px';
    BasicThemeClass.inputPaddingXMedium = '11px';
    BasicThemeClass.inputPaddingXLarge = '15px';
    BasicThemeClass.inputIconGapSmall = '4px';
    BasicThemeClass.inputIconGapMedium = '6px';
    BasicThemeClass.inputIconGapLarge = '8px';
    BasicThemeClass.inputIconSizeSmall = '16px';
    BasicThemeClass.inputIconSizeMedium = '20px';
    BasicThemeClass.inputIconSizeLarge = '24px';
    BasicThemeClass.inputBackgroundClip = 'padding-box';
    BasicThemeClass.inputBorderRadiusSmall = '2px';
    BasicThemeClass.inputBorderRadiusMedium = '2px';
    BasicThemeClass.inputBorderRadiusLarge = '2px';
    BasicThemeClass.inputDisabledBackgroundClip = 'padding-box';
    BasicThemeClass.inputBorderColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.inputBlinkColor = 'rgba(61, 61, 61, 0.2)';
    BasicThemeClass.inputColorScheme = 'light';
    BasicThemeClass.checkboxBoxSizeSmall = '16px';
    BasicThemeClass.checkboxBoxSizeMedium = '20px';
    BasicThemeClass.checkboxBoxSizeLarge = '24px';
    BasicThemeClass.checkboxCaptionGap = '8px';
    BasicThemeClass.checkboxPaddingXSmall = '0';
    BasicThemeClass.checkboxPaddingXMedium = '0';
    BasicThemeClass.checkboxPaddingXLarge = '0';
    BasicThemeClass.checkboxBoxOffsetY = '1px';
    BasicThemeClass.checkboxBgStart = '#fdfdfd';
    BasicThemeClass.checkboxBgEnd = '#ededed';
    BasicThemeClass.checkboxBorder = 'none';
    BasicThemeClass.checkboxCheckedColor = '#fff';
    BasicThemeClass.checkboxBorderRadius = '4px';
    BasicThemeClass.checkboxBg = '#fff';
    BasicThemeClass.checkboxCheckedHoverBg = '#292929';
    //#endregion Checkbox
    //#region TextArea
    BasicThemeClass.textareaBg = '#fff';
    BasicThemeClass.textareaShadow = 'none';
    BasicThemeClass.textareaBackgroundClip = 'padding-box';
    BasicThemeClass.textareaBorderRadius = '2px';
    BasicThemeClass.textareaWidth = '250px';
    BasicThemeClass.textareaPaddingXSmall = '7px';
    BasicThemeClass.textareaPaddingXMedium = '11px';
    BasicThemeClass.textareaPaddingXLarge = '15px';
    BasicThemeClass.textareaBorderTopColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.textareaMargin = '';
    BasicThemeClass.textareaVerticalAlign = 'middle';
    //#endregion Textarea
    //#region Radio
    BasicThemeClass.radioBulletSizeSmall = '6px';
    BasicThemeClass.radioBulletSizeMedium = '10px';
    BasicThemeClass.radioBulletSizeLarge = '12px';
    BasicThemeClass.radioSizeSmall = '16px';
    BasicThemeClass.radioSizeMedium = '20px';
    BasicThemeClass.radioSizeLarge = '24px';
    BasicThemeClass.radioCaptionGap = '8px';
    BasicThemeClass.radioVerticalAlign = 'top';
    BasicThemeClass.radioBgImage = 'none';
    BasicThemeClass.radioBgColor = '#fff';
    BasicThemeClass.radioBoxShadow = 'none';
    BasicThemeClass.radioHoverShadow = 'none';
    BasicThemeClass.radioActiveShadow = 'none';
    BasicThemeClass.radioCheckedBorderColor = 'transparent';
    BasicThemeClass.radioCheckedBulletColor = '#fff';
    BasicThemeClass.radioDisabledBg = '#F0F0F0';
    BasicThemeClass.radioCaptionDisplay = 'inline-flex';
    BasicThemeClass.radioBorderWidthCompensation = '0px';
    BasicThemeClass.radioCircleOffsetY = '1px';
    BasicThemeClass.tabPaddingXSmall = '8px';
    BasicThemeClass.tabPaddingXMedium = '10px';
    BasicThemeClass.tabPaddingXLarge = '12px';
    BasicThemeClass.tabBorderWidth = '2px';
    BasicThemeClass.tabColorHover = '#D6D6D6';
    BasicThemeClass.tabIndicatorBorderRadius = '2px';
    BasicThemeClass.spinnerCaptionGapSmall = '6px';
    BasicThemeClass.spinnerCaptionGapMedium = '-4px';
    BasicThemeClass.spinnerCaptionGapLarge = '-3px';
    BasicThemeClass.spinnerCaptionMarginSmall = '0 0 0 6px';
    BasicThemeClass.spinnerCaptionMarginMedium = '0 0 0 6px';
    BasicThemeClass.spinnerCaptionMarginLarge = '0 0 0 6px';
    //#endregion
    //#region Switcher
    BasicThemeClass.switcherBorderRadius = '8px';
    BasicThemeClass.switcherButtonPaddingXSmall = '7px';
    BasicThemeClass.switcherButtonPaddingXMedium = '11px';
    BasicThemeClass.switcherButtonPaddingXLarge = '15px';
    BasicThemeClass.switcherBtnDisabledBorderColor = 'rgba(0, 0, 0, 0.16)';
    //#endregion
    //#region MobilePopup
    BasicThemeClass.mobilePopupTopPadding = '80px';
    BasicThemeClass.mobilePopupContainerBottomPadding = '8px';
    BasicThemeClass.mobilePopupHeaderPadding = '16px 16px 8px 16px';
    BasicThemeClass.mobilePopupFooterPadding = '16px 16px 16px 16px';
    BasicThemeClass.mobilePopupContainerBorderRadius = '16px';
    BasicThemeClass.mobilePopupHeaderFontWeight = '500';
    BasicThemeClass.mobilePopupHeaderChildPadding = '12px';
    BasicThemeClass.mobilePopupOuterIndentY = '24px';
    //#endregion
    //#region ScrollContainer
    BasicThemeClass.scrollContainerScrollBarSize = '4px';
    BasicThemeClass.scrollContainerScrollBarHoverSize = '10px';
    BasicThemeClass.scrollContainerScrollBarColor = 'rgba(183, 183, 183, 0.7)';
    BasicThemeClass.scrollContainerScrollBarInvertColor = 'rgba(255, 255, 255, 0.5)';
    BasicThemeClass.scrollContainerScrollBarOffsetY = '4px';
    BasicThemeClass.dropdownMenuScrollContainerScrollBarOffsetY = '0px';
    //#endregion
    //#region PasswordInput
    BasicThemeClass.passwordInputVisibilityIconColor = '#000';
    BasicThemeClass.passwordInputVisibilityIconOpacity = '0.6';
    BasicThemeClass.passwordInputVisibilityIconHoverColor = '#000';
    BasicThemeClass.passwordInputVisibilityIconHoverOpacity = '1';
    BasicThemeClass.globalLoaderHeight = '4px';
    BasicThemeClass.globalLoaderWidth = '100%';
    BasicThemeClass.globalLoaderPosition = 'fixed';
    BasicThemeClass.globalLoaderTop = '0px';
    BasicThemeClass.globalLoaderLeft = '0px';
    BasicThemeClass.globalLoaderBottom = 'auto';
    BasicThemeClass.globalLoaderRight = 'auto';
    BasicThemeClass.globalLoaderBackgroundColor = 'transparent';
    BasicThemeClass.globalLoaderTransitionToSpinnerDuration = '500'; //ms
    BasicThemeClass.globalLoaderSpinnerAnimationDuration = '2000'; //ms
    BasicThemeClass.globalLoaderSlowAnimationDuration = '20000'; //ms
    BasicThemeClass.globalLoaderTransitionFromSpinnerDuration = '200'; //ms
    //#endregion
    //#region FileUploader
    BasicThemeClass.fileUploaderWidth = '362px';
    BasicThemeClass.fileUploaderTileWidth = 'auto';
    BasicThemeClass.fileUploaderBg = '';
    BasicThemeClass.fileUploaderUploadButtonBg = '#fff';
    BasicThemeClass.fileUploaderTilePaddingSmall = '3px';
    BasicThemeClass.fileUploaderTilePaddingMedium = '5px';
    BasicThemeClass.fileUploaderTilePaddingLarge = '7px';
    BasicThemeClass.fileUploaderTileFilePaddingSmall = '7px';
    BasicThemeClass.fileUploaderTileFilePaddingMedium = '11px';
    BasicThemeClass.fileUploaderTileFilePaddingLarge = '15px';
    BasicThemeClass.fileUploaderTileIconActionPaddingSmall = '8px';
    BasicThemeClass.fileUploaderTileIconActionPaddingMedium = '6px';
    BasicThemeClass.fileUploaderTileIconActionPaddingLarge = '8px';
    BasicThemeClass.fileUploaderBorderRadius = '8px';
    BasicThemeClass.fileUploaderBorderColor = 'rgba(0, 0, 0, 0.37)';
    BasicThemeClass.fileUploaderBorderStyle = 'dashed';
    BasicThemeClass.fileUploaderAfterLinkColor = '#858585';
    BasicThemeClass.fileUploaderIconSize = '14px';
    BasicThemeClass.fileUploaderIconColor = '#222222';
    BasicThemeClass.fileUploaderIconHoverColor = '#333';
    BasicThemeClass.fileUploaderTileIconColorBg = 'rgba(0, 0, 0, 0.4)';
    BasicThemeClass.fileUploaderTileIconHoverColorBg = 'rgba(0, 0, 0, 0.48)';
    BasicThemeClass.fileUploaderTileIconActiveColorBg = 'rgba(0, 0, 0, 0.24)';
    BasicThemeClass.fileUploaderTileIconColor = '#ffffff';
    BasicThemeClass.fileUploaderTileIconHoverColor = '#ffffff';
    BasicThemeClass.fileUploaderDisabledBgClip = 'padding-box';
    BasicThemeClass.fileUploaderDisabledBorderColor = 'rgba(0, 0, 0, 0.16)';
    BasicThemeClass.fileUploaderErrorBgColor = '#FFECEF';
    BasicThemeClass.fileUploaderErrorBgHoverColor = '#FFDADD';
    BasicThemeClass.fileUploaderWarningBgColor = '#FFF1CA';
    BasicThemeClass.fileUploaderWarningBgHoverColor = '#FAE2AB';
    BasicThemeClass.fileUploaderValidationTextColor = 'rgba(0, 0, 0, 0.87)';
    BasicThemeClass.fileUploaderLinkHoverTextDecoration = 'none';
    BasicThemeClass.fileUploaderHoveredBg = 'rgba(0, 0, 0, 0.06)';
    BasicThemeClass.fileUploaderActiveBg = 'rgba(0, 0, 0, 0.1)';
    BasicThemeClass.fileUploaderHoveredBorderColor = 'transparent';
    BasicThemeClass.fileUploaderIconGapSmall = '4px';
    BasicThemeClass.fileUploaderIconGapMedium = '6px';
    BasicThemeClass.fileUploaderIconGapLarge = '8px';
    BasicThemeClass.fileUploaderDragOverShadow = '0px 0px 0px 3px rgb(149, 149, 149), 0px 0px 0px 8px rgba(61, 61, 61, 0.2)';
    BasicThemeClass.fileUploaderFileTypeCodeIconColor = '#B750D1';
    BasicThemeClass.fileUploaderFileTypePictureIconColor = '#51ADFF';
    BasicThemeClass.fileUploaderFileTypePresentationIconColor = '#FC7630';
    BasicThemeClass.fileUploaderFileTypeTableIconColor = '#26AD50';
    BasicThemeClass.fileUploaderFileTypeTextIconColor = '#2291FF';
    BasicThemeClass.fileUploaderFileTypeArchiveIconColor = '#D46421';
    BasicThemeClass.fileUploaderFileTypeFolderIconColor = '#FECA42';
    BasicThemeClass.fileUploaderFileTypeUnknownIconColor = '#ADADAD';
    BasicThemeClass.fileUploaderDisabledColor = 'rgba(0, 0, 0, 0.54)';
    BasicThemeClass.fileUploaderFileHeightSmall = '32px';
    BasicThemeClass.fileUploaderFileHeightMedium = '40px';
    BasicThemeClass.fileUploaderFileHeightLarge = '48px';
    BasicThemeClass.fileUploaderTileWidthSmall = '104px';
    BasicThemeClass.fileUploaderTileWidthMedium = '120px';
    BasicThemeClass.fileUploaderTileWidthLarge = '144px';
    BasicThemeClass.fileUploaderTileMinHeightSmall = '132px';
    BasicThemeClass.fileUploaderTileMinHeightMedium = '150px';
    BasicThemeClass.fileUploaderTileMinHeightLarge = '184px';
    BasicThemeClass.fileUploaderTileHeightSmall = '180px';
    BasicThemeClass.fileUploaderTileHeightMedium = '206px';
    BasicThemeClass.fileUploaderTileHeightLarge = '248px';
    BasicThemeClass.fileUploaderFileSizeWidthSmall = '80px';
    BasicThemeClass.fileUploaderFileSizeWidthMedium = '88px';
    BasicThemeClass.fileUploaderFileSizeWidthLarge = '104px';
    BasicThemeClass.fileUploaderFileSizeMarginLeft = '28px';
    BasicThemeClass.fileUploaderFileSizeMarginSmall = '32px';
    BasicThemeClass.fileUploaderFileSizeMarginMedium = '34px';
    BasicThemeClass.fileUploaderFileSizeMarginLarge = '36px';
    BasicThemeClass.fileUploaderFileIconSizeSmall = '24px';
    BasicThemeClass.fileUploaderFileIconSizeMedium = '32px';
    BasicThemeClass.fileUploaderFileIconSizeLarge = '40px';
    BasicThemeClass.fileUploaderTileIconSizeSmall = '20px';
    BasicThemeClass.fileUploaderTileIconSizeMedium = '24px';
    BasicThemeClass.fileUploaderTileIconSizeLarge = '32px';
    BasicThemeClass.fileUploaderTileTypeIconHeightSmall = '116px';
    BasicThemeClass.fileUploaderTileTypeIconHeightMedium = '126px';
    BasicThemeClass.fileUploaderTileTypeIconHeightLarge = '152px';
    BasicThemeClass.fileUploaderListGap = '8px';
    BasicThemeClass.fileUploaderListSummaryTextGap = '12px';
    BasicThemeClass.clearCrossIconColor = 'rgba(0, 0, 0, 0.54)';
    BasicThemeClass.clearCrossIconHoverColor = 'rgba(0, 0, 0, 0.87)';
    BasicThemeClass.clearCrossIconAlign = 'center';
    BasicThemeClass.closeBtnIconDisabledColor = '#8b8b8b';
    BasicThemeClass.closeBtnIconHoverColor = 'rgba(0, 0, 0, 0.865)';
    BasicThemeClass.closeBtnIconBorderRadius = '4px';
    //#endregion Combobox
    //#region MiniModal
    BasicThemeClass.miniModalHeaderPaddingBottom = '0';
    BasicThemeClass.miniModalBodyPaddingTop = '16px';
    BasicThemeClass.miniModalBodyPaddingBottom = '0';
    BasicThemeClass.miniModalDescriptionFontSize = 'inherit';
    BasicThemeClass.miniModalDescriptionLineHeight = 'normal';
    BasicThemeClass.miniModalHeaderPaddingTop = '32px';
    BasicThemeClass.miniModalActionGap = '8px';
    BasicThemeClass.miniModalCancelIndent = '8px';
    BasicThemeClass.miniModalFooterPaddingTop = '24px';
    BasicThemeClass.miniModalFooterPaddingBottom = '32px';
    BasicThemeClass.miniModalTitleMarginTop = '16px';
    BasicThemeClass.miniModalHeightMobile = 'auto';
    BasicThemeClass.miniModalMarginTopMobile = '80px';
    BasicThemeClass.miniModalMarginLeftMobile = '24px';
    BasicThemeClass.miniModalMarginRightMobile = '24px';
    BasicThemeClass.miniModalFooterPaddingMobile = '24px 16px 16px';
    BasicThemeClass.miniModalHeaderPaddingMobile = '32px 16px 0';
    BasicThemeClass.miniModalBodyPaddingMobile = '16px 16px 0';
    BasicThemeClass.validationsTextColorWarning = '#ef8b17';
    return BasicThemeClass;
}());
var BasicTheme = createTheme({ themeClass: BasicThemeClass });
var BasicThemeClassForExtension = /** @class */ (function () {
    function class_1() {
    }
    return class_1;
}());

var LightTheme5_0 = createTheme({
    themeClass: /** @class */ (function (_super) {
        __extends(LightTheme5_0, _super);
        function LightTheme5_0() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return LightTheme5_0;
    }(BasicThemeClassForExtension)),
    prototypeTheme: BasicTheme,
    themeMarkers: [markThemeVersion('5.0')],
});

var _a$8;
var LightTheme5_1 = createTheme({
    themeClass: (_a$8 = /** @class */ (function (_super) {
            __extends(LightTheme5_1, _super);
            function LightTheme5_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(LightTheme5_1, "mobileModalCloseButtonRightPadding", {
                get: function () {
                    return this.mobileModalCloseButtonClickArea;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "mobileModalCloseButtonTopPadding", {
                get: function () {
                    return this.mobileModalCloseButtonClickArea;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "mobileSidePageCloseButtonPadding", {
                get: function () {
                    return this.mobileSidePageCloseButtonClickArea;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "sidePageCloseButtonClickAreaTop", {
                get: function () {
                    return this.modalCloseButtonClickAreaTop;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "sidePageCloseButtonClickAreaBottom", {
                get: function () {
                    return this.modalCloseButtonClickAreaBottom;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "sidePageCloseButtonClickAreaLeft", {
                get: function () {
                    return this.modalCloseButtonClickAreaLeft;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_1, "sidePageCloseButtonClickAreaRight", {
                get: function () {
                    return this.modalCloseButtonClickAreaRight;
                },
                enumerable: false,
                configurable: true
            });
            return LightTheme5_1;
        }(BasicThemeClassForExtension)),
        _a$8.modalCloseButtonClickAreaTop = '30px',
        _a$8.modalCloseButtonClickAreaBottom = '22px',
        _a$8.modalCloseButtonClickAreaLeft = '24px',
        _a$8.modalCloseButtonClickAreaRight = '28px',
        _a$8.mobileModalCloseButtonClickArea = '22px',
        _a$8.sidePageHeaderStickyOffset = '10px',
        _a$8.mobileSidePageCloseButtonClickArea = '22px',
        _a$8.sidePageCloseButtonWrapperFixedOffsetTop = '4px',
        _a$8.sidePageCloseButtonWrapperOffsetTop = '2px',
        _a$8),
    prototypeTheme: LightTheme5_0,
    themeMarkers: [markThemeVersion('5.1')],
});

var _a$7;
var LightTheme5_2 = createTheme({
    themeClass: (_a$7 = /** @class */ (function (_super) {
            __extends(LightTheme5_2, _super);
            function LightTheme5_2() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(LightTheme5_2, "mobileModalCloseButtonRightPadding", {
                get: function () {
                    return this.mobileModalCloseButtonClickArea;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_2, "mobileModalCloseButtonTopPadding", {
                get: function () {
                    return this.mobileModalCloseButtonClickArea;
                },
                enumerable: false,
                configurable: true
            });
            return LightTheme5_2;
        }(BasicThemeClassForExtension)),
        _a$7.mobileModalCloseButtonClickArea = '22px',
        _a$7.mobileModalBodyPadding = '0 16px 0 16px',
        _a$7.mobileModalContainerMarginTop = '16px',
        _a$7.mobileModalContainerMarginRight = '16px',
        _a$7.mobileModalContainerMarginBottom = '16px',
        _a$7.mobileModalContainerMarginLeft = '16px',
        _a$7.miniModalMarginTopMobile = '16px',
        _a$7.miniModalMarginLeftMobile = '16px',
        _a$7.miniModalMarginRightMobile = '16px',
        _a$7),
    prototypeTheme: LightTheme5_1,
    themeMarkers: [markThemeVersion('5.2')],
});

var _a$6;
var LightTheme5_3 = createTheme({
    themeClass: (_a$6 = /** @class */ (function (_super) {
            __extends(LightTheme5_3, _super);
            function LightTheme5_3() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return LightTheme5_3;
        }(BasicThemeClassForExtension)),
        //#region MiniModal
        _a$6.miniModalDescriptionFontSize = '16px',
        _a$6.miniModalDescriptionLineHeight = '22px',
        _a$6),
    prototypeTheme: LightTheme5_2,
    themeMarkers: [markThemeVersion('5.3')],
});

var themeTokens5_4 = {
    clearCrossIconWidthSmall: '24px',
    clearCrossIconWidthMedium: '30px',
    clearCrossIconWidthLarge: '36px',
    clearCrossIconAlign: 'flex-start',
    textareaMargin: '0px',
    textareaVerticalAlign: 'top',
};

var _a$5;
var LightTheme5_4 = createTheme({
    themeClass: (_a$5 = /** @class */ (function (_super) {
            __extends(LightTheme5_4, _super);
            function LightTheme5_4() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return LightTheme5_4;
        }(BasicThemeClassForExtension)),
        _a$5.textareaMargin = themeTokens5_4.textareaMargin,
        _a$5.clearCrossIconWidthSmall = themeTokens5_4.clearCrossIconWidthSmall,
        _a$5.clearCrossIconWidthMedium = themeTokens5_4.clearCrossIconWidthMedium,
        _a$5.clearCrossIconWidthLarge = themeTokens5_4.clearCrossIconWidthLarge,
        _a$5.clearCrossIconAlign = themeTokens5_4.clearCrossIconAlign,
        _a$5.textareaVerticalAlign = themeTokens5_4.textareaVerticalAlign,
        _a$5),
    prototypeTheme: LightTheme5_3,
    themeMarkers: [markThemeVersion('5.4')],
});

var _a$4;
var LightTheme5_5 = createTheme({
    themeClass: (_a$4 = /** @class */ (function (_super) {
            __extends(LightTheme5_5, _super);
            function LightTheme5_5() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(LightTheme5_5, "fileUploaderBorderColor", {
                get: function () {
                    return this.borderColorGrayLight;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_5, "fileUploaderDisabledTextColor", {
                get: function () {
                    return this.fileUploaderDisabledColor;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LightTheme5_5, "fileUploaderDisabledFileTypeIcon", {
                get: function () {
                    return this.fileUploaderDisabledIconColor;
                },
                enumerable: false,
                configurable: true
            });
            return LightTheme5_5;
        }(BasicThemeClassForExtension)),
        //#region FileUploader
        _a$4.fileUploaderPaddingXSmall = '7px',
        _a$4.fileUploaderPaddingXMedium = '9px',
        _a$4.fileUploaderPaddingXLarge = '11px',
        _a$4.fileUploaderDisabledColor = 'rgba(0, 0, 0, 0.54)',
        _a$4.fileUploaderDisabledIconColor = 'rgba(0, 0, 0, 0.32)',
        _a$4),
    prototypeTheme: LightTheme5_4,
    themeMarkers: [markThemeVersion('5.5')],
});

var LIGHT_THEME_5_5 = LightTheme5_5;
var LIGHT_THEME = LIGHT_THEME_5_5;

var ThemeFactory = /** @class */ (function () {
    function ThemeFactory() {
    }
    Object.defineProperty(ThemeFactory, "defaultTheme", {
        get: function () {
            return this.overridableDefaultTheme;
        },
        enumerable: false,
        configurable: true
    });
    ThemeFactory.create = function (theme, baseTheme) {
        var base = baseTheme || this.defaultTheme;
        return this.constructTheme(base, theme);
    };
    ThemeFactory.overrideBaseTheme = function (theme) {
        var _this = this;
        // copying theme variables
        ThemeFactory.getKeys(this.defaultTheme).forEach(function (variableName) {
            var descriptor = findPropertyDescriptor(theme, variableName);
            Object.defineProperty(_this.defaultTheme, variableName, descriptor);
        });
        // copying theme markers
        Object.values(REACT_UI_THEME_MARKERS).forEach(function (marker) {
            var descriptor = findPropertyDescriptor(theme, marker.key);
            Object.defineProperty(_this.defaultTheme, marker.key, descriptor);
        });
    };
    ThemeFactory.getKeys = function (theme) {
        var keys = [];
        while (isNonNullable$1(theme)) {
            Object.keys(theme).forEach(function (key) {
                if (!keys.includes(key)) {
                    keys.push(key);
                }
            });
            // TODO: Enable `no-param-reassign` rule.
            // eslint-disable-next-line no-param-reassign
            theme = Object.getPrototypeOf(theme);
        }
        return keys.sort();
    };
    ThemeFactory.constructTheme = function (base, theme) {
        var newTheme = Object.create(base);
        Object.keys(theme).forEach(function (propName) {
            var descriptor = Object.getOwnPropertyDescriptor(theme, propName);
            if (descriptor) {
                Object.defineProperty(newTheme, propName, descriptor);
            }
        });
        return Object.freeze(newTheme);
    };
    /**
     * The default theme created with Object.create() is needed for the "overrideBaseTheme" to work.
     *
     * Themes should be frozen objects. But it is not possible to define properties on frozen objects.
     * So, an object created by Object.create({ *frozen_object* }) acts as frozen too,
     * but allows to apply Object.defineProperty to his own properties.
     */
    ThemeFactory.overridableDefaultTheme = Object.create(LIGHT_THEME);
    return ThemeFactory;
}());

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

/**
 * Возвращает размер элемента и его позицию относительно viewport
 *
 * @param element - ref элемента или сам элемент
 * @returns - возвращает размер элемента и его позицию относительно viewport
 */
var getDOMRect = function (element) {
    var defaultValues = {
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
    };
    if (element && 'current' in element) {
        return getRefRect(defaultValues, element);
    }
    return getElementRect(defaultValues, element);
};
var getElementRect = function (defaultValues, element) {
    if (element) {
        return element.getBoundingClientRect();
    }
    return defaultValues;
};
var getRefRect = function (defaultValues, ref) {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
        return ref.current.getBoundingClientRect();
    }
    return defaultValues;
};

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	} 
} (eventemitter3));

var eventemitter3Exports = eventemitter3.exports;
var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

var emitterCache;
function getEmitter() {
    if (!emitterCache) {
        emitterCache = new EventEmitter();
    }
    return emitterCache;
}
function listenBrowserEvents() {
    var _a, _b;
    (_a = globalObject.globalObject.addEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'scroll', emit, { capture: true });
    (_b = globalObject.globalObject.addEventListener) === null || _b === void 0 ? void 0 : _b.call(globalObject.globalObject, 'resize', emit, { capture: true });
}
function unlistenBrowserEvents() {
    var _a, _b;
    (_a = globalObject.globalObject.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'scroll', emit, { capture: true });
    (_b = globalObject.globalObject.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(globalObject.globalObject, 'resize', emit, { capture: true });
}
function addListener(callback) {
    var emitter = getEmitter();
    if (emitter.listeners('layout').length === 0) {
        listenBrowserEvents();
    }
    emitter.addListener('layout', callback);
    return {
        remove: function () {
            emitter.removeListener('layout', callback);
            if (emitter.listeners('layout').length === 0) {
                unlistenBrowserEvents();
            }
        },
    };
}
function emit() {
    ReactDOM.unstable_batchedUpdates(function () {
        getEmitter().emit('layout');
    });
}

var callChildRef = function (componentRef, instance) {
    if (!componentRef) {
        return;
    }
    if (typeof componentRef === 'function') {
        componentRef(instance);
    }
    if (Object.prototype.hasOwnProperty.call(componentRef, 'current')) {
        // @ts-expect-error: will be fixed in #2807
        componentRef.current = instance;
    }
};

function rootNode(Component) {
    var _a;
    var rootNode = (_a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.call(this, args[0]) || this;
                _this.rootNode = Component.defaultRootNode;
                _this.rootNodeEmitter = new EventEmitter();
                _this.setRootNode = function (instance) {
                    var rootNode = getRootNode$2(instance);
                    if (rootNode !== _this.rootNode) {
                        _this.rootNode = rootNode;
                        _this.rootNodeEmitter.emit('change', rootNode);
                    }
                };
                _this.getRootNode = function () {
                    return _this.rootNode;
                };
                _this.addRootNodeChangeListener = function (callback) {
                    _this.rootNodeEmitter.addListener('change', callback);
                    return {
                        remove: function () {
                            _this.rootNodeEmitter.removeListener('change', callback);
                        },
                    };
                };
                return _this;
            }
            return class_1;
        }(Component)),
        _a.__KONTUR_REACT_UI__ = Component.__KONTUR_REACT_UI__,
        _a.displayName = Component.displayName,
        _a);
    var nameDescriptor = Object.getOwnPropertyDescriptor(rootNode, 'name');
    if (!nameDescriptor || nameDescriptor.configurable) {
        Object.defineProperty(rootNode, 'name', { value: Component.name });
    }
    return rootNode;
}
var isInstanceWithRootNode$1 = function (instance) {
    return Boolean(instance) && Object.prototype.hasOwnProperty.call(instance, 'getRootNode');
};

/**
 * Extracts component's root Element (HTMLElement/SVGElement) out of it's instance
 * following the "StrictMode support convention" (@see README.md#strictmode, #2518).
 *
 * Replaces findDOMNode but falls back to it if "convention" is not respected.
 *
 * @param instance Component's instance provided by React.Ref or `this` inside class-components.
 * @returns Component's root `Element` or null
 */
var getRootNode$2 = function (instance) {
    /**
     * Options of what instance can be:
     *  1. null or undefined
     *  2. DOM Element
     *  3. class Component instance (object)
     *  4. literally anything, returned from useImperativeHandle
     */
    if (!instance) {
        // instance can be `null` if component was unmounted
        // also checking undefined for convenient usage
        return null;
    }
    if (isElement$1(instance)) {
        // instance can be an Element already if its coming
        // from Refs of intrinsic elements (<div />, <button />, etc.)
        return instance;
    }
    var rootNode;
    if (isInstanceWithRootNode$1(instance)) {
        rootNode = instance.getRootNode();
    }
    if (rootNode !== undefined) {
        // the getter exists and has returned something, it should be what we are looking for
        // probably its an Element or null (which is also OK, e.g. Popup/Tooltip/Hint before opening)
        return rootNode;
    }
    try {
        // rootNode is undefined, which means that the getter doesn't exists or returns the undefined
        // anyway, it tell us that the convention is not respected,
        // so, we have to fall back to the deprecated findDOMNode, which breaks StrictMode
        // instance can still be a class component or an imperative handle (i.e., anything, except null/undefined/Element)
        rootNode = ReactDOM.findDOMNode(instance);
    }
    catch (e) {
        // but findDOMNode doesn`t accept everything that instance can be at this point,
        // so we have to handle exceptions
        // see https://github.com/facebook/react/blob/cae63505/packages/react-dom/src/__tests__/findDOMNode-test.js#L66-L86
        warning(false, '[getRootNode]: can`t fallback to findDOMNode.' +
            '\n' +
            'See https://github.com/skbkontur/retail-ui/blob/master/packages/react-ui/README.md#strictmode' +
            '\n\n' +
            e.message);
        return null;
    }
    // the findDOMNode can also return Text, but we are only interested in Elements, so just filter it
    return isElement$1(rootNode) ? rootNode : null;
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint, @typescript-eslint/no-unused-vars
function createPropsGetter$1(defaultProps) {
    return function () {
        return this.props;
    };
}

function isInstanceOf(instance, constructor) {
    return !!constructor && instance instanceof constructor;
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var debounce$1 = /*@__PURE__*/getDefaultExportFromCjs(lodash_debounce);

var ThemeContext = React.createContext(ThemeFactory.defaultTheme);
ThemeContext.displayName = 'ThemeContext';
ThemeContext.__KONTUR_REACT_UI__ = 'ThemeContext';

var _a$3, _b$2, _c;
// NOTE Some checks are used from https://github.com/arasatasaygin/is.js
var platform = (((_a$3 = globalObject.globalObject.navigator) === null || _a$3 === void 0 ? void 0 : _a$3.platform) || '').toLowerCase();
var userAgent = (((_b$2 = globalObject.globalObject.navigator) === null || _b$2 === void 0 ? void 0 : _b$2.userAgent) || '').toLowerCase();
var vendor = (((_c = globalObject.globalObject.navigator) === null || _c === void 0 ? void 0 : _c.vendor) || '').toLowerCase();
platform.includes('mac');
platform.includes('win');
var isSafari = /version\/(\d+).+?safari/.test(userAgent);
var isFirefox = /(?:firefox|fxios)\/(\d+)/.test(userAgent);
var isOpera = /(?:^opera.+?version|opr)\/(\d+)/.test(userAgent);
vendor.includes('google inc') && /(?:chrome|crios)\/(\d+)/.test(userAgent) && !isOpera;
var isEdge = userAgent.includes('edge/');
var isIE11 = userAgent.includes('trident/');
/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) &&
    globalObject.globalObject.document &&
    'ontouchstart' in globalObject.globalObject.document.documentElement;
isSafari && userAgent.includes('version/17');
userAgent.includes('version/17.0');
userAgent.includes('version/17.1');
userAgent.includes('version/17.2');
userAgent.includes('version/17.3');

/* eslint-disable no-useless-constructor */
var SpinnerFallbackAnimationRunner = /** @class */ (function () {
    function SpinnerFallbackAnimationRunner(animations, FPS) {
        var _this = this;
        this.animations = animations;
        this.FPS = FPS;
        this.interval = null;
        this.start = function () {
            _this.animations.forEach(function (animation) { return animation.start(); });
            _this.interval = rafInterval(function () {
                _this.animations.forEach(function (animation) { return animation.step(); });
            }, _this.FPS);
        };
        this.stop = function () {
            if (_this.interval) {
                _this.interval.clear();
                _this.animations.forEach(function (animation) { return animation.finish(); });
            }
        };
        this.start();
    }
    return SpinnerFallbackAnimationRunner;
}());
var rafInterval = function (fn, delay) {
    var lastcall = 0;
    var cleared = false;
    var rafId = 0;
    var interval = function () {
        if (cleared) {
            return;
        }
        var timestamp = new Date().getTime();
        if (!lastcall) {
            lastcall = timestamp;
        }
        if (timestamp - lastcall > delay) {
            fn();
            lastcall = timestamp;
        }
        if (globalObject.globalObject.requestAnimationFrame) {
            rafId = globalObject.globalObject.requestAnimationFrame(interval);
        }
    };
    interval();
    return {
        clear: function () {
            var _a;
            cleared = true;
            (_a = globalObject.globalObject.cancelAnimationFrame) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, rafId);
        },
    };
};
var Animation = /** @class */ (function () {
    function Animation(duration, onProgress, onFinish) {
        var _this = this;
        this.duration = duration;
        this.onProgress = onProgress;
        this.onFinish = onFinish;
        this.startTime = 0;
        this.isFinished = false;
        this.step = function () {
            if (_this.isFinished) {
                return;
            }
            var timestamp = new Date().getTime();
            if (!_this.startTime) {
                _this.startTime = timestamp;
            }
            var progress = (timestamp - _this.startTime) / _this.duration;
            _this.onProgress(progress);
            if (progress >= 1) {
                _this.finish();
            }
        };
        this.reset = function () {
            _this.startTime = 0;
            _this.isFinished = false;
        };
        this.finish = function () {
            _this.isFinished = true;
            _this.onFinish && _this.onFinish(_this);
        };
        this.start = function () {
            if (!_this.isFinished) {
                _this.step();
            }
        };
    }
    return Animation;
}());
var createOffsetAnimation = function (from, to, duration, setStyleProperty, units) {
    return new Animation(duration, function (progress) {
        var current = from + (to - from) * progress;
        setStyleProperty('stroke-dashoffset', "".concat(current).concat(units));
    }, function (animation) {
        animation.reset();
    });
};
var createLengthAnimation = function (from, to, duration, setStyleProperty, units) {
    var reverse = false;
    return new Animation(duration, function (progress) {
        var p = reverse ? 1 - progress : progress;
        var current = [from[0] + (to[0] - from[0]) * p, from[1] + (to[1] - from[1]) * p];
        setStyleProperty('stroke-dasharray', "".concat(current[0]).concat(units, " ").concat(current[1]).concat(units));
    }, function (animation) {
        reverse = !reverse;
        animation.reset();
    });
};
var createColorAnimation = function (colors, duration, setStyleProperty) {
    var rgbColors = colors.map(function (color) { return ColorFactory.create(color).rgb; });
    var currentIndex = 0;
    var nextIndex = 1;
    return new Animation(duration, function (progress) {
        var from = rgbColors[currentIndex];
        var to = rgbColors[nextIndex];
        if (from && to) {
            var current = [
                Math.round(from[0] + (to[0] - from[0]) * progress),
                Math.round(from[1] + (to[1] - from[1]) * progress),
                Math.round(from[2] + (to[2] - from[2]) * progress),
            ];
            setStyleProperty('stroke', "rgb(".concat(current, ")"));
        }
    }, function (animation) {
        animation.reset();
        currentIndex = nextIndex;
        nextIndex = (nextIndex + 1) % colors.length;
    });
};
var createRotationAnimation = function (from, to, duration, setStyleProperty, units) {
    if (units === void 0) { units = 'deg'; }
    return new Animation(duration, function (progress) {
        var current = Math.round(from + (to - from) * progress);
        setStyleProperty('transform', "rotate(".concat(current).concat(units, ")"));
    }, function (animation) {
        animation.reset();
    });
};

var isProcessEnvDefined = typeof process !== 'undefined' && typeof process.env !== 'undefined';
var isReactUITestEnv$1 = function () {
    // usefull when process doesn't exist (webpack5/vite/etc)
    var isReactUITestDefined = typeof REACT_UI_TEST !== 'undefined';
    if (isReactUITestDefined && Boolean(REACT_UI_TEST)) {
        return true;
    }
    if (isProcessEnvDefined) {
        switch (true) {
            case Boolean(process.env.REACT_UI_TEST): // when NODE_ENV is not usable (e.g., already used for dev/prod)
            case Boolean(process.env.REACT_APP_REACT_UI_TEST): // for usage with CRA
            case Boolean(process.env.STORYBOOK_REACT_UI_TEST): // for usage with storybook
            case Boolean(process.env.enableReactTesting): // deprecated, legacy variable
                return true;
        }
    }
    return false;
};
var isNodeTestEnv = isProcessEnvDefined && process.env.NODE_ENV === 'test';
isProcessEnvDefined && process.env.NODE_ENV === 'production';
isProcessEnvDefined && process.env.NODE_ENV === 'development';
var isTestEnv$1 = isNodeTestEnv || isReactUITestEnv$1();

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix$1(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix$1(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix$1(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$2 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$2 ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$2 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$2) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$2) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = createCache(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (process.env.NODE_ENV !== 'production' && this.ctr !== 0) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered, undefined);
    insertStyles(cache, serialized);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function createExtraScopePlugin() {
  for (var _len = arguments.length, extra = new Array(_len), _key = 0; _key < _len; _key++) {
    extra[_key] = arguments[_key];
  }

  var scopes = extra.map(function (scope) {
    return scope.trim();
  });

  var extraScopePlugin = function extraScopePlugin(context, content, selectors, parents, line, column, length, type) {
    if (context !== -1) {
      return;
    }

    var selector = selectors[0];
    selectors[0] = scopes[0] + " " + selector;

    for (var i = 1; i < scopes.length; i++) {
      selectors.push(scopes[i] + " " + selector);
    }
  };

  return extraScopePlugin;
}

var specificityLevel = 0;
var canModifySpecificityLevel = true;
var specificityClassName = 'react-ui';
var canModifySpecificityClassName = true;
//TODO Delete Upgrade in major release if it still doesn't work (https://github.com/skbkontur/retail-ui/blob/next/packages/react-ui/MIGRATION.md)
var Upgrade = {
    getSpecificityLevel: function () {
        canModifySpecificityLevel = false;
        return specificityLevel;
    },
    setSpecificityLevel: function (level) {
        warning(false, "setSpecificityLevel doesn't work. For more information please visit https://github.com/skbkontur/retail-ui/blob/master/packages/react-ui/MIGRATION.md");
        if (canModifySpecificityLevel) {
            specificityLevel = level;
        }
        else {
            warning(false, "specificityLevel=".concat(specificityLevel, " \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D"));
        }
    },
    getSpecificityClassName: function () {
        canModifySpecificityClassName = false;
        return specificityClassName;
    },
    setSpecificityClassName: function (className) {
        if (canModifySpecificityClassName) {
            specificityClassName = className;
        }
        else {
            warning(false, "specificityClassName=".concat(specificityClassName, " \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D"));
        }
    },
    setWindow: globalObject.setWindow,
};

var _a$2;
var _b$1;
var REACT_UI_PREFIX = Upgrade.getSpecificityClassName();
var scope = new Array(Upgrade.getSpecificityLevel()).fill(".".concat(REACT_UI_PREFIX)).join('');
(_a$2 = createEmotion({
    key: REACT_UI_PREFIX,
    prepend: true,
    stylisPlugins: scope ? [createExtraScopePlugin(scope)] : undefined,
    container: (_b$1 = globalObject.globalObject.document) === null || _b$1 === void 0 ? void 0 : _b$1.head,
}), _a$2.flush); _a$2.hydrate; var cx = _a$2.cx; _a$2.merge; _a$2.getRegisteredStyles; _a$2.injectGlobal; var keyframes = _a$2.keyframes, css = _a$2.css; _a$2.sheet; _a$2.cache;
function isZeroArgs(fn) {
    return fn.length === 0;
}
var memoize = function (fn) {
    if (isZeroArgs(fn)) {
        var isCalled_1 = false;
        var result_1;
        return function () {
            if (!isCalled_1) {
                isCalled_1 = true;
                result_1 = fn();
            }
            return result_1;
        };
    }
    var cache = new WeakMap();
    return function (arg) {
        if (!cache.has(arg)) {
            cache.set(arg, fn(arg));
        }
        return cache.get(arg);
    };
};
var memoizeStyle = function (styles) {
    Object.keys(styles).forEach(function (className) { return (styles[className] = memoize(styles[className])); });
    return styles;
};

var styles$b = memoizeStyle({
    root: function () {
        return css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n      display: inline-block;\n      margin-left: -1px;\n      margin-right: -1px;\n    "], ["\n      display: inline-block;\n      margin-left: -1px;\n      margin-right: -1px;\n    "])));
    },
    rootInline: function () {
        return css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n      margin-left: -0.0714285714285714em;\n      margin-right: -0.0714285714285714em;\n    "], ["\n      margin-left: -0.0714285714285714em;\n      margin-right: -0.0714285714285714em;\n    "])));
    },
    icon: function () {
        return css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n      margin-bottom: -3px;\n      border-radius: 50%;\n      overflow: visible;\n    "], ["\n      margin-bottom: -3px;\n      border-radius: 50%;\n      overflow: visible;\n    "])));
    },
    iconInline: function () {
        return css(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n      height: 1.1428571428571428em;\n      width: 1.1428571428571428em;\n      margin-bottom: -0.2428571428571428em;\n      stroke-width: 0.10714285714285714em;\n    "], ["\n      height: 1.1428571428571428em;\n      width: 1.1428571428571428em;\n      margin-bottom: -0.2428571428571428em;\n      stroke-width: 0.10714285714285714em;\n    "])));
    },
});
var templateObject_1$e, templateObject_2$9, templateObject_3$9, templateObject_4$9;

var sizes = {
    big: {
        size: 96,
        width: 4,
        radius: 32,
    },
    normal: {
        size: 48,
        width: 2,
        radius: 16,
    },
    mini: {
        size: 16,
        width: 1.5,
        radius: 6,
    },
};
var isSizeAlias = function (size) {
    return typeof size === 'string' && size in sizes;
};
var SpinnerIcon = function (_a) {
    var _b, _c;
    var size = _a.size, className = _a.className, dimmed = _a.dimmed, inline = _a.inline, width = _a.width, color = _a.color;
    var _size = isSizeAlias(size) ? sizes[size] : size;
    var currentSize = inline ? sizes.mini : _size;
    var svgRef = React.useRef(null);
    if (isIE11 && !isTestEnv$1) {
        // This condition will not change during app's life time
        // So its OK to use hooks here
        // https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var fallbackAnimationRef_1 = React.useRef(null);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var _d = React.useContext(ThemeContext), red_1 = _d.red, yellow_1 = _d.yellow, green_1 = _d.green, brand_1 = _d.brand;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(function () {
            var svg = svgRef.current;
            var setStyleProperty = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (svg) {
                    (_a = svg.style).setProperty.apply(_a, args);
                }
            };
            fallbackAnimationRef_1.current = new SpinnerFallbackAnimationRunner(__spreadArray([
                createOffsetAnimation(0, -230, 1000, setStyleProperty, '%'),
                createLengthAnimation([62, 168], [187, 43], 2000, setStyleProperty, '%'),
                createRotationAnimation(0, 360, 2000, setStyleProperty)
            ], (dimmed ? [] : [createColorAnimation([red_1, yellow_1, green_1, brand_1], 1500, setStyleProperty)]), true), 1000 / 60);
            return function () {
                var fallbackAnimation = fallbackAnimationRef_1.current;
                if (fallbackAnimation) {
                    fallbackAnimation.stop();
                }
                if (svg) {
                    svg.removeAttribute('style');
                }
            };
        }, [dimmed, red_1, yellow_1, green_1, brand_1]);
    }
    return (React.createElement("span", { className: cx(styles$b.root(), (_b = {}, _b[styles$b.rootInline()] = inline, _b)) },
        React.createElement("svg", { viewBox: "0 0 ".concat(currentSize.size, " ").concat(currentSize.size), className: cx(styles$b.icon(), className, (_c = {},
                _c[styles$b.iconInline()] = inline,
                _c)), width: currentSize.size, height: currentSize.size, fill: "none", stroke: color, strokeDasharray: "".concat((10 * currentSize.radius) / 6, ", ").concat((27 * currentSize.radius) / 6), strokeDashoffset: "0", strokeWidth: width || currentSize.width, ref: svgRef, focusable: "false", "aria-hidden": "true" },
            React.createElement("circle", { cx: currentSize.size / 2, cy: currentSize.size / 2, r: currentSize.radius }))));
};

var extractCommonProps = function (props) {
    var common = {};
    var rest = {};
    for (var prop in props) {
        if (isCommonProp(prop)) {
            // @ts-expect-error: See: https://github.com/skbkontur/retail-ui/pull/2257#discussion_r565275843 and https://github.com/skbkontur/retail-ui/pull/2257#discussion_r569542736.
            common[prop] = props[prop];
        }
        else {
            // @ts-expect-error: Read the comment above.
            rest[prop] = props[prop];
        }
    }
    return [common, rest];
};
var isCommonProp = function (prop) {
    switch (true) {
        case prop === 'className':
        case prop === 'style':
        case prop === 'rootNodeRef':
        case prop === 'children':
        case prop.indexOf('data-') === 0: // все data-атрибуты
            return true;
        default:
            return false;
    }
};

var toKebabCase = function (value) {
    if (!value) {
        return '';
    }
    return value
        .split(/\.?(?=[A-Z])/)
        .join('-')
        .toLowerCase();
};

var prefix = "data-visual-state-";
function fillResult(result, key, value) {
    if (value) {
        result["".concat(prefix).concat(toKebabCase(key))] = '';
    }
    return result;
}
function getVisualStateDataAttributes(attributes) {
    return Object.entries(attributes).reduce(function (previousValue, currentValue) { return fillResult(previousValue, currentValue[0], currentValue[1]); }, {});
}

var tryGetBoolean = function (value) { return (typeof value === 'boolean' ? value : undefined); };

function getCommonVisualStateDataAttributes(componentProps) {
    return getVisualStateDataAttributes({
        error: tryGetBoolean(componentProps['error']),
        warning: tryGetBoolean(componentProps['warning']),
    });
}

var CommonWrapper = /** @class */ (function (_super) {
    __extends(CommonWrapper, _super);
    function CommonWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootNodeSubscription = null;
        _this.ref = function (instance) {
            var _a, _b, _c, _d, _e;
            _this.setRootNode(instance);
            (_b = (_a = _this.props).rootNodeRef) === null || _b === void 0 ? void 0 : _b.call(_a, getRootNode$2(instance));
            // refs are called when instances change,
            // so we have to renew or remove old subscription
            (_c = _this.rootNodeSubscription) === null || _c === void 0 ? void 0 : _c.remove();
            _this.rootNodeSubscription = null;
            if (instance && isInstanceWithRootNode$1(instance)) {
                _this.rootNodeSubscription = (_d = instance.addRootNodeChangeListener) === null || _d === void 0 ? void 0 : _d.call(instance, function (node) {
                    var _a, _b;
                    _this.setRootNode(node);
                    (_b = (_a = _this.props).rootNodeRef) === null || _b === void 0 ? void 0 : _b.call(_a, node);
                });
            }
            var originalRef = (_e = _this.child) === null || _e === void 0 ? void 0 : _e.ref;
            if (typeof originalRef === 'function' || (originalRef && typeof originalRef === 'object')) {
                originalRef && callChildRef(originalRef, instance);
            }
        };
        return _this;
    }
    CommonWrapper.prototype.render = function () {
        var _this = this;
        var _a = extractCommonProps(this.props), _b = _a[0], _c = _a[1], className = _b.className, style = _b.style, children = _b.children; _b.rootNodeRef; var dataProps = __rest(_b, ["className", "style", "children", "rootNodeRef"]), rest = __rest(_c, []);
        this.child = isFunction(children) ? children(rest) : children;
        var getChildProps = function (child) {
            var childProps = __assign(__assign({}, getCommonVisualStateDataAttributes(rest)), dataProps);
            isRefableElement(child) && (childProps.ref = _this.ref);
            var classNames = cx(child.props.className, className);
            classNames && (childProps.className = classNames);
            var styles = __assign(__assign({}, child.props.style), style);
            Object.keys(styles).length && (childProps.style = styles);
            return childProps;
        };
        return React.isValidElement(this.child)
            ? React.cloneElement(this.child, getChildProps(this.child))
            : this.child;
    };
    CommonWrapper.__KONTUR_REACT_UI__ = 'CommonWrapper';
    CommonWrapper.displayName = 'CommonWrapper';
    CommonWrapper = __decorate([
        rootNode
    ], CommonWrapper);
    return CommonWrapper;
}(React.Component));

var AnimationKeyframes = {
    spinnerCircleOffset: function () {
        return keyframes(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n        0% { stroke-dashoffset: 231.25%; }\n        100% { stroke-dashoffset: 0%; }\n      "], ["\n        0% { stroke-dashoffset: 231.25%; }\n        100% { stroke-dashoffset: 0%; }\n      "])));
    },
    spinnerCircleLength: function () {
        return keyframes(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n        0% { stroke-dasharray: 62.5%, 168.75%; }\n        50% {  stroke-dasharray: 187.5%, 43.75%; }\n        100% { stroke-dasharray: 62.5%, 168.75%; }\n      "], ["\n        0% { stroke-dasharray: 62.5%, 168.75%; }\n        50% {  stroke-dasharray: 187.5%, 43.75%; }\n        100% { stroke-dasharray: 62.5%, 168.75%; }\n      "])));
    },
    spinnerCircleRotate: function () {
        return keyframes(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n        100% { transform: rotate(360deg); }\n      "], ["\n        100% { transform: rotate(360deg); }\n      "])));
    },
    spinnerColor: function (t) {
        return keyframes(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n        100%, 0% { stroke: ", "; }\n        40% { stroke: ", "; }\n        66% { stroke: ", "; }\n        80%, 90% { stroke: ", "; }\n      "], ["\n        100%, 0% { stroke: ", "; }\n        40% { stroke: ", "; }\n        66% { stroke: ", "; }\n        80%, 90% { stroke: ", "; }\n      "])), t.red, t.yellow, t.green, t.brand);
    },
};
var templateObject_1$d, templateObject_2$8, templateObject_3$8, templateObject_4$8;

var styles$a = memoizeStyle({
    circle: function (t) {
        return css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n      stroke: ", ";\n\n      ", "\n    "], ["\n      stroke: ", ";\n\n      ", "\n    "])), t.spinnerColor, !isIE11 &&
            "\n          animation: ".concat(AnimationKeyframes.spinnerCircleOffset(), " 1s cubic-bezier(0.5, 0.2, 0.5, 0.8) infinite,\n            ").concat(AnimationKeyframes.spinnerCircleLength(), " 2s cubic-bezier(0.36, 0.14, 0.38, 0.69) infinite,\n            ").concat(AnimationKeyframes.spinnerCircleRotate(), " 2s linear infinite,\n            ").concat(AnimationKeyframes.spinnerColor(t), " 6s ease-in-out infinite;\n        "));
    },
    circleDimmedColor: function (t) {
        return css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n      stroke: ", ";\n    "], ["\n      stroke: ", ";\n    "])), t.spinnerDimmedColor);
    },
    circleWithoutColorAnimation: function () {
        return css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), !isIE11 &&
            "\n          animation: ".concat(AnimationKeyframes.spinnerCircleOffset(), " 1s cubic-bezier(0.5, 0.2, 0.5, 0.8) infinite,\n          ").concat(AnimationKeyframes.spinnerCircleLength(), " 2s cubic-bezier(0.36, 0.14, 0.38, 0.69) infinite,\n          ").concat(AnimationKeyframes.spinnerCircleRotate(), " 2s linear infinite;\n        "));
    },
    captionColor: function (t) {
        return css(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), t.spinnerCaptionColor);
    },
    inline: function () {
        return css(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n      font-size: inherit;\n      line-height: inherit;\n    "], ["\n      font-size: inherit;\n      line-height: inherit;\n    "])));
    },
    mini: function (t) {
        return css(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n      margin-left: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      margin-left: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.spinnerCaptionGapSmall, t.spinnerFontSizeSmall, t.spinnerLineHeightSmall);
    },
    small: function (t) {
        return css(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n      margin: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      margin: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.spinnerCaptionMarginSmall, t.spinnerFontSizeSmall, t.spinnerLineHeightSmall);
    },
    normal: function (t) {
        return css(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n      display: block;\n      font-size: ", ";\n      line-height: ", ";\n      margin-top: ", ";\n    "], ["\n      display: block;\n      font-size: ", ";\n      line-height: ", ";\n      margin-top: ", ";\n    "])), t.spinnerFontSizeMedium, t.spinnerLineHeightMedium, t.spinnerCaptionGapMedium);
    },
    medium: function (t) {
        return css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n      margin: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      margin: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.spinnerCaptionMarginMedium, t.spinnerFontSizeMedium, t.spinnerLineHeightMedium);
    },
    big: function (t) {
        return css(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n      display: block;\n      font-size: ", ";\n      line-height: ", ";\n      margin-top: ", ";\n    "], ["\n      display: block;\n      font-size: ", ";\n      line-height: ", ";\n      margin-top: ", ";\n    "])), t.spinnerFontSizeLarge, t.spinnerLineHeightLarge, t.spinnerCaptionGapLarge);
    },
    large: function (t) {
        return css(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n      font-size: ", ";\n      line-height: ", ";\n      margin: ", ";\n    "], ["\n      font-size: ", ";\n      line-height: ", ";\n      margin: ", ";\n    "])), t.spinnerFontSizeLarge, t.spinnerLineHeightLarge, t.spinnerCaptionMarginLarge);
    },
    spinner: function () {
        return css(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n      display: inline-block;\n      text-align: center;\n      line-height: normal;\n    "], ["\n      display: inline-block;\n      text-align: center;\n      line-height: normal;\n    "])));
    },
    inner: function () {
        return css(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n      display: inline-block;\n    "], ["\n      display: inline-block;\n    "])));
    },
});
var templateObject_1$c, templateObject_2$7, templateObject_3$7, templateObject_4$7, templateObject_5$6, templateObject_6$3, templateObject_7$3, templateObject_8$2, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1;

var types = ['big', 'mini', 'normal'];
var SpinnerDataTids = {
    root: 'Spinner__root',
};
/**
 * `Spinner` — это зацикленный индикатор, не отображающий прогресс выполнения задачи.
 *
 * Используйте `Spinner`, чтобы показать, что система выполняет команду, которую дал пользователь.
 * Не применяйте `Spinner` для заполнения паузы при загрузке контента, для этого предназначен GlobalLoader.
 *
 * Используйте компонент `Spinner`, если вам нужен спиннер, без дополнительного функционала, который предоставляет компонент Loader.
 */
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter$1(Spinner_1.defaultProps);
        _this.renderSpinner = function (type, dimmed, inline) {
            var _a;
            return (React.createElement(SpinnerIcon, { size: type, className: cx((_a = {},
                    _a[styles$a.circle(_this.theme)] = !dimmed && !_this.props.color,
                    _a[styles$a.circleDimmedColor(_this.theme)] = dimmed,
                    _a[styles$a.circleWithoutColorAnimation()] = dimmed || !!_this.props.color,
                    _a)), dimmed: dimmed, width: _this.props.width, color: _this.props.color, inline: inline }));
        };
        _this.renderCaption = function (type, caption) { return (React.createElement("span", { className: cx(styles$a[type](_this.theme), styles$a.captionColor(_this.theme)) }, caption)); };
        return _this;
    }
    Spinner_1 = Spinner;
    Spinner.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = theme;
            return _this.renderMain();
        }));
    };
    Spinner.prototype.renderMain = function () {
        var _a = this.props, _b = _a.caption, caption = _b === void 0 ? null : _b, dimmed = _a.dimmed, inline = _a.inline;
        var type = this.getProps().type;
        return (React.createElement(CommonWrapper, __assign({ rootNodeRef: this.setRootNode }, this.props),
            React.createElement("div", { "data-tid": SpinnerDataTids.root, className: styles$a.spinner() },
                React.createElement("span", { className: styles$a.inner() }, this.renderSpinner(type, dimmed, inline)),
                caption && this.renderCaption(type, caption))));
    };
    var Spinner_1;
    Spinner.__KONTUR_REACT_UI__ = 'Spinner';
    Spinner.displayName = 'Spinner';
    Spinner.defaultProps = {
        type: 'normal',
    };
    Spinner.Types = Object.assign.apply(Object, __spreadArray([{}], types.map(function (type) {
        var _a;
        return (_a = {}, _a[type] = type, _a);
    }), false));
    Spinner = Spinner_1 = __decorate([
        rootNode
    ], Spinner);
    return Spinner;
}(React.Component));

var TaskWithDelayAndMinimalDuration = /** @class */ (function () {
    function TaskWithDelayAndMinimalDuration(initialValues) {
        var _this = this;
        this.isTaskActive = false;
        this.setTimeoutBeforeTaskStart = function () {
            _this.timeoutBeforeTaskStart = globalObject.globalObject.setTimeout(function () {
                _this.isTaskActive && _this.taskParams.taskStartCallback();
                _this.clearTimeoutBeforeTaskStart();
                _this.setTimeoutBeforeTaskStop();
            }, _this.taskParams.delayBeforeTaskStart);
        };
        this.setTimeoutBeforeTaskStop = function () {
            _this.timeoutBeforeTaskStop = globalObject.globalObject.setTimeout(function () {
                !_this.isTaskActive && _this.taskParams.taskStopCallback();
                _this.clearTimeoutBeforeTaskStop();
            }, _this.taskParams.durationOfTask);
        };
        this.clearTimeoutBeforeTaskStart = function () {
            _this.timeoutBeforeTaskStart && globalObject.globalObject.clearTimeout(_this.timeoutBeforeTaskStart);
            _this.timeoutBeforeTaskStart = null;
        };
        this.clearTimeoutBeforeTaskStop = function () {
            _this.timeoutBeforeTaskStop && globalObject.globalObject.clearTimeout(_this.timeoutBeforeTaskStop);
            _this.timeoutBeforeTaskStop = null;
        };
        this.start = function () {
            if (_this.isTaskActive) {
                return;
            }
            _this.isTaskActive = true;
            if (_this.timeoutBeforeTaskStop) {
                return;
            }
            if (_this.timeoutBeforeTaskStart) {
                _this.clearTimeoutBeforeTaskStart();
            }
            _this.setTimeoutBeforeTaskStart();
        };
        this.update = function (updateData) {
            _this.taskParams = __assign(__assign({}, _this.taskParams), updateData);
        };
        this.stop = function () {
            if (!_this.isTaskActive) {
                return;
            }
            _this.isTaskActive = false;
            if (!_this.timeoutBeforeTaskStart && !_this.timeoutBeforeTaskStop) {
                _this.taskParams.taskStopCallback();
            }
            if (_this.timeoutBeforeTaskStart) {
                _this.clearTimeoutBeforeTaskStart();
            }
        };
        this.clearTask = function () {
            _this.isTaskActive = false;
            _this.clearTimeoutBeforeTaskStart();
            _this.clearTimeoutBeforeTaskStop();
        };
        this.taskParams = initialValues;
    }
    return TaskWithDelayAndMinimalDuration;
}());

/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode$1 = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode$1(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode$1(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode$1(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode$1(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};

/**
 * Поиск всех элементов, у которых tabindex > -1, в переданном родителе
 * или на всей странице
 * @param {Element|Document|null} [parent=document] - Родительский элемент,
 * внутри которого осуществляется поиск.
 * @return {FocusableElement[]} - Массив найденных элементов
 */
var getTabbableElements = function (parent) {
    if (parent === void 0) { parent = globalObject.globalObject.document; }
    if (!parent || !parent.children.length || !isInstanceOf(parent, globalObject.globalObject.Element)) {
        return [];
    }
    return tabbable(parent);
};

var styles$9 = memoizeStyle({
    active: function (t) {
        return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n      border-radius: ", ";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n\n      background: ", ";\n    "], ["\n      border-radius: ", ";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n\n      background: ", ";\n    "])), t.loaderBorderRadius, t.loaderBg);
    },
    loader: function () {
        return css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n      box-sizing: border-box;\n      display: inline-block;\n      position: relative;\n      width: 100%;\n      z-index: inherit;\n    "], ["\n      box-sizing: border-box;\n      display: inline-block;\n      position: relative;\n      width: 100%;\n      z-index: inherit;\n    "])));
    },
    spinnerContainer: function () {
        return css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n      display: block;\n      margin: auto;\n      text-align: center;\n\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n\n      &::before {\n        content: ' ';\n        display: inline-block;\n        height: 100%;\n        min-height: 100%;\n        vertical-align: middle;\n      }\n    "], ["\n      display: block;\n      margin: auto;\n      text-align: center;\n\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: 0;\n\n      &::before {\n        content: ' ';\n        display: inline-block;\n        height: 100%;\n        min-height: 100%;\n        vertical-align: middle;\n      }\n    "])));
    },
    spinnerContainerSticky: function () {
        return css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n      position: fixed;\n    "], ["\n      position: fixed;\n    "])));
    },
    spinnerComponentWrapper: function () {
        return css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n      display: inline-block;\n    "], ["\n      display: inline-block;\n    "])));
    },
});
var templateObject_1$b, templateObject_2$6, templateObject_3$6, templateObject_4$6, templateObject_5$5;

var LoaderDataTids = {
    idle: 'Loader__Idle',
    veil: 'Loader__Veil',
    spinner: 'Loader__Spinner',
};
/**
 * Компонент `Loader` принимает внутрь себя контент, поверх которого в активном состоянии `Loader`'а будет отрисован спиннер.
 *
 * Если вам нужен только сам спиннер без дополнительного функционала - используйте компонент Spinner.
 */
/** @class */ ((function (_super) {
    __extends(Loader, _super);
    function Loader(props) {
        var _this = _super.call(this, props) || this;
        _this.getProps = createPropsGetter$1(Loader_1.defaultProps);
        _this.childrenRef = function (element) {
            _this.childrenContainerNode = element;
        };
        _this.spinnerRef = function (element) {
            _this.spinnerContainerNode = element;
        };
        _this.checkSpinnerPosition = function () {
            if (!_this.spinnerContainerNode || !globalObject.isBrowser(globalObject.globalObject)) {
                return;
            }
            var _a = getDOMRect(_this.spinnerContainerNode), containerTop = _a.top, containerRight = _a.right, containerBottom = _a.bottom, containerLeft = _a.left, containerHeight = _a.height, containerWidth = _a.width;
            var windowHeight = globalObject.globalObject.innerHeight;
            var windowWidth = globalObject.globalObject.innerWidth;
            // Если контейнер не больше высоты и не шире окна,
            // то просто выравниваем по центру
            if (windowHeight >= containerHeight && windowWidth >= containerWidth) {
                _this.setState({
                    isStickySpinner: false,
                    spinnerStyle: {},
                });
                return;
            }
            var spinnerStyle = {
                top: 30,
                right: 0,
                bottom: 30,
                left: 0,
            };
            // ПО ВЕРТИКАЛИ
            // Если верхний край контейнера ниже верхнего края окна,
            // то сдвигаем и лоадер
            if (containerTop > 0) {
                spinnerStyle.top = containerTop + 30;
            }
            // Если нижний край контейнера выше нижнего края окна,
            // то сдвигаем и лоадер
            if (containerBottom < windowHeight) {
                spinnerStyle.bottom = Math.abs(windowHeight - containerBottom) + 30;
            }
            // Если знаем высоту спиннера и нижний край контейнера поднимается
            // выше отступа на высоту спиннера, то убираем верхнюю позицию лоадера
            var spinnerHeight = getDOMRect(_this.spinnerNode).height;
            if (spinnerHeight && spinnerStyle.bottom >= windowHeight - spinnerHeight) {
                delete spinnerStyle.top;
            }
            // ПО ГОРИЗОНТАЛИ
            // Если левый край контейнера правее левого края окна,
            // то сдвигаем и лоадер
            if (containerLeft > 0) {
                spinnerStyle.left = containerLeft;
            }
            // Если правый край контейнера левее правого края окна,
            // то сдвигаем и лоадер
            if (containerRight < windowWidth) {
                spinnerStyle.right = windowWidth - containerRight;
            }
            _this.setState({
                isStickySpinner: true,
                spinnerStyle: spinnerStyle,
            });
        };
        _this.disableChildrenFocus = function () {
            if (!_this.childrenObserver) {
                _this.makeObservable();
            }
            var tabbableElements = getTabbableElements(_this.childrenContainerNode);
            tabbableElements.forEach(function (el) {
                if (!el.hasAttribute('origin-tabindex')) {
                    el.setAttribute('origin-tabindex', el.tabIndex.toString());
                }
                el.tabIndex = -1;
            });
        };
        _this.enableChildrenFocus = function () {
            var _a, _b;
            _this.makeUnobservable();
            // NOTE: NodeList doesn't support 'forEach' method in IE11 and other older browsers
            Array.from((_b = (_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[origin-tabindex]')) !== null && _b !== void 0 ? _b : []).forEach(function (el) {
                var _a;
                el.setAttribute('tabindex', (_a = el.getAttribute('origin-tabindex')) !== null && _a !== void 0 ? _a : '0');
                el.removeAttribute('origin-tabindex');
            });
        };
        _this.makeObservable = function () {
            var target = _this.childrenContainerNode;
            if (!target || !globalObject.globalObject.MutationObserver) {
                return;
            }
            var config = {
                childList: true,
                subtree: true,
            };
            var observer = new globalObject.globalObject.MutationObserver(_this.disableChildrenFocus);
            observer.observe(target, config);
            _this.childrenObserver = observer;
        };
        _this.makeUnobservable = function () {
            var _a;
            (_a = _this.childrenObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
            _this.childrenObserver = null;
        };
        _this.spinnerContainerNode = null;
        _this.childrenContainerNode = null;
        _this.childrenObserver = null;
        _this.spinnerNode = null;
        _this.state = {
            isStickySpinner: false,
            isSpinnerVisible: false,
            isLoaderActive: false,
        };
        _this.spinnerTask = new TaskWithDelayAndMinimalDuration({
            delayBeforeTaskStart: _this.getProps().delayBeforeSpinnerShow,
            durationOfTask: _this.getProps().minimalDelayBeforeSpinnerHide,
            taskStartCallback: function () { return _this.setState({ isSpinnerVisible: true }); },
            taskStopCallback: function () { return _this.setState({ isSpinnerVisible: false }); },
        });
        return _this;
    }
    Loader_1 = Loader;
    Loader.prototype.componentDidMount = function () {
        var active = this.getProps().active;
        this.checkSpinnerPosition();
        active && this.spinnerTask.start();
        this.layoutEvents = addListener(debounce$1(this.checkSpinnerPosition, 10));
        if (active) {
            this.disableChildrenFocus();
        }
    };
    Loader.prototype.componentDidUpdate = function (prevProps, prevState) {
        var component = this.props.component;
        var _a = this.getProps(), active = _a.active, delayBeforeSpinnerShow = _a.delayBeforeSpinnerShow, minimalDelayBeforeSpinnerHide = _a.minimalDelayBeforeSpinnerHide;
        var isLoaderActive = this.state.isLoaderActive;
        if ((active && !prevProps.active) || prevProps.component !== component) {
            this.checkSpinnerPosition();
        }
        if (delayBeforeSpinnerShow !== prevProps.delayBeforeSpinnerShow ||
            minimalDelayBeforeSpinnerHide !== prevProps.minimalDelayBeforeSpinnerHide) {
            this.spinnerTask.update({
                delayBeforeTaskStart: delayBeforeSpinnerShow,
                durationOfTask: minimalDelayBeforeSpinnerHide,
            });
        }
        if (active !== prevProps.active) {
            active ? this.spinnerTask.start() : this.spinnerTask.stop();
        }
        if (isLoaderActive !== prevState.isLoaderActive) {
            if (isLoaderActive) {
                this.disableChildrenFocus();
            }
            else {
                this.enableChildrenFocus();
            }
        }
    };
    Loader.prototype.componentWillUnmount = function () {
        this.makeUnobservable();
        if (this.layoutEvents) {
            this.layoutEvents.remove();
        }
        this.spinnerTask.clearTask();
    };
    Loader.getDerivedStateFromProps = function (props, state) {
        if (props.active && !state.isLoaderActive) {
            return {
                isLoaderActive: true,
            };
        }
        if (state.isLoaderActive && !(props.active || state.isSpinnerVisible)) {
            return {
                isLoaderActive: false,
            };
        }
        return state;
    };
    Loader.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = theme;
            return _this.renderMain();
        }));
    };
    Loader.prototype.renderMain = function () {
        var _a;
        var _b = this.props, caption = _b.caption, component = _b.component;
        var type = this.getProps().type;
        var isLoaderActive = this.state.isLoaderActive;
        return (React.createElement(CommonWrapper, __assign({ rootNodeRef: this.setRootNode }, this.props),
            React.createElement("div", { className: styles$9.loader(), "data-tid": this.props['data-tid'] || (isLoaderActive ? LoaderDataTids.veil : LoaderDataTids.idle) },
                React.createElement(ZIndex, { applyZIndex: isLoaderActive, coverChildren: isLoaderActive, style: { height: '100%' }, wrapperRef: this.childrenRef }, this.props.children),
                isLoaderActive && (React.createElement(ZIndex, { wrapperRef: this.spinnerRef, className: cx((_a = {},
                        _a[styles$9.active(this.theme)] = isLoaderActive,
                        _a)) }, this.state.isSpinnerVisible && this.renderSpinner(type, caption, component))))));
    };
    Loader.prototype.renderSpinner = function (type, caption, component) {
        var _a;
        var _this = this;
        return (React.createElement("span", { "data-tid": LoaderDataTids.spinner, className: cx(styles$9.spinnerContainer(), (_a = {}, _a[styles$9.spinnerContainerSticky()] = this.state.isStickySpinner, _a)), style: this.state.spinnerStyle },
            React.createElement("div", { className: styles$9.spinnerComponentWrapper(), ref: function (element) {
                    _this.spinnerNode = element;
                } }, component !== undefined ? component : React.createElement(Spinner, { type: type, caption: caption }))));
    };
    var Loader_1;
    Loader.__KONTUR_REACT_UI__ = 'Loader';
    Loader.displayName = 'Loader';
    Loader.defaultProps = {
        type: 'normal',
        active: false,
        delayBeforeSpinnerShow: isTestEnv$1 ? 0 : 300,
        minimalDelayBeforeSpinnerHide: isTestEnv$1 ? 0 : 1000,
    };
    Loader = Loader_1 = __decorate([
        rootNode
    ], Loader);
    return Loader;
})(React.Component));

// Заглушка нужна для корректной гидрации порталов после SSR,
// которую реакт сам пока не поддерживает.
// @see https://github.com/facebook/react/issues/13097
// А также для вставки актуального render-container-id на клиенте.
//
// Дело в том, что во время гидрации, структура HTML на сервере
// и на клиенте должна совпадать, иначе возможны артефакты.
// Алгоритм там примерно такой. Клиент во время гидрации идет
// по этим двум деревьям и сравнивает узлы. Элементы разных типов
// он подменяет на свои. А те, что совпадают, он оставляет как есть
// вместе со всеми атрибутами, навесив только обработчики событий.
//
// Поэтому, для портала, который рендерится только на клиенте,
// нужно использовать серверную заглушку, чтобы при гидрации
// он не испортил какой-то другой элемент. Null не подходит,
// т.к. на сервере он тоже не рендерится.
// А элемент с render-container-id нужно отрендерить с нуля.
var SSRPlaceholder = function () { return React.createElement("script", { "data-id": "ssr-placeholder" }); };
var Portal = function (_a) {
    var _b;
    var container = _a.container, rt_rootID = _a.rt_rootID, children = _a.children;
    // container exists only in browser
    return (React.createElement(React.Fragment, null,
        container ? ReactDOM.createPortal(children, container) : React.createElement(SSRPlaceholder, null),
        container ? React.createElement("noscript", __assign({}, (_b = {}, _b[PORTAL_INLET_ATTR] = rt_rootID, _b))) : React.createElement(SSRPlaceholder, null)));
};
var RenderInnerContainer = /** @class */ (function (_super) {
    __extends(RenderInnerContainer, _super);
    function RenderInnerContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderInnerContainer.prototype.render = function () {
        var _a = this.props, anchor = _a.anchor, children = _a.children, domContainer = _a.domContainer, rootId = _a.rootId;
        var inner = anchor;
        if (children) {
            inner = (React.createElement(React.Fragment, null,
                anchor,
                React.createElement(Portal, { key: "portal-ref", rt_rootID: rootId, container: domContainer }, children)));
        }
        return inner;
    };
    RenderInnerContainer.__KONTUR_REACT_UI__ = 'RenderInnerContainer';
    RenderInnerContainer.displayName = 'RenderInnerContainer';
    return RenderInnerContainer;
}(React.Component));
Portal.__KONTUR_REACT_UI__ = 'Portal';
Portal.displayName = 'Portal';

var PORTAL_INLET_ATTR = 'data-render-container-id';
var PORTAL_OUTLET_ATTR = 'data-rendered-container-id';
var RenderContainer = /** @class */ (function (_super) {
    __extends(RenderContainer, _super);
    function RenderContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domContainer = null;
        _this.rootId = RenderContainer.getRootId();
        return _this;
    }
    RenderContainer.prototype.shouldComponentUpdate = function (nextProps) {
        if (!this.props.children && nextProps.children) {
            this.mountContainer();
        }
        if (this.props.children && !nextProps.children) {
            this.unmountContainer();
        }
        return true;
    };
    RenderContainer.prototype.componentWillUnmount = function () {
        this.destroyContainer();
    };
    RenderContainer.prototype.render = function () {
        if (this.props.children) {
            this.mountContainer();
        }
        return React.createElement(RenderInnerContainer, __assign({}, this.props, { domContainer: this.domContainer, rootId: this.rootId }));
    };
    RenderContainer.prototype.createContainer = function () {
        var _a;
        var domContainer = (_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.createElement('div');
        if (domContainer) {
            domContainer.setAttribute('class', Upgrade.getSpecificityClassName());
            domContainer.setAttribute(PORTAL_OUTLET_ATTR, "".concat(this.rootId));
            this.domContainer = domContainer;
        }
    };
    RenderContainer.prototype.mountContainer = function () {
        var _a, _b;
        var globalWithReactTesting = globalObject.globalObject;
        if (!this.domContainer) {
            this.createContainer();
        }
        if (this.domContainer && this.domContainer.parentNode !== ((_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.body)) {
            (_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.body.appendChild(this.domContainer);
            if (this.props.containerRef) {
                callChildRef(this.props.containerRef, this.domContainer);
            }
            if (globalWithReactTesting.ReactTesting) {
                globalWithReactTesting.ReactTesting.addRenderContainer(this.rootId, this);
            }
        }
    };
    RenderContainer.prototype.destroyContainer = function () {
        if (this.domContainer) {
            this.unmountContainer();
            this.domContainer = null;
        }
    };
    RenderContainer.prototype.unmountContainer = function () {
        if (this.domContainer && this.domContainer.parentNode) {
            this.domContainer.parentNode.removeChild(this.domContainer);
            if (this.props.containerRef) {
                callChildRef(this.props.containerRef, null);
            }
            var globalWithReactTesting = globalObject.globalObject;
            if (globalWithReactTesting.ReactTesting) {
                globalWithReactTesting.ReactTesting.removeRenderContainer(this.rootId);
            }
        }
    };
    RenderContainer.__KONTUR_REACT_UI__ = 'RenderContainer';
    RenderContainer.displayName = 'RenderContainer';
    RenderContainer.getRootId = function () { return getRandomID(); };
    return RenderContainer;
}(React.Component));

var calculatePriority = function (priority) {
    if (typeof priority === 'string') {
        return componentPriorities[priority];
    }
    return priority;
};
var componentPriorities = {
    MobilePopup: 9000,
    Toast: 10000,
    GlobalLoader: 10,
    Sidepage: 9,
    Modal: 9,
    Sticky: 7,
    PopupMenu: 5,
    Popup: 3,
};
var priorityStep = 1000;
var globalWithRetailUiZIndexes = globalObject.globalObject;
var getZIndexes = function () {
    return globalWithRetailUiZIndexes.__RetailUiZIndexes || (globalWithRetailUiZIndexes.__RetailUiZIndexes = [0]);
};
var getIndexPriority = function (zIndex) { return Math.trunc(zIndex / priorityStep); };
var getMaxAllowedValue = function (priority) { return (priority + 1) * priorityStep - 1; };
var upperBorder = getMaxAllowedValue(Math.max.apply(Math, Object.values(componentPriorities)));
function incrementZIndex(priority, delta) {
    var calculatedPriority = calculatePriority(priority);
    var maxAllowedValue = getMaxAllowedValue(calculatedPriority);
    var zIndexes = getZIndexes();
    var prevIndexId = zIndexes.length - 1;
    while (zIndexes[prevIndexId] > maxAllowedValue && prevIndexId > 0) {
        prevIndexId--;
    }
    var zIndex = getIndexPriority(zIndexes[prevIndexId]) === calculatedPriority
        ? Math.min(zIndexes[prevIndexId] + delta, maxAllowedValue)
        : calculatedPriority * priorityStep;
    zIndexes.push(zIndex);
    zIndexes.sort(function (a, b) { return a - b; });
    return zIndex;
}
function removeZIndex(zIndex) {
    var zIndexes = getZIndexes();
    var i = zIndexes.indexOf(zIndex);
    if (i !== -1) {
        zIndexes.splice(i, 1);
    }
}

var DEFAULT_ZINDEX_CONTEXT = { parentLayerZIndex: 0, maxZIndex: Infinity };
var ZIndexContext = React.createContext(DEFAULT_ZINDEX_CONTEXT);
ZIndexContext.displayName = 'ZIndexContext';
var ZIndex = /** @class */ (function (_super) {
    __extends(ZIndex, _super);
    function ZIndex(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            zIndex: 0,
            DOMZIndexContext: null,
        };
        _this.getProps = createPropsGetter$1(ZIndex_1.defaultProps);
        _this.zIndexContext = null;
        _this.wrapperRef = function (element) {
            var wrapperRef = _this.props.wrapperRef;
            _this.setRootNode(element);
            wrapperRef && callChildRef(wrapperRef, element);
            element && _this.tryGetContextByDOM(element);
        };
        _this.increment = function () {
            var _a = _this.getProps(), priority = _a.priority, delta = _a.delta;
            return incrementZIndex(priority, delta);
        };
        _this.tryGetContextByDOM = function (element) {
            var _a, _b, _c, _d;
            if (_this.props.applyZIndex &&
                isEqual$1(DEFAULT_ZINDEX_CONTEXT, _this.zIndexContext) &&
                _this.state.DOMZIndexContext === null) {
                var DOMZIndexContext = DEFAULT_ZINDEX_CONTEXT;
                var portal = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.closest("[".concat(PORTAL_OUTLET_ATTR, "]"));
                if (isInstanceOf(portal, globalObject.globalObject.HTMLElement)) {
                    var portalID = portal.getAttribute(PORTAL_OUTLET_ATTR);
                    var noscript = (_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.querySelector("noscript[".concat(PORTAL_INLET_ATTR, "=\"").concat(portalID, "\"]"));
                    var parent_1 = (_c = noscript === null || noscript === void 0 ? void 0 : noscript.parentElement) === null || _c === void 0 ? void 0 : _c.closest('[style*=z-index]');
                    if (isInstanceOf(parent_1, globalObject.globalObject.HTMLElement)) {
                        var newZIndex = Number(parent_1.style.zIndex || 0);
                        var maxZIndex = Infinity;
                        if (((_d = parent_1.parentElement) === null || _d === void 0 ? void 0 : _d.dataset.tid) === LoaderDataTids.veil) {
                            maxZIndex = _this.calcZIndex(newZIndex, maxZIndex);
                        }
                        DOMZIndexContext = { maxZIndex: maxZIndex, parentLayerZIndex: newZIndex };
                    }
                }
                _this.setState({ DOMZIndexContext: DOMZIndexContext });
            }
        };
        _this.state.zIndex = _this.increment();
        return _this;
    }
    ZIndex_1 = ZIndex;
    ZIndex.prototype.validateProps = function (delta) {
        warning((delta || ZIndex_1.defaultProps.delta) > 0, "[ZIndex]: Prop 'delta' must be greater than 0, received ".concat(delta));
        warning(Math.trunc(delta || ZIndex_1.defaultProps.delta) === delta, "[ZIndex]: Prop 'delta' must be integer, received ".concat(delta));
    };
    ZIndex.prototype.componentDidUpdate = function (prevProps) {
        var props = this.getProps();
        this.validateProps(props.delta);
        if (prevProps.priority !== props.priority || prevProps.delta !== props.delta) {
            removeZIndex(this.state.zIndex);
            this.setState({ zIndex: this.increment() });
        }
    };
    ZIndex.prototype.componentWillUnmount = function () {
        removeZIndex(this.state.zIndex);
    };
    ZIndex.prototype.render = function () {
        var _this = this;
        var _a = this.getProps(), style = _a.style, children = _a.children; _a.delta; _a.priority; var applyZIndex = _a.applyZIndex, coverChildren = _a.coverChildren, createStackingContext = _a.createStackingContext; _a.wrapperRef; var useWrapper = _a.useWrapper, rest = __rest(_a, ["style", "children", "delta", "priority", "applyZIndex", "coverChildren", "createStackingContext", "wrapperRef", "useWrapper"]);
        var wrapperStyle = {};
        return (React.createElement(ZIndexContext.Consumer, null, function (context) {
            _this.zIndexContext = context;
            var currentZIndexContext = _this.state.DOMZIndexContext && isEqual$1(context, DEFAULT_ZINDEX_CONTEXT)
                ? _this.state.DOMZIndexContext
                : context;
            var parentLayerZIndex = currentZIndexContext.parentLayerZIndex, maxZIndex = currentZIndexContext.maxZIndex;
            var newZIndexContext = currentZIndexContext;
            var newZIndex = 0;
            if (applyZIndex) {
                newZIndex = _this.calcZIndex(parentLayerZIndex, maxZIndex);
                wrapperStyle.zIndex = newZIndex;
                newZIndexContext = coverChildren
                    ? { parentLayerZIndex: parentLayerZIndex, maxZIndex: newZIndex }
                    : { parentLayerZIndex: newZIndex, maxZIndex: Number.isFinite(maxZIndex) ? newZIndex : Infinity };
                if (createStackingContext) {
                    globalObject.isBrowser(globalObject.globalObject) && 'isolation' in globalObject.globalObject.document.body.style
                        ? (wrapperStyle.isolation = 'isolate')
                        : (wrapperStyle.transform = 'rotate(0)');
                }
            }
            var child = !useWrapper ? (children) : (React.createElement("div", __assign({ style: __assign(__assign({}, style), wrapperStyle), ref: _this.wrapperRef }, rest), children));
            return React.createElement(ZIndexContext.Provider, { value: newZIndexContext }, child);
        }));
    };
    ZIndex.prototype.calcZIndex = function (parentLayerZIndex, maxZIndex) {
        var newZIndex = this.state.zIndex;
        if (Number.isFinite(maxZIndex)) {
            var allowedValuesIntervalLength = maxZIndex - parentLayerZIndex;
            var scale = upperBorder / allowedValuesIntervalLength;
            newZIndex = Math.ceil(newZIndex / scale);
        }
        newZIndex += parentLayerZIndex;
        return newZIndex;
    };
    var ZIndex_1;
    ZIndex.priorities = componentPriorities;
    ZIndex.__KONTUR_REACT_UI__ = 'ZIndex';
    ZIndex.displayName = 'ZIndex';
    ZIndex.defaultProps = {
        delta: 10,
        priority: 0,
        style: {},
        applyZIndex: true,
        coverChildren: false,
        createStackingContext: false,
        useWrapper: true,
    };
    ZIndex = ZIndex_1 = __decorate([
        rootNode
    ], ZIndex);
    return ZIndex;
}(React.Component));

var eventListenersMap = new Map();
function addResponsiveLayoutListener(mediaQuery, callback) {
    if (eventListenersMap.has(mediaQuery)) {
        addCallbackToMQListener(mediaQuery, callback);
    }
    else {
        createMQListener(mediaQuery, callback);
    }
    return {
        remove: function () {
            removeCallbackFromMQListener(mediaQuery, callback);
        },
    };
}
function addCallbackToMQListener(mediaQuery, callback) {
    var eventListener = eventListenersMap.get(mediaQuery);
    if (eventListener) {
        eventListenersMap.set(mediaQuery, __assign(__assign({}, eventListener), { listeners: __spreadArray(__spreadArray([], eventListener.listeners, true), [callback], false) }));
    }
}
function createMQListener(mediaQuery, callback) {
    var _a;
    var mql = (_a = globalObject.globalObject.matchMedia) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, mediaQuery);
    if (mql) {
        var newMediaQueryInfo = { mql: mql, listeners: [callback] };
        eventListenersMap.set(mediaQuery, newMediaQueryInfo);
        if (mql.addEventListener) {
            mql.addEventListener('change', changeCallback);
        }
        else {
            mql.addListener(changeCallback);
        }
    }
}
function removeCallbackFromMQListener(mediaQuery, callback) {
    if (eventListenersMap.has(mediaQuery)) {
        var eventListener = eventListenersMap.get(mediaQuery);
        if (eventListener) {
            var newListeners = eventListener.listeners.filter(function (listener) { return listener !== callback; });
            if (newListeners.length === 0) {
                if (eventListener.mql.removeEventListener) {
                    eventListener.mql.removeEventListener('change', changeCallback);
                }
                else {
                    eventListener.mql.removeListener(changeCallback);
                }
                eventListenersMap.delete(mediaQuery);
                return;
            }
            eventListenersMap.set(mediaQuery, __assign(__assign({}, eventListener), { listeners: __spreadArray([], newListeners, true) }));
        }
    }
}
function checkMatches(mediaQuery) {
    var _a, _b;
    if (!globalObject.globalObject.matchMedia) {
        return false;
    }
    if (!eventListenersMap.has(mediaQuery)) {
        return !!((_a = globalObject.globalObject.matchMedia(mediaQuery)) === null || _a === void 0 ? void 0 : _a.matches);
    }
    var eventListener = eventListenersMap.get(mediaQuery);
    return (_b = eventListener === null || eventListener === void 0 ? void 0 : eventListener.mql.matches) !== null && _b !== void 0 ? _b : false;
}
function changeCallback(e) {
    var eventListener = eventListenersMap.get(e.media);
    if (eventListener) {
        eventListener.listeners.forEach(function (listener) {
            listener(e);
        });
    }
}

function useResponsiveLayout(_a) {
    var _b = _a === void 0 ? {} : _a, customMediaQueries = _b.customMediaQueries;
    var theme = React.useContext(ThemeContext);
    var allMediaQueries = Object.entries(__assign({ isMobile: theme.mobileMediaQuery }, customMediaQueries)).map(function (_a) {
        var key = _a[0], value = _a[1];
        return ({
            flag: key,
            query: value,
            ref: React.createRef(),
        });
    });
    var getLayoutFromGlobal = function () {
        return allMediaQueries.reduce(function (result, mediaQuery) {
            var _a;
            return Object.assign(result, (_a = {}, _a[mediaQuery.flag] = checkMatches(mediaQuery.query), _a));
        }, {});
    };
    var _c = React.useState(getLayoutFromGlobal()), state = _c[0], setState = _c[1];
    var prepareMediaQueries = React.useCallback(function () {
        if (!theme) {
            return;
        }
        allMediaQueries.forEach(function (mediaQuery) {
            return (mediaQuery.ref.current = addResponsiveLayoutListener(mediaQuery.query, checkLayoutsMediaQueries));
        });
        // Checking for SSR use case
        var globalLayout = getLayoutFromGlobal();
        var hasChangedQuery = Object.entries(globalLayout).find(function (_a) {
            var key = _a[0], value = _a[1];
            return state[key] !== value;
        });
        if (hasChangedQuery) {
            setState(globalLayout);
        }
    }, [theme]);
    var checkLayoutsMediaQueries = React.useCallback(function (e) {
        if (!theme) {
            return;
        }
        allMediaQueries.forEach(function (mediaQuery) {
            if (e.media === mediaQuery.query) {
                setState(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[mediaQuery.flag] = e.matches, _a)));
                });
            }
        });
    }, [theme]);
    React.useEffect(function () {
        prepareMediaQueries();
        return function () {
            allMediaQueries.forEach(function (mediaQuery) { var _a; return (_a = mediaQuery.ref.current) === null || _a === void 0 ? void 0 : _a.remove(); });
        };
    }, []);
    return state;
}

/**
 * Компонент `ResponsiveLayout` для определения текущего лэйаута.
 */
function ResponsiveLayout(props) {
    var _a, _b;
    var layoutFlags = useResponsiveLayout({ customMediaQueries: props.customMediaQueries });
    React.useEffect(function () {
        if (props.onLayoutChange) {
            props.onLayoutChange(layoutFlags);
        }
    }, [layoutFlags]);
    return (React.createElement(CommonWrapper, __assign({}, props), isFunction(props.children) ? (_a = props.children(layoutFlags)) !== null && _a !== void 0 ? _a : null : (_b = props.children) !== null && _b !== void 0 ? _b : null));
}
ResponsiveLayout.__KONTUR_REACT_UI__ = 'ResponsiveLayout';
ResponsiveLayout.displayName = 'ResponsiveLayout';

function responsiveLayout(WrappedComp) {
    var ComponentWithLayout = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.renderWithLayout = function (currentLayout) {
                _this.layout = currentLayout;
                return _super.prototype.render.call(_this);
            };
            return _this;
        }
        Object.defineProperty(class_1.prototype, "currentLayout", {
            get: function () {
                return this.layout;
            },
            set: function (value) {
                //
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "isMobileLayout", {
            get: function () {
                return this.layout.isMobile;
            },
            set: function (value) {
                //
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype.render = function () {
            return React.createElement(ResponsiveLayout, null, this.renderWithLayout);
        };
        return class_1;
    }(WrappedComp));
    var nameDescriptor = Object.getOwnPropertyDescriptor(ComponentWithLayout, 'name');
    if (!nameDescriptor || nameDescriptor.configurable) {
        Object.defineProperty(ComponentWithLayout, 'name', { value: WrappedComp.name });
    }
    return ComponentWithLayout;
}

var scrollbarWidth = null;
function getScrollWidth() {
    if (!globalObject.globalObject.document) {
        return 0;
    }
    var body = globalObject.globalObject.document.body;
    if (!body) {
        throw Error('There is no "body" element in "document"');
    }
    if (scrollbarWidth !== null) {
        return scrollbarWidth;
    }
    var div = globalObject.globalObject.document.createElement('div');
    div.innerHTML = 'a'; // In IE clientWidth is 0 if this div is empty.
    div.style.overflowY = 'scroll';
    body.appendChild(div);
    // At least in jest it's NaN.
    scrollbarWidth = div.offsetWidth - div.clientWidth || 0;
    body.removeChild(div);
    return scrollbarWidth;
}

var disposeDocumentStyle = null;
var HideBodyVerticalScroll = /** @class */ (function (_super) {
    __extends(HideBodyVerticalScroll, _super);
    function HideBodyVerticalScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialScroll = 0;
        _this.master = false;
        _this.restoreStyles = function () {
            if (disposeDocumentStyle) {
                disposeDocumentStyle();
                disposeDocumentStyle = null;
                if (globalObject.globalObject.document) {
                    globalObject.globalObject.document.documentElement.scrollTop = _this.initialScroll;
                }
            }
        };
        return _this;
    }
    HideBodyVerticalScroll.prototype.componentDidMount = function () {
        var _a, _b;
        var counter = VerticalScrollCounter.increment();
        if (counter === 1) {
            this.master = true;
            this.initialScroll = ((_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.documentElement) ? globalObject.globalObject.document.documentElement.scrollTop : 0;
            HideBodyVerticalScroll.updateScrollVisibility();
            (_b = globalObject.globalObject.addEventListener) === null || _b === void 0 ? void 0 : _b.call(globalObject.globalObject, 'resize', HideBodyVerticalScroll.updateScrollVisibility);
        }
    };
    HideBodyVerticalScroll.prototype.componentDidUpdate = function () {
        if (this.master) {
            HideBodyVerticalScroll.updateScrollVisibility();
        }
    };
    HideBodyVerticalScroll.prototype.componentWillUnmount = function () {
        var _a;
        var counter = VerticalScrollCounter.decrement();
        if (counter === 0) {
            this.restoreStyles();
            (_a = globalObject.globalObject.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'resize', HideBodyVerticalScroll.updateScrollVisibility);
        }
    };
    HideBodyVerticalScroll.prototype.render = function () {
        return null;
    };
    HideBodyVerticalScroll.__KONTUR_REACT_UI__ = 'HideBodyVerticalScroll';
    HideBodyVerticalScroll.displayName = 'HideBodyVerticalScroll';
    HideBodyVerticalScroll.updateScrollVisibility = function () {
        var shouldHide = !disposeDocumentStyle;
        if (shouldHide) {
            HideBodyVerticalScroll.hideScroll();
        }
    };
    HideBodyVerticalScroll.hideScroll = function () {
        if (!globalObject.isBrowser(globalObject.globalObject)) {
            return;
        }
        var documentElement = globalObject.globalObject.document.documentElement;
        var clientHeight = documentElement.clientHeight, scrollHeight = documentElement.scrollHeight;
        var documentComputedStyle = globalObject.globalObject.getComputedStyle(documentElement);
        var scrollbarConst = globalObject.globalObject.getComputedStyle(documentElement).overflowY === 'scroll';
        var scrollWidth = clientHeight < scrollHeight || scrollbarConst ? getScrollWidth() : 0;
        var documentMargin = parseFloat(documentComputedStyle.marginRight || '');
        var className = generateDocumentStyle(documentMargin + scrollWidth);
        disposeDocumentStyle = HideBodyVerticalScroll.attachStyle(documentElement, className);
    };
    HideBodyVerticalScroll.attachStyle = function (element, className) {
        element.classList.add(className);
        return function () {
            element.classList.remove(className);
        };
    };
    return HideBodyVerticalScroll;
}(React.Component));
var VerticalScrollCounter = /** @class */ (function () {
    function VerticalScrollCounter() {
    }
    VerticalScrollCounter.increment = function () {
        var globalWithRetailUIVerticalScrollCounter = globalObject.globalObject;
        var counter = globalWithRetailUIVerticalScrollCounter.RetailUIVerticalScrollCounter || 0;
        return (globalWithRetailUIVerticalScrollCounter.RetailUIVerticalScrollCounter = counter + 1);
    };
    VerticalScrollCounter.decrement = function () {
        var globalWithRetailUIVerticalScrollCounter = globalObject.globalObject;
        var counter = globalWithRetailUIVerticalScrollCounter.RetailUIVerticalScrollCounter || 0;
        return (globalWithRetailUIVerticalScrollCounter.RetailUIVerticalScrollCounter = counter - 1);
    };
    VerticalScrollCounter.get = function () {
        var globalWithRetailUIVerticalScrollCounter = globalObject.globalObject;
        return globalWithRetailUIVerticalScrollCounter.RetailUIVerticalScrollCounter || 0;
    };
    return VerticalScrollCounter;
}());
function generateDocumentStyle(documentMargin) {
    return css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    overflow: hidden !important;\n    margin-right: ", "px !important;\n    height: 100%;\n  "], ["\n    overflow: hidden !important;\n    margin-right: ", "px !important;\n    height: 100%;\n  "])), documentMargin);
}
var templateObject_1$a;

var _a$1, _b;
var handlers = [];
function addHandleEvent() {
    var _a;
    /**
     * Firefox do not supports 'focusin' event.
     * Focus events bubbles multiple time
     * without possibilty to cancell bubbling.
     * Using debounce to capture only first focus event
     * Mozilla Firefix
     *   ¯\_(ツ)_/¯
     */
    (_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.body.addEventListener(isFirefox ? 'focus' : 'focusin', isFirefox ? debounce$1(handleNativeFocus, 0, { leading: true, trailing: false }) : handleNativeFocus, { capture: true });
}
if (((_a$1 = globalObject.globalObject.document) === null || _a$1 === void 0 ? void 0 : _a$1.readyState) === 'complete') {
    addHandleEvent();
}
else {
    (_b = globalObject.globalObject.addEventListener) === null || _b === void 0 ? void 0 : _b.call(globalObject.globalObject, 'load', addHandleEvent);
}
function handleNativeFocus(event) {
    // FIXME: not safe casting
    var target = (event.target || event.srcElement);
    handlers.forEach(function (handler) {
        var elements = handler.elements;
        if (typeof elements === 'function') {
            elements = elements();
        }
        if (elements.some(containsTargetOrRenderContainer(target))) {
            return;
        }
        ReactDOM.unstable_batchedUpdates(function () { return handler.callback(event); });
    });
}
function containsTargetOrRenderContainer(target) {
    return function (element) {
        if (!element) {
            return false;
        }
        if (element.contains(target)) {
            return true;
        }
        var container = findRenderContainer(target, element);
        return !!container && element.contains(container);
    };
}
/**
 * Searches RenderContainer placed in "rootNode" for "node"
 */
function findRenderContainer(node, rootNode, container) {
    var _a, _b, _c;
    var currentNode = node.parentNode;
    if (!currentNode ||
        node === rootNode ||
        currentNode === rootNode ||
        currentNode === ((_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.body) ||
        currentNode === ((_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.documentElement) ||
        !isInstanceOf(currentNode, globalObject.globalObject.Element)) {
        return container ? container : null;
    }
    var newContainerId = currentNode.getAttribute(PORTAL_OUTLET_ATTR);
    if (newContainerId) {
        var nextNode = (_c = globalObject.globalObject.document) === null || _c === void 0 ? void 0 : _c.querySelector("[".concat(PORTAL_INLET_ATTR, "~=\"").concat(newContainerId, "\"]"));
        if (!nextNode) {
            throw Error("Origin node for render container was not found");
        }
        return findRenderContainer(nextNode, rootNode, nextNode);
    }
    return findRenderContainer(currentNode, rootNode, container);
}
function listen(elements, callback) {
    var handler = {
        elements: elements,
        callback: callback,
    };
    handlers.push(handler);
    return {
        remove: function () {
            var index = handlers.indexOf(handler);
            if (index > -1) {
                handlers.splice(index, 1);
            }
        },
    };
}

var RenderLayer = /** @class */ (function (_super) {
    __extends(RenderLayer, _super);
    function RenderLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter$1(RenderLayer_1.defaultProps);
        _this.focusOutsideListenerToken = null;
        _this.handleFocusOutside = function (event) {
            if (_this.props.onFocusOutside) {
                _this.props.onFocusOutside(event);
            }
        };
        _this.handleNativeDocClick = function (event) {
            var target = event.target || event.srcElement;
            var node = _this.getAnchorNode();
            if (!node || (isInstanceOf(target, globalObject.globalObject.Element) && containsTargetOrRenderContainer(target)(node))) {
                return;
            }
            if (_this.props.onClickOutside) {
                _this.props.onClickOutside(event);
            }
        };
        return _this;
    }
    RenderLayer_1 = RenderLayer;
    RenderLayer.prototype.componentDidMount = function () {
        if (this.getProps().active) {
            this.attachListeners();
        }
    };
    RenderLayer.prototype.componentDidUpdate = function (prevProps) {
        var active = this.getProps().active;
        if (!prevProps.active && active) {
            this.attachListeners();
        }
        if (prevProps.active && !active) {
            this.detachListeners();
        }
    };
    RenderLayer.prototype.componentWillUnmount = function () {
        if (this.getProps().active) {
            this.detachListeners();
        }
    };
    RenderLayer.prototype.render = function () {
        return (React.createElement(CommonWrapper, __assign({ rootNodeRef: this.setRootNode }, this.props), React.Children.only(this.props.children)));
    };
    RenderLayer.prototype.getAnchorNode = function () {
        var getAnchorElement = this.props.getAnchorElement;
        return getAnchorElement ? getAnchorElement() : getRootNode$2(this);
    };
    RenderLayer.prototype.attachListeners = function () {
        var _a, _b;
        var node = this.getAnchorNode();
        if (!node) {
            return;
        }
        this.focusOutsideListenerToken = listen(function () { return [node]; }, this.handleFocusOutside);
        (_a = globalObject.globalObject.addEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'blur', this.handleFocusOutside);
        (_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.addEventListener('ontouchstart' in globalObject.globalObject.document.documentElement && 'onpointerup' in globalObject.globalObject.document.documentElement
            ? 'pointerup'
            : 'mousedown', this.handleNativeDocClick);
    };
    RenderLayer.prototype.detachListeners = function () {
        var _a, _b;
        if (this.focusOutsideListenerToken) {
            this.focusOutsideListenerToken.remove();
            this.focusOutsideListenerToken = null;
        }
        (_a = globalObject.globalObject.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'blur', this.handleFocusOutside);
        (_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.removeEventListener('ontouchstart' in globalObject.globalObject.document.documentElement && 'onpointerup' in globalObject.globalObject.document.documentElement
            ? 'pointerup'
            : 'mousedown', this.handleNativeDocClick);
    };
    var RenderLayer_1;
    RenderLayer.__KONTUR_REACT_UI__ = 'RenderLayer';
    RenderLayer.displayName = 'RenderLayer';
    RenderLayer.defaultProps = {
        active: true,
    };
    RenderLayer = RenderLayer_1 = __decorate([
        rootNode
    ], RenderLayer);
    return RenderLayer;
}(React.Component));

var styles$8 = {
    root: function (t) {
        return css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n      width: 100%;\n      height: 100%;\n      flex-direction: column;\n      display: flex;\n      justify-content: flex-end;\n      border-radius: ", ";\n      overflow: hidden;\n      padding-bottom: ", ";\n      background: ", ";\n    "], ["\n      width: 100%;\n      height: 100%;\n      flex-direction: column;\n      display: flex;\n      justify-content: flex-end;\n      border-radius: ", ";\n      overflow: hidden;\n      padding-bottom: ", ";\n      background: ", ";\n    "])), t.mobilePopupContainerBorderRadius, t.mobilePopupContainerBottomPadding, t.menuBgDefault);
    },
    wrapper: function () {
        return css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      overflow: auto;\n    "], ["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      overflow: auto;\n    "])));
    },
    content: function (t) {
        return css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), t.bgDefault);
    },
    container: function (t) {
        return css(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n      position: absolute;\n      top: ", ";\n      left: ", ";\n      right: ", ";\n      z-index: 100000;\n    "], ["\n      position: absolute;\n      top: ", ";\n      left: ", ";\n      right: ", ";\n      z-index: 100000;\n    "])), t.mobilePopupTopPadding, t.mobilePopupOuterIndentY, t.mobilePopupOuterIndentY);
    },
    bg: function () {
        return css(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      z-index: 9999;\n      background: #333333;\n      pointer-events: none;\n      opacity: 50%;\n    "], ["\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      z-index: 9999;\n      background: #333333;\n      pointer-events: none;\n      opacity: 50%;\n    "])));
    },
    bottomIndent: function () {
        return css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n      height: 80px;\n    "], ["\n      height: 80px;\n    "])));
    },
    zIndex: function () {
        return css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n      position: relative;\n    "], ["\n      position: relative;\n    "])));
    },
};
var jsStyles$2 = memoizeStyle(styles$8);
var templateObject_1$9, templateObject_2$5, templateObject_3$5, templateObject_4$5, templateObject_5$4, templateObject_6$2, templateObject_7$2;

var styles$7 = {
    root: function (t) {
        return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n      position: relative;\n      padding: ", ";\n    "], ["\n      position: relative;\n      padding: ", ";\n    "])), t.mobilePopupHeaderPadding);
    },
    rootWithoutContent: function () {
        return css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n      padding: 8px 0 0 0;\n    "], ["\n      padding: 8px 0 0 0;\n    "])));
    },
    container: function () {
        return css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n    "], ["\n      display: flex;\n      flex-direction: column;\n    "])));
    },
    caption: function (t) {
        return css(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n    "], ["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n    "])), t.mobilePopupHeaderFontSize, t.mobilePopupHeaderLineHeight, t.mobilePopupHeaderFontWeight, t.textColorDefault);
    },
    captionWithChildren: function () {
        return css(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n      padding-bottom: 8px;\n    "], ["\n      padding-bottom: 8px;\n    "])));
    },
};
var jsStyles$1 = memoizeStyle(styles$7);
var templateObject_1$8, templateObject_2$4, templateObject_3$4, templateObject_4$4, templateObject_5$3;

var MobilePopupHeader = /** @class */ (function (_super) {
    __extends(MobilePopupHeader, _super);
    function MobilePopupHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobilePopupHeader.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = theme;
            return _this.renderMain();
        }));
    };
    MobilePopupHeader.prototype.renderMain = function () {
        var _a, _b;
        var _c = this.props, caption = _c.caption, children = _c.children;
        return (React.createElement("div", { className: cx((_a = {},
                _a[jsStyles$1.root(this.theme)] = true,
                _a[jsStyles$1.rootWithoutContent()] = !caption && !children,
                _a)) },
            React.createElement("div", { className: jsStyles$1.container() },
                caption && (React.createElement("div", { className: cx((_b = {},
                        _b[jsStyles$1.caption(this.theme)] = true,
                        _b[jsStyles$1.captionWithChildren()] = isNonNullable$1(children),
                        _b)) }, caption)),
                React.isValidElement(children) && React.createElement("div", null, children))));
    };
    MobilePopupHeader.__KONTUR_REACT_UI__ = 'MobileMenuHeader';
    MobilePopupHeader.displayName = 'MobileMenuHeader';
    return MobilePopupHeader;
}(React.Component));

var styles$6 = {
    root: function (t) {
        return css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      padding: ", ";\n    "], ["\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      padding: ", ";\n    "])), t.mobilePopupHeaderPadding);
    },
};
var jsStyles = memoizeStyle(styles$6);
var templateObject_1$7;

var MobilePopupFooter = /** @class */ (function (_super) {
    __extends(MobilePopupFooter, _super);
    function MobilePopupFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobilePopupFooter.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = theme;
            return _this.renderMain();
        }));
    };
    MobilePopupFooter.prototype.renderMain = function () {
        var children = this.props.children;
        if (!children || !React.isValidElement(children)) {
            return null;
        }
        return React.createElement("div", { className: jsStyles.root(this.theme) }, children);
    };
    MobilePopupFooter.__KONTUR_REACT_UI__ = 'MobileMenuFooter';
    return MobilePopupFooter;
}(React.Component));

var MobilePopupDataTids = {
    root: 'MobilePopup__root',
    container: 'MobilePopup__container',
};
var MobilePopup = /** @class */ (function (_super) {
    __extends(MobilePopup, _super);
    function MobilePopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.close = function () {
            if (_this.props.onCloseRequest) {
                _this.props.onCloseRequest();
            }
        };
        return _this;
    }
    MobilePopup.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = theme;
            return _this.renderMain();
        }));
    };
    MobilePopup.prototype.renderMain = function () {
        var content = (React.createElement(ZIndex, { id: this.props.id, className: jsStyles$2.zIndex(), priority: 'MobilePopup' },
            React.createElement(Transition, { in: this.props.opened, onExited: this.props.onClose, mountOnEnter: true, unmountOnExit: true, timeout: 0 },
                React.createElement("div", { className: jsStyles$2.wrapper() },
                    React.createElement(RenderLayer, { onClickOutside: this.close },
                        React.createElement("div", { ref: this.setRootNode, "data-tid": MobilePopupDataTids.container, className: jsStyles$2.container(this.theme) },
                            React.createElement("div", { "data-tid": MobilePopupDataTids.root, className: jsStyles$2.root(this.theme) },
                                React.createElement(MobilePopupHeader, { caption: this.props.caption }, this.props.headerChildComponent),
                                React.createElement("div", { className: jsStyles$2.content(this.theme) }, this.props.children),
                                React.createElement(MobilePopupFooter, null, this.props.footerChildComponent)),
                            React.createElement("div", { onClick: this.close, className: jsStyles$2.bottomIndent() }))),
                    React.createElement("div", { className: jsStyles$2.bg() }),
                    React.createElement(HideBodyVerticalScroll, null)))));
        if (this.props.withoutRenderContainer) {
            return content;
        }
        return React.createElement(RenderContainer, null, content);
    };
    MobilePopup.__KONTUR_REACT_UI__ = 'MobileMenuHeader';
    MobilePopup.displayName = 'MobileMenuHeader';
    // see #2873 and #2895
    MobilePopup.defaultRootNode = null;
    MobilePopup = __decorate([
        rootNode
    ], MobilePopup);
    return MobilePopup;
}(React.Component));

var isInstanceWithAnchorElement = function (instance) {
    return Boolean(instance) && Object.prototype.hasOwnProperty.call(instance, 'getAnchorElement');
};

var reactUIFeatureFlagsDefault = {
    dateInputFixSameNumberTypingOnRefocus: false,
    dateInputAllowInvalidValuesInDays: false,
    comboBoxAllowValueChangeInEditingState: false,
    stickyReduceLayoutEvents: false,
    radioGroupRemoveBaselineSpacer: false,
    groupAddHintAndTooltipSupport: false,
    popupFixPinTearing: false,
    autocompleteUseMaskedInput: false,
    fxInputUseMaskedInput: false,
    sidePageDisableHeaderShrink: false,
    sidePageNotCutTitleOnStuckByDefault: false,
    tokenInputCreateTokenOnBlurInWithoutReferenceMode: false,
    textareaBaselineAlign: false,
};
var ReactUIFeatureFlagsContext = React.createContext(reactUIFeatureFlagsDefault);
ReactUIFeatureFlagsContext.displayName = 'ReactUIFeatureFlagsContext';
ReactUIFeatureFlagsContext.__KONTUR_REACT_UI__ = 'ReactUIFeatureFlagsContext';

var getFullReactUIFlagsContext = function (flags) {
    return __assign(__assign({}, reactUIFeatureFlagsDefault), flags);
};

var CALLBACK_AS_KEY = { callbackAsKey: true };
var cache = new WeakMap();
/**
 * Позволяет объединить несколько параметров ref в один вызов, в котором во все переданные параметры просетится ref.
 *
 * Кеширует результат возвращаемой функции, так что при одинаковых входных параметрах React-у будет возвращена одинаковая функция.
 * Это позволит не вызывать лишние commitAttachRef и commitDetachRef и не ловить сайдэффекты связанные со значением ref в моменте
 *
 * Не прокидывай в параметрах стрелочные функции, так результат не будет закеширован.
 *
 * @returns function that passed refs: (...refs) =>
 *
 * @example
 * const SomeComponent = forwardRef((props, ref) => {
 *  const localRef = useRef();
 *  return <div ref={mergeRefs(localRef, ref)} />;
 * });
 */
function mergeRefs() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var cacheLevel = getLeafRefInCache.apply(void 0, refs);
    var cachedCallback = cacheLevel.get(CALLBACK_AS_KEY);
    if (cachedCallback && typeof cachedCallback === 'function') {
        return cachedCallback;
    }
    var newRefCallback = createRefCallback(refs);
    cacheLevel.set(CALLBACK_AS_KEY, newRefCallback);
    return newRefCallback;
}
function createRefCallback(refs) {
    function applyRef(value) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                return ref(value);
            }
            else if (isNonNullable$1(ref)) {
                return (ref.current = value);
            }
        });
    }
    return applyRef;
}
function getLeafRefInCache() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var cacheLevel = cache;
    for (var _a = 0, refs_1 = refs; _a < refs_1.length; _a++) {
        var ref = refs_1[_a];
        if (isNullable$1(ref)) {
            continue;
        }
        var child = cacheLevel.get(ref);
        if (child && typeof child !== 'function') {
            cacheLevel = child;
        }
        else {
            var leaf = new WeakMap();
            cacheLevel.set(ref, leaf);
            cacheLevel = leaf;
        }
    }
    return cacheLevel;
}

function getPositionObject(position) {
    var x = position.split(' ');
    return {
        direction: x[0],
        align: x[1],
    };
}
function getElementAbsoluteRect(element) {
    var rect = _getElementRelativeRect(element);
    return convertRectToAbsolute(rect);
}
function isAbsoluteRectFullyVisible(coordinates, popupRect) {
    var windowRelativeRect = _getWindowRelativeRect();
    var windowAbsoluteRect = convertRectToAbsolute(windowRelativeRect);
    var absoluteRect = {
        top: coordinates.top,
        left: coordinates.left,
        height: popupRect.height,
        width: popupRect.width,
    };
    return _rectContainsRect(windowAbsoluteRect, absoluteRect);
}
// Can become fully visible by scrolling into viewport
function canBecomeFullyVisible(positionName, coordinates) {
    var position = getPositionObject(positionName);
    if (position.direction === 'top') {
        var availableScrollDistances = convertRectToAbsolute(_getWindowRelativeRect());
        return coordinates.top + availableScrollDistances.top >= 0;
    }
    if (position.direction === 'left') {
        var availableScrollDistances = convertRectToAbsolute(_getWindowRelativeRect());
        return coordinates.left + availableScrollDistances.left >= 0;
    }
    // NOTE: for bottom/right cases browser will always expand document size
    return true;
}
function _getElementRelativeRect(element) {
    var rect = getDOMRect(element);
    return {
        top: rect.top,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top,
    };
}
function _getWindowRelativeRect() {
    return {
        top: 0,
        left: 0,
        width: _getViewProperty(function (x) { return x.clientWidth; }) || globalObject.globalObject.innerWidth || 0,
        height: _getViewProperty(function (x) { return x.clientHeight; }) || globalObject.globalObject.innerHeight || 0,
    };
}
function convertRectToAbsolute(rect) {
    var offset = _getAbsoluteOffset();
    return {
        top: rect.top + offset.top,
        left: rect.left + offset.left,
        width: rect.width,
        height: rect.height,
    };
}
function _getAbsoluteOffset() {
    var scrollTop = globalObject.globalObject.pageYOffset || _getViewProperty(function (x) { return x.scrollTop; });
    var scrollLeft = globalObject.globalObject.pageXOffset || _getViewProperty(function (x) { return x.scrollLeft; });
    var clientTop = _getViewProperty(function (x) { return x.clientTop; });
    var clientLeft = _getViewProperty(function (x) { return x.clientLeft; });
    var top = scrollTop - clientTop;
    var left = scrollLeft - clientLeft;
    return {
        top: top,
        left: left,
    };
}
function _rectContainsRect(outerRect, innerRect) {
    return (innerRect.top > outerRect.top &&
        innerRect.top + innerRect.height < outerRect.top + outerRect.height &&
        innerRect.left > outerRect.left &&
        innerRect.left + innerRect.width < outerRect.left + outerRect.width);
}
function _getViewProperty(getProperty) {
    var _a, _b;
    var views = [(_a = globalObject.globalObject.document) === null || _a === void 0 ? void 0 : _a.documentElement, (_b = globalObject.globalObject.document) === null || _b === void 0 ? void 0 : _b.body];
    return views.map(function (x) { return x && getProperty(x); }).find(Boolean) || 0;
}
var PopupHelper = {
    getPositionObject: getPositionObject,
    getElementAbsoluteRect: getElementAbsoluteRect,
    isFullyVisible: isAbsoluteRectFullyVisible,
    canBecomeFullyVisible: canBecomeFullyVisible,
};

var styles$5 = memoizeStyle({
    pin: function () {
        return css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n      position: absolute;\n    "], ["\n      position: absolute;\n    "])));
    },
    pinTop: function () {
        return css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n      clip-path: polygon(0 0, 50% 100%, 100% 0);\n    "], ["\n      clip-path: polygon(0 0, 50% 100%, 100% 0);\n    "])));
    },
    pinBottom: function () {
        return css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n      clip-path: polygon(0 100%, 50% 0, 100% 100%);\n    "], ["\n      clip-path: polygon(0 100%, 50% 0, 100% 100%);\n    "])));
    },
    pinLeft: function () {
        return css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n      clip-path: polygon(0 0, 100% 50%, 0 100%);\n    "], ["\n      clip-path: polygon(0 0, 100% 50%, 0 100%);\n    "])));
    },
    pinRight: function () {
        return css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n      clip-path: polygon(100% 0, 0 50%, 100% 100%);\n    "], ["\n      clip-path: polygon(100% 0, 0 50%, 100% 100%);\n    "])));
    },
});
var templateObject_1$6, templateObject_2$3, templateObject_3$3, templateObject_4$3, templateObject_5$2;

var PopupPinNew = /** @class */ (function (_super) {
    __extends(PopupPinNew, _super);
    function PopupPinNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPinInlineStyle = function (left, top) {
            var _a, _b;
            var direction = _this.getPopupOppositeDirection();
            if (!direction) {
                return;
            }
            // Добавляем запас в 1px, чтобы пофиксить случайные отделения пинов
            var correctedLeft = left - 1;
            var correctedTop = top - 1;
            var correctedSize = _this.props.size + 1;
            switch (direction) {
                case 'top':
                case 'bottom':
                    return _a = {},
                        _a[direction] = -_this.props.size + 'px',
                        _a.left = correctedLeft + 'px',
                        _a.width = correctedSize * 2 + 'px',
                        _a.height = correctedSize + 'px',
                        _a.backgroundColor = _this.props.backgroundColor,
                        _a;
                case 'left':
                case 'right':
                    return _b = {},
                        _b[direction] = -_this.props.size + 'px',
                        _b.top = correctedTop + 'px',
                        _b.height = correctedSize * 2 + 'px',
                        _b.width = correctedSize + 'px',
                        _b.backgroundColor = _this.props.backgroundColor,
                        _b;
                default:
                    console.error("Can't get inline style: invalid direction '".concat(direction, "'. Returning default"));
            }
        };
        _this.getPinCoordinates = function (popupElement) {
            var popupRect = PopupHelper.getElementAbsoluteRect(popupElement);
            var _a = _this.positionObject, direction = _a.direction, align = _a.align;
            switch (direction) {
                case 'top':
                    return {
                        top: popupRect.height,
                        left: _this.getPinLeftCoordinate(popupRect, align),
                    };
                case 'bottom':
                    return {
                        top: -2 * _this.props.size,
                        left: _this.getPinLeftCoordinate(popupRect, align),
                    };
                case 'left':
                    return {
                        top: _this.getPinTopCoordinate(popupRect, align),
                        left: popupRect.width,
                    };
                case 'right':
                    return {
                        top: _this.getPinTopCoordinate(popupRect, align),
                        left: -2 * _this.props.size,
                    };
                default:
                    console.error("Can't get coordinate: invalid direction '".concat(direction, "'."));
            }
        };
        _this.getPinTopCoordinate = function (popupRect, align) {
            switch (align) {
                case 'top':
                    return _this.props.offset;
                case 'middle':
                    return popupRect.height / 2 - _this.props.size;
                case 'bottom':
                    return popupRect.height - _this.props.offset - 2 * _this.props.size;
                default:
                    console.error("Can't get coordinate: invalid align '".concat(align, "'."));
            }
        };
        _this.getPinLeftCoordinate = function (popupRect, align) {
            switch (align) {
                case 'left':
                    return _this.props.offset;
                case 'center':
                    return popupRect.width / 2 - _this.props.size;
                case 'right':
                    return popupRect.width - _this.props.offset - 2 * _this.props.size;
                default:
                    console.error("Can't get coordinate: invalid align '".concat(align, "'."));
            }
        };
        _this.getPinDirectionalStyle = function () {
            switch (_this.positionObject.direction) {
                case 'top':
                    return styles$5.pinTop();
                case 'bottom':
                    return styles$5.pinBottom();
                case 'left':
                    return styles$5.pinLeft();
                case 'right':
                    return styles$5.pinRight();
                default:
                    console.error("Can't get directional style: invalid direction '".concat(_this.positionObject.direction, "'."));
            }
        };
        return _this;
    }
    PopupPinNew.prototype.render = function () {
        if (!this.props.popupElement) {
            return null;
        }
        this.positionObject = PopupHelper.getPositionObject(this.props.popupPosition);
        var coords = this.getPinCoordinates(this.props.popupElement);
        if (!coords || !coords.left || !coords.top) {
            return null;
        }
        var inlineStyle = this.getPinInlineStyle(coords.left, coords.top);
        var directionalStyle = this.getPinDirectionalStyle();
        if (!inlineStyle || !directionalStyle) {
            return null;
        }
        return (React.createElement("div", { "data-tid": PopupDataTids.popupPin, className: cx(styles$5.pin(), directionalStyle), style: inlineStyle }));
    };
    PopupPinNew.prototype.getPopupOppositeDirection = function () {
        var popupDirection = PopupHelper.getPositionObject(this.props.popupPosition).direction;
        switch (popupDirection) {
            case 'top':
                return 'bottom';
            case 'bottom':
                return 'top';
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                console.error("Can't get opposite direction: invalid direction '".concat(popupDirection, "'"));
        }
    };
    PopupPinNew.__KONTUR_REACT_UI__ = 'PopupPin';
    PopupPinNew.displayName = 'PopupPin';
    return PopupPinNew;
}(React.Component));

var styles$4 = memoizeStyle({
    popup: function (t) {
        return css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n      position: absolute;\n      border-radius: ", ";\n      border: ", " ", ";\n      display: flex;\n      width: max-content;\n    "], ["\n      position: absolute;\n      border-radius: ", ";\n      border: ", " ", ";\n      display: flex;\n      width: max-content;\n    "])), t.popupBorderRadius, t.popupBorder, t.popupBorderColor);
    },
    popupIgnoreHover: function () {
        return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
    },
    content: function (t) {
        return css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n      overflow: hidden;\n      border-radius: ", ";\n      flex-shrink: 0;\n      max-width: 100%;\n      line-height: normal;\n    "], ["\n      overflow: hidden;\n      border-radius: ", ";\n      flex-shrink: 0;\n      max-width: 100%;\n      line-height: normal;\n    "])), t.popupBorderRadius);
    },
    contentInner: function (t) {
        return css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n      color: ", ";\n      background: ", ";\n    "], ["\n      color: ", ";\n      background: ", ";\n    "])), t.popupTextColor, t.popupBackground);
    },
    shadow: function (t) {
        return css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), t.popupBoxShadow);
    },
    transitionEnter: function () {
        return css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n      opacity: 0.01;\n    "], ["\n      opacity: 0.01;\n    "])));
    },
    'transition-enter-top': function () {
        return css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n      transform: translateY(10px);\n    "], ["\n      transform: translateY(10px);\n    "])));
    },
    'transition-enter-middle': function () {
        return css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject([""], [""])));
    },
    'transition-enter-bottom': function () {
        return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      transform: translateY(-10px);\n    "], ["\n      transform: translateY(-10px);\n    "])));
    },
    'transition-enter-left': function () {
        return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      transform: translateX(10px);\n    "], ["\n      transform: translateX(10px);\n    "])));
    },
    'transition-enter-right': function () {
        return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      transform: translateX(-10px);\n    "], ["\n      transform: translateX(-10px);\n    "])));
    },
    transitionEnterActive: function () {
        return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      transition:\n        transform 0.18s cubic-bezier(0.22, 0.61, 0.36, 1),\n        opacity 0.18s cubic-bezier(0.22, 0.61, 0.36, 1);\n      opacity: 1;\n      transform: translate(0, 0);\n    "], ["\n      transition:\n        transform 0.18s cubic-bezier(0.22, 0.61, 0.36, 1),\n        opacity 0.18s cubic-bezier(0.22, 0.61, 0.36, 1);\n      opacity: 1;\n      transform: translate(0, 0);\n    "])));
    },
    transitionExit: function () {
        return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      opacity: 0.01;\n      transition: opacity 0.15s ease-out;\n      transform: translate(0, 0);\n    "], ["\n      opacity: 0.01;\n      transition: opacity 0.15s ease-out;\n      transform: translate(0, 0);\n    "])));
    },
    absoluteParent: function () {
        return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      position: absolute;\n      text-align: initial;\n    "], ["\n      position: absolute;\n      text-align: initial;\n    "])));
    },
});
var templateObject_1$5, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;

var styles$3 = memoizeStyle({
    wrapper: function () {
        return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n      overflow: hidden;\n      position: absolute;\n      pointer-events: none;\n    "], ["\n      overflow: hidden;\n      position: absolute;\n      pointer-events: none;\n    "])));
    },
});
var templateObject_1$4;

var borderStyles = {
    position: 'absolute',
    borderStyle: 'solid',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
};
var PopupPin = /** @class */ (function (_super) {
    __extends(PopupPin, _super);
    function PopupPin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupPin.prototype.render = function () {
        if (!this.props.popupElement) {
            return null;
        }
        var options = this.getPinOptions(PopupHelper.getElementAbsoluteRect(this.props.popupElement), PopupHelper.getPositionObject(this.props.popupPosition), this.props.size, this.props.offset, this.props.borderWidth);
        var styleOuter = this.getOuterStyle(options.activeBorder, options.outerSize, this.props.borderColor);
        var styleInner = this.getInnerStyle(options.activeBorder, this.props.size, this.props.backgroundColor);
        var styleWrapper = this.getWrapperStyle(options.outerLeft, options.outerTop, options.outerSize);
        return (React.createElement("div", { "data-tid": PopupDataTids.popupPin, className: styles$3.wrapper(), style: styleWrapper },
            React.createElement("div", { style: styleOuter },
                React.createElement("div", { style: styleInner }))));
    };
    PopupPin.prototype.getPopupOppositeDirection = function () {
        var popupDirection = PopupHelper.getPositionObject(this.props.popupPosition).direction;
        switch (popupDirection) {
            case 'top':
                return 'bottom';
            case 'bottom':
                return 'top';
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            default:
                throw new TypeError('Unknown direction ' + popupDirection);
        }
    };
    PopupPin.prototype.getWrapperStyle = function (left, top, borderWidth) {
        var _a, _b;
        var direction = this.getPopupOppositeDirection();
        switch (direction) {
            case 'top':
            case 'bottom':
                return _a = {},
                    _a[direction] = -borderWidth + 'px',
                    _a.left = left + 'px',
                    _a.width = borderWidth * 2 + 'px',
                    _a.height = borderWidth + 'px',
                    _a;
            case 'left':
            case 'right':
                return _b = {},
                    _b[direction] = -borderWidth + 'px',
                    _b.top = top + 'px',
                    _b.height = borderWidth * 2 + 'px',
                    _b.width = borderWidth + 'px',
                    _b;
            default:
                throw new TypeError('Unknown direction ' + direction);
        }
    };
    PopupPin.prototype.getOuterStyle = function (activeBorder, borderWitdth, borderColor) {
        var _a, _b;
        var direction = this.getPopupOppositeDirection();
        switch (direction) {
            case 'top':
            case 'bottom':
                return __assign(__assign({}, borderStyles), (_a = {}, _a[direction] = -borderWitdth + 'px', _a.left = '0px', _a.borderWidth = borderWitdth + 'px', _a['border' + activeBorder + 'Color'] = borderColor, _a));
            case 'left':
            case 'right':
                return __assign(__assign({}, borderStyles), (_b = {}, _b[direction] = -borderWitdth + 'px', _b.top = '0px', _b.borderWidth = borderWitdth + 'px', _b['border' + activeBorder + 'Color'] = borderColor, _b));
            default:
                throw new TypeError('Unknown direction ' + direction);
        }
    };
    PopupPin.prototype.getInnerStyle = function (activeBorder, borderWitdth, borderColor) {
        var _a, _b;
        var direction = this.getPopupOppositeDirection();
        switch (direction) {
            case 'top':
            case 'bottom':
                return __assign(__assign({}, borderStyles), (_a = {}, _a[direction] = -borderWitdth + 2 + 'px', _a.left = -borderWitdth + 'px', _a.borderWidth = borderWitdth + 'px', _a['border' + activeBorder + 'Color'] = borderColor, _a));
            case 'left':
            case 'right':
                return __assign(__assign({}, borderStyles), (_b = {}, _b[direction] = -borderWitdth + 2 + 'px', _b.top = -borderWitdth + 'px', _b.borderWidth = borderWitdth + 'px', _b['border' + activeBorder + 'Color'] = borderColor, _b));
            default:
                throw new TypeError('Unknown direction ' + direction);
        }
    };
    PopupPin.prototype.getPinOptions = function (popupRect, popupPosition, pinSize, pinOffset, borderWidth) {
        var bordersDelta = 2 * borderWidth;
        var outerSize = pinSize + bordersDelta;
        switch (popupPosition.direction) {
            case 'top':
                return {
                    outerTop: popupRect.height,
                    outerLeft: this.getPinLeftCoordinate(popupRect, popupPosition.align, pinSize, pinOffset) - bordersDelta,
                    innerTop: -outerSize,
                    innerLeft: -outerSize + bordersDelta,
                    activeBorder: 'Top',
                    outerSize: outerSize,
                };
            case 'bottom':
                return {
                    outerTop: -2 * outerSize,
                    outerLeft: this.getPinLeftCoordinate(popupRect, popupPosition.align, pinSize, pinOffset) - bordersDelta,
                    innerTop: -outerSize + 2 * bordersDelta,
                    innerLeft: -outerSize + bordersDelta,
                    activeBorder: 'Bottom',
                    outerSize: outerSize,
                };
            case 'left':
                return {
                    outerTop: this.getPinTopCoordinate(popupRect, popupPosition.align, pinSize, pinOffset) - bordersDelta,
                    outerLeft: popupRect.width,
                    innerTop: -outerSize + bordersDelta,
                    innerLeft: -outerSize,
                    activeBorder: 'Left',
                    outerSize: outerSize,
                };
            case 'right':
                return {
                    outerTop: this.getPinTopCoordinate(popupRect, popupPosition.align, pinSize, pinOffset) - bordersDelta,
                    outerLeft: -2 * outerSize,
                    innerTop: -outerSize + bordersDelta,
                    innerLeft: -outerSize + 2 * bordersDelta,
                    activeBorder: 'Right',
                    outerSize: outerSize,
                };
            default:
                throw new Error('Direction must be one of top, right, bottom, left');
        }
    };
    PopupPin.prototype.getPinTopCoordinate = function (popupRect, align, pinHeight, pinOffset) {
        switch (align) {
            case 'top':
                return pinOffset;
            case 'middle':
                return popupRect.height / 2 - pinHeight;
            case 'bottom':
                return popupRect.height - pinOffset - 2 * pinHeight;
            default:
                throw new Error("Unexpected align '".concat(align, "'"));
        }
    };
    PopupPin.prototype.getPinLeftCoordinate = function (popupRect, align, pinHeight, pinOffset) {
        switch (align) {
            case 'left':
                return pinOffset;
            case 'center':
                return popupRect.width / 2 - pinHeight;
            case 'right':
                return popupRect.width - pinOffset - 2 * pinHeight;
            default:
                throw new Error("Unexpected align '".concat(align, "'"));
        }
    };
    PopupPin.__KONTUR_REACT_UI__ = 'PopupPin';
    PopupPin.displayName = 'PopupPin';
    return PopupPin;
}(React.Component));

var POPUP_BORDER_DEFAULT_COLOR = 'transparent';
var TRANSITION_TIMEOUT = { enter: 0, exit: 200 };
var PopupNonPinnablePositions = ['middle center', 'middle left', 'middle right'];
var PopupPinnablePositions = [
    'top center',
    'top left',
    'top right',
    'bottom center',
    'bottom left',
    'bottom right',
    'left middle',
    'left top',
    'left bottom',
    'right middle',
    'right top',
    'right bottom',
];
var PopupPositions = __spreadArray(__spreadArray([], PopupPinnablePositions, true), PopupNonPinnablePositions, true);
var DefaultPosition = PopupPositions[0];
var DUMMY_LOCATION = {
    position: DefaultPosition,
    coordinates: {
        top: -9999,
        left: -9999,
    },
    isFullyVisible: false,
};
var PopupDataTids = {
    root: 'Popup__root',
    content: 'PopupContent',
    contentInner: 'PopupContentInner',
    popupPin: 'PopupPin__root',
};
var PopupIds = {
    root: PopupDataTids.root,
};
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter$1(Popup_1.defaultProps);
        _this.state = { location: _this.props.opened ? DUMMY_LOCATION : null };
        _this.locationUpdateId = null;
        _this.refForTransition = React.createRef();
        _this.hasAnchorElementListeners = false;
        _this.rootId = PopupIds.root + getRandomID();
        _this.anchorElement = null;
        _this.absoluteParent = null;
        _this.renderInPortal = function (anchor, ref) {
            var location = _this.state.location;
            return (React.createElement(RenderContainer, { anchor: anchor, ref: ref }, _this.isMobileLayout && !_this.props.withoutMobile
                ? _this.renderMobile()
                : location && _this.renderContent(location)));
        };
        _this.renderWithoutPortal = function (anchor, ref) {
            var location = _this.state.location;
            return (React.createElement(EmptyWrapper, { ref: ref },
                anchor,
                location && (React.createElement("div", { ref: _this.updateAbsoluteElement, className: styles$4.absoluteParent() }, _this.renderContent(location)))));
        };
        _this.updateAnchorElement = function (instance) {
            var childDomNode = isInstanceWithAnchorElement(instance) ? instance.getAnchorElement() : getRootNode$2(instance);
            var anchorElement = _this.anchorElement;
            if (childDomNode !== anchorElement) {
                _this.removeEventListeners(anchorElement);
                _this.anchorElement = childDomNode;
                _this.addEventListeners(childDomNode);
            }
        };
        _this.updateAbsoluteElement = function (instance) {
            _this.absoluteParent = instance;
        };
        _this.handleMouseEnter = function (event) {
            if (_this.props.onMouseEnter) {
                _this.props.onMouseEnter(event);
            }
        };
        _this.handleMouseLeave = function (event) {
            if (_this.props.onMouseLeave) {
                _this.props.onMouseLeave(event);
            }
        };
        _this.handleClick = function (event) {
            if (_this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        _this.handleFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleBlur = function (event) {
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.calculateWidth = function (width) {
            if (typeof width === 'string' && width.includes('%')) {
                var anchorWidth_1 = getDOMRect(_this.anchorElement).width;
                return width.replace(/(\d)+%/g, function (percent) { return "".concat((anchorWidth_1 * parseFloat(percent)) / 100, "px"); });
            }
            return width;
        };
        _this.content = function (children) {
            var backgroundColor = _this.props.backgroundColor;
            var _a = _this.getProps(), width = _a.width, minWidth = _a.minWidth;
            return (React.createElement("div", { className: styles$4.content(_this.theme), "data-tid": PopupDataTids.content, ref: mergeRefs(_this.refForTransition, _this.refPopupContentElement) },
                React.createElement("div", { className: styles$4.contentInner(_this.theme), style: { backgroundColor: backgroundColor, width: _this.calculateWidth(width), minWidth: _this.calculateWidth(minWidth) }, "data-tid": PopupDataTids.contentInner }, children)));
        };
        _this.prepareDataVisualState = function () {
            var _a;
            var _b;
            var position = (_b = _this.state.location) === null || _b === void 0 ? void 0 : _b.position;
            if (position) {
                var attrName = "position-" + position.replace(' ', '-');
                return getVisualStateDataAttributes((_a = {}, _a[attrName] = true, _a));
            }
            return {};
        };
        _this.resetLocation = function () {
            _this.cancelDelayedUpdateLocation();
            _this.state.location !== null && _this.setState({ location: null });
        };
        _this.refPopupContentElement = function (element) {
            _this.lastPopupContentElement = element;
        };
        _this.handleLayoutEvent = function () {
            if (!_this.state.location) {
                return;
            }
            _this.updateLocation();
        };
        _this.updateLocation = function () {
            var _a, _b;
            var popupContentElement = _this.lastPopupContentElement;
            if (!popupContentElement) {
                return;
            }
            var location = _this.getLocation(popupContentElement, _this.state.location);
            if (location) {
                (_b = (_a = _this.props).onPositionChange) === null || _b === void 0 ? void 0 : _b.call(_a, location.position, location.isFullyVisible);
            }
            if (!_this.locationEquals(_this.state.location, location)) {
                _this.setState({ location: location });
            }
        };
        _this.getRelativeShift = function () {
            var absoluteParent = _this.absoluteParent;
            if (!_this.props.disablePortal || !absoluteParent) {
                return {
                    top: 0,
                    left: 0,
                };
            }
            var rect = PopupHelper.getElementAbsoluteRect(absoluteParent);
            return {
                top: -rect.top,
                left: -rect.left,
            };
        };
        return _this;
    }
    Popup_1 = Popup;
    Popup.prototype.componentDidMount = function () {
        this.updateLocation();
        this.layoutEventsToken = addListener(this.handleLayoutEvent);
        if (!this.hasAnchorElementListeners) {
            this.addEventListeners(this.anchorElement);
        }
    };
    Popup.getDerivedStateFromProps = function (props, state) {
        /**
         * Delaying updateLocation to ensure it happens after props update
         */
        if (props.opened) {
            if (!state.location) {
                return { location: DUMMY_LOCATION };
            }
        }
        else if (state.location) {
            return { location: DUMMY_LOCATION };
        }
        return state;
    };
    Popup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var hadNoLocation = prevState.location === DUMMY_LOCATION;
        var hasLocation = this.state.location !== DUMMY_LOCATION;
        var wasClosed = prevProps.opened && !this.props.opened;
        if (this.isMobileLayout && prevState.location === null && this.state.location === null) {
            this.setState({ location: DUMMY_LOCATION });
        }
        if (this.props.opened && hadNoLocation && hasLocation && this.props.onOpen) {
            this.props.onOpen();
        }
        if (wasClosed && !hasLocation && this.props.onClose) {
            this.props.onClose();
        }
        if (this.props.opened) {
            this.delayUpdateLocation();
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        this.cancelDelayedUpdateLocation();
        if (this.hasAnchorElementListeners) {
            this.removeEventListeners(this.anchorElement);
        }
        if (this.layoutEventsToken) {
            this.layoutEventsToken.remove();
            this.layoutEventsToken = null;
        }
        if (this.state.location && this.props.onClose) {
            this.props.onClose();
        }
    };
    Popup.prototype.render = function () {
        var _this = this;
        return (React.createElement(ReactUIFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = getFullReactUIFlagsContext(flags);
            return (React.createElement(ThemeContext.Consumer, null, function (theme) {
                _this.theme = theme;
                return _this.renderMain();
            }));
        }));
    };
    Popup.prototype.renderMobile = function () {
        var opened = this.props.opened;
        var children = this.renderChildren();
        return children ? (React.createElement(CommonWrapper, { rootNodeRef: this.setRootNode },
            React.createElement(MobilePopup, { opened: opened, withoutRenderContainer: true, onCloseRequest: this.props.mobileOnCloseRequest }, this.content(children)))) : null;
    };
    Popup.prototype.renderMain = function () {
        var anchorElement = this.props.anchorElement;
        var useWrapper = this.getProps().useWrapper;
        var anchor = null;
        if (isInstanceOf(anchorElement, globalObject.globalObject.Element)) {
            this.updateAnchorElement(anchorElement);
        }
        else if (React.isValidElement(anchorElement)) {
            anchor = useWrapper ? React.createElement("span", null, anchorElement) : anchorElement;
        }
        else {
            anchor = React.createElement("span", null, anchorElement);
        }
        var anchorWithRef = anchor && React.isValidElement(anchor) && isRefableElement(anchor)
            ? React.cloneElement(anchor, {
                ref: mergeRefs(anchor === null || anchor === void 0 ? void 0 : anchor.ref, this.updateAnchorElement),
            })
            : null;
        // we need to get anchor's DOM node
        // so we either set our own ref on it via cloning
        // or relay on findDOMNode (inside getRootNode)
        // which should be called within updateAnchorElement
        // in the case when the anchor is not refable
        var canGetAnchorNode = !!anchorWithRef || isInstanceOf(anchorElement, globalObject.globalObject.Element);
        var renderRef = canGetAnchorNode ? null : this.updateAnchorElement;
        var renderAnchor = anchorWithRef || anchor;
        return this.props.disablePortal
            ? this.renderWithoutPortal(renderAnchor, renderRef)
            : this.renderInPortal(renderAnchor, renderRef);
    };
    Popup.prototype.addEventListeners = function (element) {
        if (element && isInstanceOf(element, globalObject.globalObject.Element)) {
            // @ts-expect-error: Type ElementEventMap is missing events: https://github.com/skbkontur/retail-ui/pull/2946#discussion_r931072657
            element.addEventListener('mouseenter', this.handleMouseEnter);
            // @ts-expect-error: See the comment above
            element.addEventListener('mouseleave', this.handleMouseLeave);
            // @ts-expect-error: See the comment above
            element.addEventListener('click', this.handleClick);
            element.addEventListener('focusin', this.handleFocus);
            element.addEventListener('focusout', this.handleBlur);
            this.hasAnchorElementListeners = true;
        }
    };
    Popup.prototype.removeEventListeners = function (element) {
        if (element && isInstanceOf(element, globalObject.globalObject.Element)) {
            // @ts-expect-error: Type ElementEventMap is missing events: https://github.com/skbkontur/retail-ui/pull/2946#discussion_r931072657
            element.removeEventListener('mouseenter', this.handleMouseEnter);
            // @ts-expect-error: See the comment above
            element.removeEventListener('mouseleave', this.handleMouseLeave);
            // @ts-expect-error: See the comment above
            element.removeEventListener('click', this.handleClick);
            element.removeEventListener('focusin', this.handleFocus);
            element.removeEventListener('focusout', this.handleBlur);
            this.hasAnchorElementListeners = false;
        }
    };
    Popup.prototype.renderContent = function (location) {
        var _this = this;
        var _a = this.props, maxWidth = _a.maxWidth, opened = _a.opened;
        var _b = this.getProps(), hasShadow = _b.hasShadow, disableAnimations = _b.disableAnimations, ignoreHover = _b.ignoreHover;
        var children = this.renderChildren();
        var relativeShift = this.getRelativeShift();
        var direction = PopupHelper.getPositionObject(location.position).direction;
        var rootStyle = {
            maxWidth: maxWidth,
            top: location.coordinates.top + relativeShift.top,
            left: location.coordinates.left + relativeShift.left,
        };
        return (React.createElement(Transition, { timeout: TRANSITION_TIMEOUT, appear: !disableAnimations, in: Boolean(opened && children), mountOnEnter: true, unmountOnExit: true, enter: !disableAnimations, exit: !disableAnimations, onExited: this.resetLocation, nodeRef: this.refForTransition }, function (state) {
            var _a, _b;
            var _c;
            return (React.createElement(CommonWrapper, __assign({}, _this.props, { rootNodeRef: _this.setRootNode }, _this.prepareDataVisualState()),
                React.createElement(ZIndex, { id: (_c = _this.props.id) !== null && _c !== void 0 ? _c : _this.rootId, "data-tid": PopupDataTids.root, priority: _this.props.priority, className: cx(__assign((_a = {}, _a[styles$4.popup(_this.theme)] = true, _a[styles$4.shadow(_this.theme)] = hasShadow, _a[styles$4.popupIgnoreHover()] = ignoreHover, _a), (disableAnimations
                        ? {}
                        : (_b = {},
                            _b[styles$4["transition-enter-".concat(direction)](_this.theme)] = true,
                            _b[styles$4.transitionEnter()] = state === 'entering',
                            _b[styles$4.transitionEnterActive()] = state === 'entered',
                            _b[styles$4.transitionExit()] = state === 'exiting',
                            _b)))), style: rootStyle, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave },
                    _this.content(children),
                    (!_this.isMobileLayout || _this.props.withoutMobile) && _this.renderPin(location.position))));
        }));
    };
    Popup.prototype.renderChildren = function () {
        return isFunction(this.props.children) ? this.props.children() : this.props.children;
    };
    Popup.prototype.renderPin = function (positionName) {
        var isDefaultBorderColor = this.theme.popupBorderColor === POPUP_BORDER_DEFAULT_COLOR;
        var pinBorder = isIE11 && isDefaultBorderColor ? 'rgba(0, 0, 0, 0.09)' : this.theme.popupBorderColor;
        var _a = this.props, pinSize = _a.pinSize, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
        var _b = this.getProps(), hasShadow = _b.hasShadow, hasPin = _b.hasPin;
        var position = PopupHelper.getPositionObject(positionName);
        return (hasPin &&
            !PopupNonPinnablePositions.includes(positionName) &&
            (this.featureFlags.popupFixPinTearing ? (React.createElement(PopupPinNew, { popupElement: this.lastPopupContentElement, popupPosition: positionName, size: pinSize || parseInt(this.theme.popupPinSize), offset: this.getPinOffset(position.align), backgroundColor: backgroundColor || this.theme.popupBackground })) : (React.createElement(PopupPin, { popupElement: this.lastPopupContentElement, popupPosition: positionName, size: pinSize || parseInt(this.theme.popupPinSize), offset: this.getPinOffset(position.align), borderWidth: hasShadow ? 1 : 0, backgroundColor: backgroundColor || this.theme.popupBackground, borderColor: borderColor || pinBorder }))));
    };
    Popup.prototype.delayUpdateLocation = function () {
        var _a;
        this.cancelDelayedUpdateLocation();
        this.locationUpdateId = (_a = globalObject.globalObject.requestAnimationFrame) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, this.updateLocation);
    };
    Popup.prototype.cancelDelayedUpdateLocation = function () {
        var _a;
        if (this.locationUpdateId) {
            (_a = globalObject.globalObject.cancelAnimationFrame) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, this.locationUpdateId);
            this.locationUpdateId = null;
        }
    };
    Popup.prototype.locationEquals = function (x, y) {
        if (x === y) {
            return true;
        }
        if (isNullable$1(x) || isNullable$1(y)) {
            return false;
        }
        if (!isIE11 && !isEdge) {
            return (x.coordinates.left === y.coordinates.left &&
                x.coordinates.top === y.coordinates.top &&
                x.position === y.position);
        }
        // Для ie/edge обновляем позицию только при разнице минимум в 1. Иначе есть вероятность
        // уйти в бесконечный ререндер
        return (x.position === y.position &&
            Math.abs(x.coordinates.top - y.coordinates.top) <= 1 &&
            Math.abs(x.coordinates.left - y.coordinates.left) <= 1);
    };
    Popup.prototype.reorderPropsPositionsWithPriorityPos = function () {
        var positions = this.props.positions ? this.props.positions : PopupPinnablePositions;
        var pos_ = '';
        if (this.props.pos) {
            pos_ = this.props.pos;
        }
        else {
            pos_ = positions[0];
        }
        var index = positions.findIndex(function (position) { return position.startsWith(pos_); });
        if (index === -1) {
            warning(false, 'Unexpected position ' + pos_ + ' passed to Popup. Expected one of: ' + positions.join(', '));
            return positions;
        }
        return __spreadArray(__spreadArray([], positions.slice(index), true), positions.slice(0, index), true);
    };
    Popup.prototype.getLocation = function (popupElement, location) {
        var tryPreserveFirstRenderedPosition = this.getProps().tryPreserveFirstRenderedPosition;
        var positions = this.reorderPropsPositionsWithPriorityPos();
        var anchorElement = this.anchorElement;
        warning(anchorElement && isInstanceOf(anchorElement, globalObject.globalObject.Element), 'Anchor element is not defined or not instance of Element');
        if (!(anchorElement && isInstanceOf(anchorElement, globalObject.globalObject.Element))) {
            return location;
        }
        var anchorRect = PopupHelper.getElementAbsoluteRect(anchorElement);
        var popupRect = PopupHelper.getElementAbsoluteRect(popupElement);
        var position;
        var coordinates;
        if (location && location !== DUMMY_LOCATION && location.position) {
            position = location.position;
            coordinates = this.getCoordinates(anchorRect, popupRect, position);
            var isFullyVisible = PopupHelper.isFullyVisible(coordinates, popupRect);
            var canBecomeVisible = !isFullyVisible && PopupHelper.canBecomeFullyVisible(position, coordinates);
            if (
            // если нужно сохранить первоначальную позицию и Попап целиком
            // находится в пределах вьюпорта (или может быть проскроллен в него)
            (tryPreserveFirstRenderedPosition && (isFullyVisible || canBecomeVisible)) ||
                // если Попап целиком во вьюпорте и в самой приоритетной позиции
                // (иначе нужно попытаться позицию сменить)
                (isFullyVisible && position === positions[0])) {
                // сохраняем текущую позицию
                return { coordinates: coordinates, position: position, isFullyVisible: true };
            }
        }
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            position = positions_1[_i];
            coordinates = this.getCoordinates(anchorRect, popupRect, position);
            if (PopupHelper.isFullyVisible(coordinates, popupRect)) {
                return { coordinates: coordinates, position: position, isFullyVisible: true };
            }
        }
        position = positions[0];
        coordinates = this.getCoordinates(anchorRect, popupRect, position);
        return { coordinates: coordinates, position: position, isFullyVisible: false };
    };
    Popup.prototype.getPinnedPopupOffset = function (anchorRect, position) {
        if (!this.getProps().hasPin || /center|middle/.test(position.align)) {
            return 0;
        }
        var anchorSize = /top|bottom/.test(position.direction) ? anchorRect.width : anchorRect.height;
        var pinSize = this.props.pinSize;
        return Math.max(0, this.getPinOffset(position.align) + (pinSize || parseInt(this.theme.popupPinSize)) - anchorSize / 2);
    };
    Popup.prototype.getCoordinates = function (anchorRect, popupRect, positionName) {
        var marginFromProps = this.props.margin;
        var margin = isNonNullable$1(marginFromProps) && !isNaN(marginFromProps)
            ? marginFromProps
            : parseInt(this.theme.popupMargin) || 0;
        var position = PopupHelper.getPositionObject(positionName);
        var popupOffset = this.getProps().popupOffset + this.getPinnedPopupOffset(anchorRect, position);
        switch (position.direction) {
            case 'top':
                return {
                    top: anchorRect.top - popupRect.height - margin,
                    left: this.getHorizontalPosition(anchorRect, popupRect, position.align, popupOffset),
                };
            case 'middle':
                return {
                    top: anchorRect.top + anchorRect.height / 2 - popupRect.height / 2,
                    left: this.getHorizontalPosition(anchorRect, popupRect, position.align, popupOffset),
                };
            case 'bottom':
                return {
                    top: anchorRect.top + anchorRect.height + margin,
                    left: this.getHorizontalPosition(anchorRect, popupRect, position.align, popupOffset),
                };
            case 'left':
                return {
                    top: this.getVerticalPosition(anchorRect, popupRect, position.align, popupOffset),
                    left: anchorRect.left - popupRect.width - margin,
                };
            case 'right':
                return {
                    top: this.getVerticalPosition(anchorRect, popupRect, position.align, popupOffset),
                    left: anchorRect.left + anchorRect.width + margin,
                };
            default:
                throw new Error("Unexpected direction '".concat(position.direction, "'"));
        }
    };
    Popup.prototype.getPinOffset = function (align) {
        var pinOffset = this.props.pinOffset;
        switch (align) {
            case 'top':
            case 'bottom':
                return pinOffset || parseInt(this.theme.popupPinOffsetY);
            case 'left':
            case 'right':
                return pinOffset || parseInt(this.theme.popupPinOffsetX);
            case 'center':
            case 'middle':
                return 0;
            default:
                throw new Error("Unexpected align '".concat(align, "'"));
        }
    };
    Popup.prototype.getHorizontalPosition = function (anchorRect, popupRect, align, popupOffset) {
        switch (align) {
            case 'left':
                return anchorRect.left - popupOffset;
            case 'center':
                return anchorRect.left - (popupRect.width - anchorRect.width) / 2;
            case 'right':
                return anchorRect.left - (popupRect.width - anchorRect.width) + popupOffset;
            default:
                throw new Error("Unexpected align '".concat(align, "'"));
        }
    };
    Popup.prototype.getVerticalPosition = function (anchorRect, popupRect, align, popupOffset) {
        switch (align) {
            case 'top':
                return anchorRect.top - popupOffset;
            case 'middle':
                return anchorRect.top - (popupRect.height - anchorRect.height) / 2;
            case 'bottom':
                return anchorRect.top - (popupRect.height - anchorRect.height) + popupOffset;
            default:
                throw new Error("Unexpected align '".concat(align, "'"));
        }
    };
    var Popup_1;
    Popup.__KONTUR_REACT_UI__ = 'Popup';
    Popup.displayName = 'Popup';
    Popup.defaultProps = {
        popupOffset: 0,
        hasPin: false,
        hasShadow: false,
        disableAnimations: isTestEnv$1,
        useWrapper: false,
        ignoreHover: false,
        disablePortal: false,
        width: 'auto',
        priority: ZIndex.priorities.Popup,
    };
    // see #2873 and #2895
    Popup.defaultRootNode = null;
    Popup = Popup_1 = __decorate([
        responsiveLayout,
        rootNode
    ], Popup);
    return Popup;
}(React.Component));
var EmptyWrapper = /** @class */ (function (_super) {
    __extends(EmptyWrapper, _super);
    function EmptyWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyWrapper.prototype.render = function () {
        return this.props.children;
    };
    return EmptyWrapper;
}(React.Component));

var KeyboardEventCodes;
(function (KeyboardEventCodes) {
    KeyboardEventCodes["Unidentified"] = "Unidentified";
    KeyboardEventCodes["Escape"] = "Escape";
    KeyboardEventCodes["KeyA"] = "KeyA";
    KeyboardEventCodes["KeyC"] = "KeyC";
    KeyboardEventCodes["KeyV"] = "KeyV";
    KeyboardEventCodes["KeyX"] = "KeyX";
    KeyboardEventCodes["Enter"] = "Enter";
    KeyboardEventCodes["Tab"] = "Tab";
    KeyboardEventCodes["CapsLock"] = "CapsLock";
    KeyboardEventCodes["Minus"] = "Minus";
    KeyboardEventCodes["Equal"] = "Equal";
    KeyboardEventCodes["Backspace"] = "Backspace";
    KeyboardEventCodes["Comma"] = "Comma";
    KeyboardEventCodes["Period"] = "Period";
    KeyboardEventCodes["Slash"] = "Slash";
    KeyboardEventCodes["Backslash"] = "Backslash";
    KeyboardEventCodes["IntlBackslash"] = "IntlBackslash";
    KeyboardEventCodes["Space"] = "Space";
    KeyboardEventCodes["Home"] = "Home";
    KeyboardEventCodes["End"] = "End";
    KeyboardEventCodes["Insert"] = "Insert";
    KeyboardEventCodes["Delete"] = "Delete";
    KeyboardEventCodes["PageUp"] = "PageUp";
    KeyboardEventCodes["PageDown"] = "PageDown";
    KeyboardEventCodes["NumpadDivide"] = "NumpadDivide";
    KeyboardEventCodes["NumpadSubtract"] = "NumpadSubtract";
    KeyboardEventCodes["NumpadDecimal"] = "NumpadDecimal";
    KeyboardEventCodes["NumpadEnter"] = "NumpadEnter";
})(KeyboardEventCodes || (KeyboardEventCodes = {}));

var _a;
var STANDARD = 0; //KeyboardEvent.DOM_KEY_LOCATION_STANDARD;
var NUMPAD = 3; //KeyboardEvent.DOM_KEY_LOCATION_NUMPAD;
(_a = {},
    _a[KeyboardEventCodes.Unidentified] = [[0, 0]],
    _a[KeyboardEventCodes.End] = [[35, STANDARD]],
    _a[KeyboardEventCodes.Escape] = [[27, STANDARD]],
    _a[KeyboardEventCodes.Equal] = [[187, STANDARD]],
    _a[KeyboardEventCodes.Backspace] = [[8, STANDARD]],
    _a[KeyboardEventCodes.Enter] = [[13, STANDARD]],
    _a[KeyboardEventCodes.NumpadEnter] = [[13, NUMPAD]],
    _a[KeyboardEventCodes.Home] = [[36, STANDARD]],
    _a[KeyboardEventCodes.Delete] = [[46, STANDARD]],
    _a[KeyboardEventCodes.Insert] = [[45, STANDARD]],
    _a[KeyboardEventCodes.PageUp] = [[33, STANDARD]],
    _a[KeyboardEventCodes.PageDown] = [[34, STANDARD]],
    _a[KeyboardEventCodes.Tab] = [[9, STANDARD]],
    _a[KeyboardEventCodes.CapsLock] = [[20, STANDARD]],
    _a[KeyboardEventCodes.KeyA] = [[65, STANDARD]],
    _a[KeyboardEventCodes.KeyC] = [[67, STANDARD]],
    _a[KeyboardEventCodes.KeyV] = [[86, STANDARD]],
    _a[KeyboardEventCodes.KeyX] = [[88, STANDARD]],
    _a[KeyboardEventCodes.NumpadDecimal] = [
        [110, NUMPAD],
        [46, NUMPAD],
    ],
    _a[KeyboardEventCodes.NumpadSubtract] = [[109, NUMPAD]],
    _a[KeyboardEventCodes.NumpadDivide] = [[111, NUMPAD]],
    _a[KeyboardEventCodes.Comma] = [[188, STANDARD]],
    _a[KeyboardEventCodes.Minus] = [[189, STANDARD]],
    _a[KeyboardEventCodes.Period] = [[190, STANDARD]],
    _a[KeyboardEventCodes.Slash] = [[191, STANDARD]],
    _a[KeyboardEventCodes.Backslash] = [[220, STANDARD]],
    _a[KeyboardEventCodes.IntlBackslash] = [[226, STANDARD]],
    _a[KeyboardEventCodes.Space] = [[32, STANDARD]],
    _a);

var isKeyTab = function (e) { return e.key === 'Tab'; };
var isKeyArrowUp = function (e) { return e.key === 'ArrowUp' || e.key === 'Up'; };
var isKeyArrowRight = function (e) { return e.key === 'ArrowRight' || e.key === 'Right'; };
var isKeyArrowDown = function (e) { return e.key === 'ArrowDown' || e.key === 'Down'; };
var isKeyArrowLeft = function (e) { return e.key === 'ArrowLeft' || e.key === 'Left'; };
var isKeyArrowHorizontal = function (e) { return isKeyArrowRight(e) || isKeyArrowLeft(e); };
var isKeyArrowVertical = function (e) { return isKeyArrowUp(e) || isKeyArrowDown(e); };
var isKeyArrow = function (e) { return isKeyArrowHorizontal(e) || isKeyArrowVertical(e); };

var KeyListener = /** @class */ (function () {
    function KeyListener() {
        var _this = this;
        var _a, _b;
        this.isTabPressed = false;
        this.isArrowPressed = false;
        (_a = globalObject.globalObject.addEventListener) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, 'keydown', function (e) {
            _this.isTabPressed = isKeyTab(e);
            _this.isArrowPressed = isKeyArrow(e);
        });
        (_b = globalObject.globalObject.addEventListener) === null || _b === void 0 ? void 0 : _b.call(globalObject.globalObject, 'mousedown', function () {
            _this.isTabPressed = false;
            _this.isArrowPressed = false;
        });
    }
    return KeyListener;
}());
var keyListener = new KeyListener();

var ALIASES_TO_SIZES = {
    small: 16,
    medium: 20,
    large: 24,
};
var DEFAULT_ICON_ALIAS = 'small';
var DEFAULT_ICON_SIZE = 16;

var resetButton = function () {
    return css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    outline: none;\n    border: none;\n    margin: 0; /* Need for Safari. */\n    padding: 0;\n    width: auto;\n    overflow: visible; /* On IE it's hidden by default. */\n    background: transparent;\n\n    /* inherit font & color from ancestor */\n    color: inherit;\n    font: inherit;\n\n    /* Normalize 'line-height'. Cannot be changed from 'normal' in Firefox 4+. */\n    line-height: normal;\n\n    /* Corrects font smoothing for webkit */\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n\n    /* Corrects inability to style clickable 'input' types in iOS */\n    -webkit-appearance: none;\n    text-align: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      padding: 0;\n    }\n  "], ["\n    outline: none;\n    border: none;\n    margin: 0; /* Need for Safari. */\n    padding: 0;\n    width: auto;\n    overflow: visible; /* On IE it's hidden by default. */\n    background: transparent;\n\n    /* inherit font & color from ancestor */\n    color: inherit;\n    font: inherit;\n\n    /* Normalize 'line-height'. Cannot be changed from 'normal' in Firefox 4+. */\n    line-height: normal;\n\n    /* Corrects font smoothing for webkit */\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n\n    /* Corrects inability to style clickable 'input' types in iOS */\n    -webkit-appearance: none;\n    text-align: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      padding: 0;\n    }\n  "])));
};
var templateObject_1$3;

var styles$2 = memoizeStyle({
    root: function (t) {
        return css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n      ", "\n      display: inline-block;\n      position: relative;\n      border-radius: ", ";\n      color: ", ";\n      cursor: pointer;\n      transition: color ", " ", ";\n\n      &:enabled:focus,\n      &:enabled:hover {\n        color: ", ";\n      }\n    "], ["\n      ", "\n      display: inline-block;\n      position: relative;\n      border-radius: ", ";\n      color: ", ";\n      cursor: pointer;\n      transition: color ", " ", ";\n\n      &:enabled:focus,\n      &:enabled:hover {\n        color: ", ";\n      }\n    "])), resetButton(), t.closeBtnIconBorderRadius, t.closeBtnIconColor, t.transitionDuration, t.transitionTimingFunction, t.closeBtnIconHoverColor);
    },
    rootDisabled: function (t) {
        return css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), t.closeBtnIconDisabledColor);
    },
    focus: function (t) {
        return css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), t.closeBtnIconFocusShadow);
    },
    wrapper: function () {
        return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n      box-sizing: content-box;\n      display: flex;\n      width: 100%;\n      height: 100%;\n      align-items: center;\n      justify-content: center;\n      pointer-events: none;\n    "], ["\n      box-sizing: content-box;\n      display: flex;\n      width: 100%;\n      height: 100%;\n      align-items: center;\n      justify-content: center;\n      pointer-events: none;\n    "])));
    },
});
var templateObject_1$2, templateObject_2$1, templateObject_3$1, templateObject_4$1;

function forwardName(name, render) {
    render.displayName = name;
    render.__KONTUR_REACT_UI__ = name;
    return render;
}
function forwardRefAndName(name, render) {
    return forwardName(name, React.forwardRef(render));
}
function forwardIconName(name, render) {
    render.displayName = name;
    render.__KONTUR_REACT_UI__ = name;
    render.__KONTUR_ICON__ = true;
    return render;
}
function forwardRefAndIconName(name, render) {
    return forwardIconName(name, React.forwardRef(render));
}

var isAlias = function (size) {
    return typeof size === 'string' && Object.keys(ALIASES_TO_SIZES).includes(size);
};
var getAliasFromSize = function (size) {
    return Object.entries(ALIASES_TO_SIZES).sort(function (_a, _b) {
        var a = _a[1];
        var b = _b[1];
        return Math.abs(size - a) > Math.abs(size - b) ? 1 : -1;
    })[0][0];
};
var iconSizer = function (sizes, iconName) {
    return forwardRefAndIconName(iconName, function (_a, ref) {
        var _b = _a.size, size = _b === void 0 ? DEFAULT_ICON_ALIAS : _b, props = __rest(_a, ["size"]);
        var alias = DEFAULT_ICON_ALIAS;
        if (size !== alias && isAlias(size)) {
            alias = size;
        }
        else if (typeof size === 'number') {
            alias = getAliasFromSize(size);
        }
        var Icon = sizes[alias]();
        return React.cloneElement(Icon, __assign({ ref: ref }, props));
    });
};

/**
 * ZERO WIDTH SPACE
 *
 * Symbol to align to baseline
 *
 * @see https://www.fileformat.info/info/unicode/char/200b/index.htm
 */
var ZERO_WIDTH_SPACE_CSS = '\\200B';

var styles$1 = memoizeStyle({
    centeredIcon: function () {
        return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      display: inline-flex;\n      align-items: center;\n\n      &::before {\n        content: '", "';\n      }\n    "], ["\n      display: inline-flex;\n      align-items: center;\n\n      &::before {\n        content: '", "';\n      }\n    "])), ZERO_WIDTH_SPACE_CSS);
    },
});
var templateObject_1$1;

var BaseIcon = forwardRefAndName('BaseIcon', function (_a, ref) {
    var color = _a.color, size = _a.size, style = _a.style, _b = _a["aria-hidden"], ariaHidden = _b === void 0 ? true : _b, _c = _a.viewBoxSize, viewBoxSize = _c === void 0 ? 16 : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, children = _a.children, rest = __rest(_a, ["color", "size", "style", 'aria-hidden', "viewBoxSize", "align", "children"]);
    var icon = (React.createElement("svg", __assign({ ref: ref, width: size || viewBoxSize, height: size || viewBoxSize, style: __assign({ fill: color !== null && color !== void 0 ? color : 'currentColor', marginBottom: align === 'none' || align === 'center' ? 0 : '-0.1875em', flexShrink: 0 }, style), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize), "aria-hidden": ariaHidden }, rest), children));
    if (align === 'center') {
        return React.createElement("span", { className: styles$1.centeredIcon() }, icon);
    }
    return icon;
});

var XIcon20Light = forwardRefAndName('XIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.146 4.146a.5.5 0 0 1 .708 0L10 9.293l5.146-5.147a.5.5 0 1 1 .707.708L10.707 10l5.146 5.146a.5.5 0 1 1-.707.707L10 10.707l-5.146 5.146a.5.5 0 1 1-.708-.707L9.293 10 4.146 4.854a.5.5 0 0 1 0-.708Z" })));
});

var XIcon24Regular = forwardRefAndName('XIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.47 4.47a.75.75 0 0 1 1.06 0L12 10.94l6.47-6.47a.75.75 0 1 1 1.06 1.06L13.06 12l6.47 6.47a.75.75 0 1 1-1.06 1.06L12 13.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L10.94 12 4.47 5.53a.75.75 0 0 1 0-1.06Z" })));
});

var CrossIcon = iconSizer({
    small: function () { return React.createElement(XIcon20Light, { size: 16, align: "none" }); },
    medium: function () { return React.createElement(XIcon20Light, { align: "none" }); },
    large: function () { return React.createElement(XIcon24Regular, { align: "none" }); },
}, 'CrossIcon');

var CloseButtonIcon = function (_a) {
    var _b = _a.side, side = _b === void 0 ? DEFAULT_ICON_SIZE : _b, _c = _a.size, size = _c === void 0 ? DEFAULT_ICON_SIZE : _c, color = _a.color, colorHover = _a.colorHover, _d = _a.tabbable, tabbable = _d === void 0 ? true : _d, style = _a.style, rest = __rest(_a, ["side", "size", "color", "colorHover", "tabbable", "style"]);
    var _theme = React.useContext(ThemeContext);
    var theme = ThemeFactory.create({
        closeBtnIconColor: color !== null && color !== void 0 ? color : _theme.closeBtnIconColor,
        closeBtnIconHoverColor: colorHover !== null && colorHover !== void 0 ? colorHover : _theme.closeBtnIconHoverColor,
    }, _theme);
    var _e = React.useState(false), focusedByTab = _e[0], setFocusedByTab = _e[1];
    var handleFocus = function () {
        var _a;
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        (_a = globalObject.globalObject.requestAnimationFrame) === null || _a === void 0 ? void 0 : _a.call(globalObject.globalObject, function () {
            if (keyListener.isTabPressed) {
                setFocusedByTab(true);
            }
        });
    };
    var handleBlur = function () { return setFocusedByTab(false); };
    var tabIndex = !tabbable || rest.disabled ? -1 : 0;
    return (React.createElement(CommonWrapper, __assign({}, rest),
        React.createElement("button", __assign({ tabIndex: tabIndex, className: cx(styles$2.root(theme), !rest.disabled && focusedByTab && styles$2.focus(theme), rest.disabled && styles$2.rootDisabled(theme)), style: __assign(__assign({}, style), { width: side, height: side }), onFocus: handleFocus, onBlur: handleBlur }, rest),
            React.createElement("span", { className: styles$2.wrapper() },
                React.createElement(CrossIcon, { size: side < size ? side : size, focusable: tabIndex >= 0 })))));
};
CloseButtonIcon.__KONTUR_REACT_UI__ = 'CloseButtonIcon';
CloseButtonIcon.displayName = 'CloseButtonIcon';

var defaultSizeValue = 'small';

var SizeControlContext = React.createContext({
    size: defaultSizeValue,
});
SizeControlContext.displayName = 'SizeContext';
SizeControlContext.__KONTUR_REACT_UI__ = 'SizeContext';

function withSize(constructor) {
    var SizeDecorator = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.size = defaultSizeValue;
            return _this;
        }
        class_1.prototype.render = function () {
            var _this = this;
            return (React.createElement(SizeControlContext.Consumer, null, function (context) {
                var _a;
                _this.size = (_a = _this.props.size) !== null && _a !== void 0 ? _a : context.size;
                var originalRender = _super.prototype.render;
                if (typeof originalRender === 'function') {
                    return originalRender.call(_this);
                }
                return null;
            }));
        };
        return class_1;
    }(constructor));
    var nameDescriptor = Object.getOwnPropertyDescriptor(SizeDecorator, 'name');
    if (!nameDescriptor || nameDescriptor.configurable) {
        Object.defineProperty(SizeDecorator, 'name', { value: constructor.name });
    }
    return SizeDecorator;
}

var styles = memoizeStyle({
    closeButton: function (t) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: absolute;\n      box-sizing: content-box;\n      right: 0;\n      top: 0;\n      width: ", ";\n      height: ", ";\n      color: ", ";\n      cursor: pointer;\n      line-height: 0;\n\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      position: absolute;\n      box-sizing: content-box;\n      right: 0;\n      top: 0;\n      width: ", ";\n      height: ", ";\n      color: ", ";\n      cursor: pointer;\n      line-height: 0;\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t.tooltipCloseBtnSide, t.tooltipCloseBtnSide, t.tooltipCloseBtnColor, t.tooltipCloseBtnHoverColor);
    },
    closeButtonSmall: function (t) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), t.tooltipCloseBtnPaddingSmall);
    },
    closeButtonMedium: function (t) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), t.tooltipCloseBtnPaddingMedium);
    },
    closeButtonLarge: function (t) {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), t.tooltipCloseBtnPaddingLarge);
    },
    tooltipContent: function (t) {
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: relative;\n      color: ", ";\n    "], ["\n      position: relative;\n      color: ", ";\n    "])), t.tooltipTextColor);
    },
    tooltipContentSmall: function (t) {
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.tooltipPaddingYSmall, t.tooltipPaddingXSmall, t.tooltipFontSizeSmall, t.tooltipLineHeightSmall);
    },
    tooltipContentMedium: function (t) {
        return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.tooltipPaddingYMedium, t.tooltipPaddingXMedium, t.tooltipFontSizeMedium, t.tooltipLineHeightMedium);
    },
    tooltipContentLarge: function (t) {
        return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "], ["\n      padding: ", " ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.tooltipPaddingYLarge, t.tooltipPaddingXLarge, t.tooltipFontSizeLarge, t.tooltipLineHeightLarge);
    },
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var DEFAULT_DELAY = 100;
var TooltipDataTids = {
    root: 'Tooltip__root',
    content: 'Tooltip__content',
    crossIcon: 'Tooltip__crossIcon',
};
var DefaultPositions = [
    'right bottom',
    'right middle',
    'right top',
    'top right',
    'top center',
    'top left',
    'left top',
    'left middle',
    'left bottom',
    'bottom left',
    'bottom center',
    'bottom right',
];
/**
 * `Tooltip` — это подсказка, которая объясняет состояние контрола или даёт контекстную справку.
 *
 * Открывается по клику, фокусом на элемент или по наведению. В отличие от `Hint`, `Tooltip` может содержать
 * изображения, кнопки, ссылки и прочие интерактивные элементы.
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter$1(Tooltip_1.defaultProps);
        _this.state = { opened: false, focused: false };
        _this.contentElement = null;
        _this.clickedOutside = true;
        _this.popupRef = React.createRef();
        _this.renderContent = function () {
            var content = _this.props.render ? _this.props.render() : null;
            if (isNullable$1(content)) {
                return null;
            }
            return (React.createElement("div", { ref: _this.refContent, className: cx(styles.tooltipContent(_this.theme), _this.sizeVariables.contentStyle), "data-tid": TooltipDataTids.content },
                content,
                _this.renderCloseButton()));
        };
        _this.getAnchorElement = function () {
            var _a;
            return (_a = _this.popupRef.current) === null || _a === void 0 ? void 0 : _a.anchorElement;
        };
        _this.getPositions = function () {
            return _this.props.allowedPositions
                ? _this.props.allowedPositions.filter(function (item) { return DefaultPositions.includes(item); })
                : DefaultPositions;
        };
        _this.refContent = function (node) {
            _this.contentElement = node;
        };
        _this.open = function () { return _this.setState({ opened: true }); };
        _this.close = function () { return _this.setState({ opened: false }); };
        _this.handleMouseEnter = function (event) {
            var isHoverAnchor = _this.getProps().trigger === 'hoverAnchor';
            if (isHoverAnchor && event.target === _this.contentElement) {
                return;
            }
            _this.clearHoverTimeout();
            _this.hoverTimeout = globalObject.globalObject.setTimeout(_this.open, _this.getProps().delayBeforeShow);
        };
        _this.handleMouseLeave = function (event) {
            var trigger = _this.getProps().trigger;
            if ((trigger === 'hover&focus' && _this.state.focused) ||
                (trigger === 'hover' && event.relatedTarget === _this.contentElement)) {
                return;
            }
            _this.clearHoverTimeout();
            if (trigger === 'hoverAnchor') {
                _this.close();
            }
            else {
                _this.hoverTimeout = globalObject.globalObject.setTimeout(_this.close, Tooltip_1.delay);
            }
        };
        _this.handleClick = function () {
            _this.open();
        };
        _this.handleClickOutsideAnchor = function (event) {
            _this.clickedOutside = _this.isClickOutsideContent(event);
            if (_this.clickedOutside) {
                if (_this.props.onCloseRequest) {
                    _this.props.onCloseRequest(event);
                }
                _this.close();
            }
        };
        _this.handleFocus = function () {
            _this.setState({ focused: true });
            _this.open();
        };
        _this.handleBlur = function () {
            var trigger = _this.getProps().trigger;
            if (trigger === 'hover&focus' && _this.clickedOutside) {
                _this.close();
            }
            if (trigger === 'focus') {
                _this.close();
            }
            _this.clickedOutside = true;
            _this.setState({ focused: false });
        };
        _this.handleCloseButtonClick = function (event) {
            event.stopPropagation();
            if (_this.props.onCloseClick) {
                _this.props.onCloseClick(event);
            }
            if (event.defaultPrevented) {
                return;
            }
            if (_this.props.onCloseRequest) {
                _this.props.onCloseRequest(event);
            }
            _this.close();
        };
        _this.getSizeVariables = function () {
            switch (_this.size) {
                case 'small':
                    return {
                        closeButtonStyle: styles.closeButtonSmall(_this.theme),
                        contentStyle: styles.tooltipContentSmall(_this.theme),
                        borderRadius: _this.theme.tooltipBorderRadiusSmall,
                        pinSize: _this.theme.tooltipPinSizeSmall,
                        pinOffsetX: _this.theme.tooltipPinOffsetXSmall,
                        pinOffsetY: _this.theme.tooltipPinOffsetYSmall,
                        margin: _this.theme.tooltipMarginSmall,
                    };
                case 'medium':
                    return {
                        closeButtonStyle: styles.closeButtonMedium(_this.theme),
                        contentStyle: styles.tooltipContentMedium(_this.theme),
                        borderRadius: _this.theme.tooltipBorderRadiusMedium,
                        pinSize: _this.theme.tooltipPinSizeMedium,
                        pinOffsetX: _this.theme.tooltipPinOffsetXMedium,
                        pinOffsetY: _this.theme.tooltipPinOffsetYMedium,
                        margin: _this.theme.tooltipMarginMedium,
                    };
                case 'large':
                    return {
                        closeButtonStyle: styles.closeButtonLarge(_this.theme),
                        contentStyle: styles.tooltipContentLarge(_this.theme),
                        borderRadius: _this.theme.tooltipBorderRadiusLarge,
                        pinSize: _this.theme.tooltipPinSizeLarge,
                        pinOffsetX: _this.theme.tooltipPinOffsetXLarge,
                        pinOffsetY: _this.theme.tooltipPinOffsetYLarge,
                        margin: _this.theme.tooltipMarginLarge,
                    };
                default:
                    console.error("Can't get size variables: invalid value in size prop '".concat(_this.size, "'. Returning default"));
                    return {
                        closeButtonStyle: styles.closeButtonSmall(_this.theme),
                        contentStyle: styles.tooltipContentSmall(_this.theme),
                        borderRadius: _this.theme.tooltipBorderRadiusSmall,
                        pinSize: _this.theme.tooltipPinSizeSmall,
                        pinOffsetX: _this.theme.tooltipPinOffsetXSmall,
                        pinOffsetY: _this.theme.tooltipPinOffsetYSmall,
                        margin: _this.theme.tooltipMarginSmall,
                    };
            }
        };
        return _this;
    }
    Tooltip_1 = Tooltip;
    Tooltip.prototype.validateProps = function (props) {
        warning(props.children || props.anchorElement, "[Tooltip]: you must provide either 'children' or 'anchorElement' prop for Tooltip to work properly");
    };
    Tooltip.prototype.getAllowedPositions = function () {
        return this.props.allowedPositions ? this.props.allowedPositions : DefaultPositions;
    };
    Tooltip.prototype.componentDidMount = function () {
        this.validateProps(this.getProps());
    };
    Tooltip.prototype.componentDidUpdate = function () {
        var trigger = this.getProps().trigger;
        this.validateProps(this.getProps());
        if (trigger === 'closed' && this.state.opened) {
            this.close();
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        this.clearHoverTimeout();
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        return (React.createElement(ReactUIFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = getFullReactUIFlagsContext(flags);
            return (React.createElement(ThemeContext.Consumer, null, function (theme) {
                _this.theme = theme;
                _this.sizeVariables = _this.getSizeVariables();
                return (React.createElement(ThemeContext.Provider, { value: ThemeFactory.create({
                        popupBackground: theme.tooltipBg,
                        popupBorder: theme.tooltipBorder,
                        popupBorderRadius: _this.sizeVariables.borderRadius,
                        popupPinSize: _this.sizeVariables.pinSize,
                        popupPinOffsetX: _this.sizeVariables.pinOffsetX,
                        popupPinOffsetY: _this.sizeVariables.pinOffsetY,
                        popupMargin: _this.sizeVariables.margin,
                    }, theme) }, _this.renderMain()));
            }));
        }));
    };
    Tooltip.prototype.renderCloseButton = function () {
        var hasCross = this.props.closeButton === undefined
            ? !Tooltip_1.triggersWithoutCloseButton.includes(this.getProps().trigger)
            : this.props.closeButton;
        if (!hasCross) {
            return null;
        }
        var icon = (React.createElement(CloseButtonIcon, { tabbable: false, side: parseInt(this.theme.tooltipCloseBtnSide), color: this.theme.tooltipCloseBtnColor, colorHover: this.theme.tooltipCloseBtnHoverColor }));
        return (React.createElement("div", { className: cx(styles.closeButton(this.theme), this.sizeVariables.closeButtonStyle), onClick: this.handleCloseButtonClick, "data-tid": TooltipDataTids.crossIcon }, icon));
    };
    /**
     * Программно открывает тултип.
     * <p>Не действует если проп *trigger* `'opened'` или `'closed'`.</p>
     * @public
     */
    Tooltip.prototype.show = function () {
        if (this.state.opened) {
            return;
        }
        var trigger = this.getProps().trigger;
        if (trigger === 'opened' || trigger === 'closed') {
            warning(true, "Function 'show' is not supported with trigger specified '".concat(trigger, "'"));
            return;
        }
        this.open();
    };
    /**
     * Программно закрывает тултип.
     * <p>Не действует если проп *trigger* `'opened'` или `'closed'`.</p>
     * @public
     */
    Tooltip.prototype.hide = function () {
        var trigger = this.getProps().trigger;
        if (trigger === 'opened' || trigger === 'closed') {
            warning(true, "Function 'hide' is not supported with trigger specified '".concat(trigger, "'"));
            return;
        }
        this.close();
    };
    Tooltip.prototype.renderMain = function () {
        var props = this.props;
        var content = this.renderContent();
        var _a = this.getPopupAndLayerProps(), popupProps = _a.popupProps, _b = _a.layerProps, layerProps = _b === void 0 ? { active: false } : _b;
        var anchorElement = props.children || props.anchorElement;
        var popup = this.renderPopup(anchorElement, popupProps, content);
        return (React.createElement(RenderLayer, __assign({}, layerProps, { getAnchorElement: this.getAnchorElement }), popup));
    };
    Tooltip.prototype.renderPopup = function (anchorElement, popupProps, content) {
        var _a = this.getProps(), disableAnimations = _a.disableAnimations, trigger = _a.trigger;
        return (React.createElement(CommonWrapper, __assign({ rootNodeRef: this.setRootNode }, this.props),
            React.createElement(Popup, __assign({ "data-tid": TooltipDataTids.root, anchorElement: anchorElement, hasPin: true, hasShadow: true, maxWidth: "none", opened: this.state.opened, disableAnimations: disableAnimations, positions: isThemeGTE(this.theme, '5.4') ? this.getPositions() : this.props.allowedPositions, pos: this.props.pos, ignoreHover: trigger === 'hoverAnchor', onOpen: this.props.onOpen, onClose: this.props.onClose, tryPreserveFirstRenderedPosition: true, ref: this.popupRef, withoutMobile: true }, popupProps), content)));
    };
    Tooltip.prototype.getPopupAndLayerProps = function () {
        var props = this.props;
        var useWrapper = !!props.children && this.getProps().useWrapper;
        var trigger = this.getProps().trigger;
        switch (trigger) {
            case 'opened':
                return {
                    layerProps: {
                        active: true,
                        onClickOutside: this.handleClickOutsideAnchor,
                    },
                    popupProps: {
                        opened: true,
                        useWrapper: useWrapper,
                    },
                };
            case 'closed':
                return {
                    popupProps: {
                        opened: false,
                        useWrapper: useWrapper,
                    },
                };
            case 'hoverAnchor':
            case 'hover':
                return {
                    popupProps: {
                        onMouseEnter: this.handleMouseEnter,
                        onMouseLeave: this.handleMouseLeave,
                        useWrapper: useWrapper,
                    },
                };
            case 'manual':
                return {
                    popupProps: {
                        useWrapper: useWrapper,
                    },
                };
            case 'click':
                return {
                    layerProps: {
                        active: this.state.opened,
                        onClickOutside: this.handleClickOutsideAnchor,
                    },
                    popupProps: {
                        onClick: this.handleClick,
                        useWrapper: useWrapper,
                    },
                };
            case 'focus':
                return {
                    popupProps: {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur,
                        useWrapper: useWrapper,
                    },
                };
            case 'hover&focus':
                return {
                    layerProps: {
                        active: this.state.opened,
                        onClickOutside: this.handleClickOutsideAnchor,
                    },
                    popupProps: {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur,
                        onMouseEnter: this.handleMouseEnter,
                        onMouseLeave: this.handleMouseLeave,
                        useWrapper: useWrapper,
                    },
                };
            default:
                throw new Error('Unknown trigger specified: ' + trigger);
        }
    };
    Tooltip.prototype.clearHoverTimeout = function () {
        if (this.hoverTimeout) {
            globalObject.globalObject.clearTimeout(this.hoverTimeout);
            this.hoverTimeout = null;
        }
    };
    Tooltip.prototype.isClickOutsideContent = function (event) {
        if (this.contentElement && isInstanceOf(event.target, globalObject.globalObject.Element)) {
            return !containsTargetOrRenderContainer(event.target)(this.contentElement);
        }
        return true;
    };
    var Tooltip_1;
    Tooltip.__KONTUR_REACT_UI__ = 'Tooltip';
    Tooltip.displayName = 'Tooltip';
    Tooltip.defaultProps = {
        trigger: 'hover',
        disableAnimations: isTestEnv$1,
        useWrapper: false,
        delayBeforeShow: DEFAULT_DELAY,
    };
    Tooltip.delay = DEFAULT_DELAY;
    Tooltip.triggersWithoutCloseButton = ['hover', 'hoverAnchor', 'focus', 'hover&focus'];
    Tooltip = Tooltip_1 = __decorate([
        rootNode,
        withSize
    ], Tooltip);
    return Tooltip;
}(React.PureComponent));

/**
 * Проверяет, не является ли переданный аргумент null или undefined и исключает типы null и undefined из типа аргумента
 *
 * @param value Значение, которое нужно проверить и исключить из него типы
 * @returns Возвращает true, если переданный аргумент не является null или undefined иначе false
 */
var isNonNullable = function (value) {
    return value !== null && value !== undefined;
};

var ReactUiDetection = /** @class */ (function () {
    function ReactUiDetection() {
    }
    ReactUiDetection.checkType = function (element, type) {
        var _a;
        return isNonNullable(element) && ((_a = element.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === type;
    };
    ReactUiDetection.isDatePicker = function (element) {
        return ReactUiDetection.checkType(element, 'DatePicker');
    };
    ReactUiDetection.isRadioGroup = function (element) {
        return ReactUiDetection.checkType(element, 'RadioGroup');
    };
    ReactUiDetection.isTokenInput = function (element) {
        return ReactUiDetection.checkType(element, 'TokenInput');
    };
    ReactUiDetection.isSwitcher = function (element) {
        return ReactUiDetection.checkType(element, 'Switcher');
    };
    ReactUiDetection.isComboBox = function (element) {
        return ReactUiDetection.checkType(element, 'ComboBox');
    };
    ReactUiDetection.isRadio = function (element) {
        return ReactUiDetection.checkType(element, 'Radio');
    };
    ReactUiDetection.isCheckBox = function (element) {
        return ReactUiDetection.checkType(element, 'Checkbox');
    };
    ReactUiDetection.isToggle = function (element) {
        return ReactUiDetection.checkType(element, 'Toggle');
    };
    ReactUiDetection.isSelect = function (element) {
        return ReactUiDetection.checkType(element, 'Select');
    };
    ReactUiDetection.isSelectionControl = function (element) {
        return (ReactUiDetection.isRadioGroup(element) ||
            ReactUiDetection.isRadio(element) ||
            ReactUiDetection.isCheckBox(element) ||
            ReactUiDetection.isToggle(element) ||
            ReactUiDetection.isSwitcher(element) ||
            ReactUiDetection.isSelect(element) ||
            ReactUiDetection.isComboBox(element));
    };
    return ReactUiDetection;
}());

var ValidationText = function (_a) {
    var pos = _a.pos, children = _a.children, validation = _a.validation, dataTid = _a["data-tid"];
    var theme = React.useContext(ThemeContext);
    var color = getValidationTextColor(theme, validation === null || validation === void 0 ? void 0 : validation.level);
    if (pos === 'right') {
        var childrenAndValidationText_1 = (React.createElement(React.Fragment, null,
            children,
            React.createElement("span", { "data-tid": dataTid, "data-validation-message": "text", style: { marginLeft: '10px', color: color } }, (validation && validation.message) || '')));
        return React.createElement("div", { style: { display: 'inline-block' } }, childrenAndValidationText_1);
    }
    var validationText = (React.createElement("span", { "data-tid": dataTid, "data-validation-message": "text", style: {
            color: color,
            overflow: 'visible',
            whiteSpace: 'nowrap',
            position: 'absolute',
            top: '2px',
            left: 0,
        } }, (validation && validation.message) || ''));
    var childrenAndValidationText = (React.createElement(React.Fragment, null,
        children,
        React.createElement("span", { style: { position: 'absolute', bottom: 0, left: 0, height: 0 } }, validationText)));
    return React.createElement("div", { style: { position: 'relative', display: 'inline-block' } }, childrenAndValidationText);
};
ValidationText.__KONTUR_REACT_UI__ = 'ValidationText';
ValidationText.displayName = 'ValidationText';

var ValidationTooltip = /** @class */ (function (_super) {
    __extends(ValidationTooltip, _super);
    function ValidationTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationTooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, pos = _a.pos, error = _a.error, render = _a.render, rest = __rest(_a, ["children", "pos", "error", "render"]);
        var onlyChild = React.Children.only(children);
        var child = onlyChild && onlyChild.props ? onlyChild.props.children : null;
        return ReactUiDetection.isRadioGroup(child) ||
            ReactUiDetection.isTokenInput(child) ||
            ReactUiDetection.isSwitcher(child) ? (React.createElement(Tooltip, __assign({ useWrapper: false, pos: pos, render: error ? render : undefined, trigger: 'hover&focus' }, rest), child)) : (React.createElement(Tooltip, __assign({ pos: pos, render: error ? render : undefined, trigger: 'hover&focus' }, rest), children));
    };
    ValidationTooltip.__KONTUR_REACT_UI__ = 'ValidationTooltip';
    ValidationTooltip.displayName = 'ValidationTooltip';
    return ValidationTooltip;
}(React.Component));

function tooltip(pos) {
    return function (control, hasError, validation) {
        return (React.createElement(ValidationTooltip, { pos: pos, error: hasError, render: function () {
                if (!validation || !validation.message) {
                    return null;
                }
                return (validation && validation.message) || '';
            } }, control));
    };
}
function text(pos) {
    if (pos === void 0) { pos = 'right'; }
    return function (control, _hasError, validation) {
        return (React.createElement(ValidationText, { pos: pos, validation: validation }, control));
    };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-unnecessary-type-constraint
function createPropsGetter(defaultProps) {
    return function () {
        return this.props;
    };
}

var env = (typeof process === 'object' && process && process.env) || {};
var enableReactTesting = env.enableReactTesting, NODE_ENV = env.NODE_ENV, REACT_UI_TEST$1 = env.REACT_UI_TEST, REACT_APP_REACT_UI_TEST = env.REACT_APP_REACT_UI_TEST, STORYBOOK_REACT_UI_TEST = env.STORYBOOK_REACT_UI_TEST;
var isReactUITestEnv = Boolean(REACT_UI_TEST$1) || // for cases when NODE_ENV is not usable (dev/prod)
    Boolean(REACT_APP_REACT_UI_TEST) || // for usage with CRA
    Boolean(STORYBOOK_REACT_UI_TEST) || // for usage with storybook
    Boolean(enableReactTesting); // deprecated, legacy variable
var isTestEnv = NODE_ENV === 'test' || isReactUITestEnv;
var isBrowser = typeof window !== 'undefined';
function isElement(el) {
    return !!el && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
}
var getDoc = function (node) { var _a; return (_a = node.ownerDocument) !== null && _a !== void 0 ? _a : node; };
var getWin = function (node) { return getDoc(node).defaultView; };

/**
 * Checks if the value `null` or `undefined`.
 *
 * @param value Value to check for `null` and `undefined`.
 * @returns Returns `true` if `value` is `null` or `undefined`, else `false`.
 */
// @ts-expect-error: TypeScript doesn't consider the check inside of the function.
var isNullable = function (value) {
    return value === null || value === undefined;
};

exports.FocusMode = void 0;
(function (FocusMode) {
    FocusMode[FocusMode["Errors"] = 0] = "Errors";
    FocusMode[FocusMode["ErrorsAndWarnings"] = 1] = "ErrorsAndWarnings";
    FocusMode[FocusMode["None"] = 2] = "None";
})(exports.FocusMode || (exports.FocusMode = {}));

var ValidationContext = React.createContext({
    register: function () { return undefined; },
    unregister: function () { return undefined; },
    instanceProcessBlur: function () { return undefined; },
    onValidationUpdated: function () { return undefined; },
    getSettings: function () { return ({
        scrollOffset: {},
        disableSmoothScroll: false,
    }); },
    isAnyWrapperInChangingMode: function () { return false; },
    isValidationCalled: function () { return false; },
});
ValidationContext.displayName = 'ValidationContext';
var ValidationContextWrapper = /** @class */ (function (_super) {
    __extends(ValidationContextWrapper, _super);
    function ValidationContextWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childWrappers = [];
        _this.validationHasBeenCalled = false;
        _this.renderChildren = function (children) {
            if (React.isValidElement(children)) {
                return React.cloneElement(children, {
                    'data-tid': _this.props['data-tid'],
                });
            }
            return children;
        };
        return _this;
    }
    ValidationContextWrapper.prototype.getSettings = function () {
        var scrollOffset = {};
        if (typeof this.props.scrollOffset === 'number') {
            scrollOffset = { top: this.props.scrollOffset };
        }
        else {
            scrollOffset = isNullable(this.props.scrollOffset) ? {} : this.props.scrollOffset;
        }
        var _a = scrollOffset.top, top = _a === void 0 ? 50 : _a, _b = scrollOffset.bottom, bottom = _b === void 0 ? 0 : _b;
        return {
            scrollOffset: {
                top: top,
                bottom: bottom,
            },
            disableSmoothScroll: this.props.disableSmoothScroll,
        };
    };
    ValidationContextWrapper.prototype.register = function (wrapper) {
        this.childWrappers.push(wrapper);
    };
    ValidationContextWrapper.prototype.unregister = function (wrapper) {
        this.childWrappers.splice(this.childWrappers.indexOf(wrapper), 1);
        this.onValidationRemoved();
    };
    ValidationContextWrapper.prototype.instanceProcessBlur = function (instance) {
        for (var _i = 0, _a = this.childWrappers.filter(function (x) { return x !== instance && !x.isIndependent(); }); _i < _a.length; _i++) {
            var wrapper = _a[_i];
            wrapper.processBlur();
        }
    };
    ValidationContextWrapper.prototype.onValidationUpdated = function (wrapper, isValid) {
        var onValidationUpdated = this.props.onValidationUpdated;
        if (onValidationUpdated) {
            var isValidResult = !this.childWrappers.find(function (x) {
                if (x === wrapper) {
                    return !isValid;
                }
                return x.hasError();
            });
            onValidationUpdated(isValidResult);
        }
    };
    ValidationContextWrapper.prototype.isAnyWrapperInChangingMode = function () {
        return this.childWrappers.some(function (x) { return x.isChanging; });
    };
    ValidationContextWrapper.prototype.isValidationCalled = function () {
        return this.validationHasBeenCalled;
    };
    ValidationContextWrapper.prototype.onValidationRemoved = function () {
        var onValidationUpdated = this.props.onValidationUpdated;
        if (onValidationUpdated) {
            var isValidResult = !this.childWrappers.find(function (x) { return x.hasError(); });
            onValidationUpdated(isValidResult);
        }
    };
    ValidationContextWrapper.prototype.getChildWrappersSortedByPosition = function () {
        var wrappersWithPosition = __spreadArray([], this.childWrappers, true).map(function (x) { return ({
            target: x,
            position: x.getControlPosition(),
        }); });
        wrappersWithPosition.sort(function (x, y) {
            var xPosition = x.position;
            var yPosition = y.position;
            if (isNullable(xPosition) && isNullable(yPosition)) {
                return 0;
            }
            if (isNullable(xPosition)) {
                return 1;
            }
            if (isNullable(yPosition)) {
                return -1;
            }
            if (Math.sign(xPosition.x - yPosition.x) !== 0) {
                return Math.sign(xPosition.x - yPosition.x);
            }
            return Math.sign(xPosition.y - yPosition.y);
        });
        return wrappersWithPosition.map(function (x) { return x.target; });
    };
    ValidationContextWrapper.prototype.validate = function (withoutFocusOrValidationSettings) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var focusMode, childrenWrappersSortedByPosition, firstError;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        focusMode = ValidationContextWrapper.getFocusMode(withoutFocusOrValidationSettings);
                        return [4 /*yield*/, Promise.all(this.childWrappers.map(function (x) { return x.processSubmit(); }))];
                    case 1:
                        _b.sent();
                        this.validationHasBeenCalled = true;
                        childrenWrappersSortedByPosition = this.getChildWrappersSortedByPosition();
                        firstError = childrenWrappersSortedByPosition.find(function (x) { return x.hasError(); });
                        if (focusMode === exports.FocusMode.ErrorsAndWarnings) {
                            (_a = childrenWrappersSortedByPosition.find(function (x) { return x.hasError() || x.hasWarning(); })) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                        if (focusMode === exports.FocusMode.Errors) {
                            firstError === null || firstError === void 0 ? void 0 : firstError.focus();
                        }
                        if (this.props.onValidationUpdated) {
                            this.props.onValidationUpdated(!firstError);
                        }
                        return [2 /*return*/, !firstError];
                }
            });
        });
    };
    ValidationContextWrapper.getFocusMode = function (withoutFocusOrValidationSettings) {
        if (typeof withoutFocusOrValidationSettings === 'object' && 'focusMode' in withoutFocusOrValidationSettings) {
            return withoutFocusOrValidationSettings.focusMode;
        }
        else if (!withoutFocusOrValidationSettings) {
            return exports.FocusMode.Errors;
        }
        return exports.FocusMode.None;
    };
    ValidationContextWrapper.prototype.render = function () {
        return (React.createElement(ValidationContext.Provider, { value: this }, this.renderChildren(React.createElement("div", { style: { display: 'inline' } }, this.props.children))));
    };
    return ValidationContextWrapper;
}(React.Component));

var ValidationContainer = /** @class */ (function (_super) {
    __extends(ValidationContainer, _super);
    function ValidationContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter(ValidationContainer.defaultProps);
        _this.childContext = null;
        _this.refChildContext = function (el) { return (_this.childContext = el); };
        return _this;
    }
    ValidationContainer.prototype.validateProps = function (scrollOffset) {
        warning(typeof scrollOffset !== 'number', "[ValidationContainer]: scrollOffset as a number type has been deprecated, now use object { top?: number; bottom?: number; }");
    };
    ValidationContainer.prototype.submit = function (withoutFocusOrValidationSettings) {
        if (withoutFocusOrValidationSettings === void 0) { withoutFocusOrValidationSettings = { focusMode: exports.FocusMode.Errors }; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.childContext) {
                            throw new Error('childContext is not defined');
                        }
                        return [4 /*yield*/, this.childContext.validate(withoutFocusOrValidationSettings)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ValidationContainer.prototype.validate = function (withoutFocusOrValidationSettings) {
        if (withoutFocusOrValidationSettings === void 0) { withoutFocusOrValidationSettings = { focusMode: exports.FocusMode.Errors }; }
        if (!this.childContext) {
            throw new Error('childContext is not defined');
        }
        return this.childContext.validate(withoutFocusOrValidationSettings);
    };
    ValidationContainer.prototype.componentDidMount = function () {
        this.validateProps(this.getProps().scrollOffset);
    };
    ValidationContainer.prototype.componentDidUpdate = function () {
        var props = this.getProps();
        this.validateProps(props.scrollOffset);
    };
    ValidationContainer.prototype.render = function () {
        return (React.createElement(ValidationContextWrapper, { "data-tid": this.props['data-tid'], ref: this.refChildContext, scrollOffset: this.props.scrollOffset, disableSmoothScroll: this.getProps().disableSmoothScroll, onValidationUpdated: this.props.onValidationUpdated }, this.props.children));
    };
    ValidationContainer.__KONTUR_REACT_UI__ = 'ValidationContainer';
    ValidationContainer.displayName = 'ValidationContainer';
    ValidationContainer.defaultProps = {
        disableSmoothScroll: isTestEnv,
    };
    return ValidationContainer;
}(React.Component));

var isInstanceWithRootNode = function (instance) {
    return Boolean(instance) && Object.prototype.hasOwnProperty.call(instance, 'getRootNode');
};
/**
 * Temporary duplicates @skbkontur/react-ui/lib/rootNode/getRootNode.ts
 * */
var getRootNode = function (instance) {
    /**
     * Options of what instance can be:
     *  1. null or undefined
     *  2. DOM Element
     *  3. class Component instance (object)
     *  4. literally anything, returned from useImperativeHandle
     */
    if (!instance) {
        // instance can be `null` if component was unmounted
        // also checking undefined for convenient usage
        return null;
    }
    if (isElement(instance)) {
        // instance can be an Element already if its coming
        // from Refs of intrinsic elements (<div />, <button />, etc.)
        return instance;
    }
    var rootNode;
    if (isInstanceWithRootNode(instance)) {
        rootNode = instance.getRootNode();
    }
    if (rootNode !== undefined) {
        // the getter exists and has returned something, it should be what we are looking for
        // probably its an Element or null (which is also OK, e.g. Popup/Tooltip/Hint before opening)
        return rootNode;
    }
    try {
        // rootNode is undefined, which means that the getter doesn't exists or returns the undefined
        // anyway, it tell us that the convention is not respected,
        // so, we have to fall back to the deprecated findDOMNode, which breaks StrictMode
        // instance can still be a class component or an imperative handle (i.e., anything, except null/undefined/Element)
        rootNode = ReactDOM.findDOMNode(instance);
    }
    catch (e) {
        // but findDOMNode doesn`t accept everything that instance can be at this point,
        // so we have to handle exceptions
        // see https://github.com/facebook/react/blob/cae63505/packages/react-dom/src/__tests__/findDOMNode-test.js#L66-L86
        warning(false, '[getRootNode]: can`t fallback to findDOMNode.' +
            '\n' +
            'See https://github.com/skbkontur/retail-ui/blob/master/packages/react-ui/README.md#strictmode' +
            '\n\n' +
            e.message);
        return null;
    }
    // the findDOMNode can also return Text, but we are only interested in Elements, so just filter it
    return isElement(rootNode) ? rootNode : null;
};

function smoothScrollIntoView(element, scrollOffset) {
    return __awaiter(this, void 0, void 0, function () {
        var activeDocument, activeWindow, scrollableParent, parentRects, clientRects, topOffset, bottomOffset, html, viewportHeight, viewportWidth, isElementInViewport;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    activeDocument = getDoc(element);
                    activeWindow = getWin(element);
                    scrollableParent = findScrollableParent(element);
                    parentRects = scrollableParent.getBoundingClientRect();
                    clientRects = element.getBoundingClientRect();
                    topOffset = scrollOffset.top || 0;
                    bottomOffset = scrollOffset.bottom || 0;
                    if (!(scrollableParent === activeDocument.body)) return [3 /*break*/, 2];
                    html = activeDocument.documentElement || { clientHeight: 0, clientWidth: 0 };
                    viewportHeight = (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.innerHeight) || html.clientHeight;
                    viewportWidth = (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.innerWidth) || html.clientWidth;
                    isElementInViewport = clientRects.top >= topOffset &&
                        clientRects.left >= 0 &&
                        clientRects.bottom <= viewportHeight - bottomOffset &&
                        clientRects.right <= viewportWidth;
                    if (isElementInViewport) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, scrollBy({
                            element: element,
                            left: clientRects.left,
                            top: clientRects.top - topOffset,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    if (clientRects.top - topOffset + 50 > parentRects.top && clientRects.bottom < parentRects.bottom) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, smoothScroll(scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top - topOffset)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, scrollBy({
                            element: element,
                            left: parentRects.left,
                            top: parentRects.top,
                        })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function smoothScroll(element, x, y) {
    var activeDocument = getDoc(element);
    var activeWindow = getWin(element);
    var context;
    if (activeWindow) {
        if (element === getDocumentBodyStrict(activeDocument)) {
            context = {
                scrollable: element,
                startX: activeWindow.scrollX || activeWindow.pageXOffset,
                startY: activeWindow.scrollY || activeWindow.pageYOffset,
                method: getScrollWindow(element),
                startTime: getNow(element)(),
                x: x,
                y: y,
            };
        }
        else {
            context = {
                scrollable: element,
                startX: element.scrollLeft,
                startY: element.scrollTop,
                method: scrollElement,
                startTime: getNow(element)(),
                x: x,
                y: y,
            };
        }
    }
    return new Promise(function (resolve) { return step(__assign(__assign({}, context), { resolve: resolve })); });
}
function step(_a) {
    var scrollable = _a.scrollable, startX = _a.startX, startY = _a.startY, x = _a.x, y = _a.y, method = _a.method, resolve = _a.resolve, startTime = _a.startTime;
    var time = getNow(scrollable)();
    var scrollTime = 468;
    var elapsed = Math.min(1, (time - startTime) / scrollTime);
    var value = ease(elapsed);
    var activeWindow = getWin(scrollable);
    var currentX = startX + (x - startX) * value;
    var currentY = startY + (y - startY) * value;
    method(scrollable, currentX, currentY);
    if (currentX !== x || currentY !== y) {
        !!activeWindow &&
            activeWindow.requestAnimationFrame(function () { return step({ scrollable: scrollable, startX: startX, startY: startY, x: x, y: y, method: method, resolve: resolve, startTime: startTime }); });
    }
    else {
        resolve();
    }
}
var getScrollWindow = function (el) {
    var activeWindow = getWin(el);
    if (isBrowser) {
        if (typeof (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.scroll) === 'function') {
            return function (_, x, y) { return activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.scroll(x, y); };
        }
    }
    return function () { return undefined; };
};
var getNow = function (el) {
    var activeWindow = getWin(el);
    return isBrowser && (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.performance) && (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.performance.now)
        ? activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.performance.now.bind(activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.performance)
        : Date.now;
};
function scrollElement(element, x, y) {
    element.scrollLeft = x;
    element.scrollTop = y;
}
function ease(time) {
    return 0.5 * (1 - Math.cos(Math.PI * time));
}
function getDocumentBodyStrict(activeDocument) {
    if (isNullable(activeDocument.body)) {
        throw new Error('Scrolling can be used only in browser');
    }
    return activeDocument.body;
}
function findScrollableParent(el) {
    var _a;
    var isBody;
    var hasScrollableSpace;
    var hasVisibleOverflow;
    var currentElement = el;
    do {
        if (isNullable(currentElement.parentElement) || !isElement(currentElement.parentElement)) {
            return getDocumentBodyStrict(getDoc(currentElement));
        }
        currentElement = currentElement.parentElement;
        isBody = currentElement === getDoc(currentElement).body;
        hasScrollableSpace =
            currentElement.clientHeight < currentElement.scrollHeight ||
                currentElement.clientWidth < currentElement.scrollWidth;
        hasVisibleOverflow = ((_a = getWin(currentElement)) === null || _a === void 0 ? void 0 : _a.getComputedStyle(currentElement, null).overflow) === 'visible';
    } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));
    isBody = null;
    hasScrollableSpace = null;
    hasVisibleOverflow = null;
    return currentElement;
}
function scrollBy(_a) {
    var element = _a.element, left = _a.left, top = _a.top;
    var activeWindow = getWin(element);
    var activeDocument = getDoc(element);
    if (!activeWindow) {
        return new Promise(function (resolve) { return resolve(); });
    }
    var x = Math.floor(left) + ((activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.scrollX) || (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.pageXOffset));
    var y = Math.floor(top) + ((activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.scrollY) || (activeWindow === null || activeWindow === void 0 ? void 0 : activeWindow.pageYOffset));
    return smoothScroll(getDocumentBodyStrict(activeDocument), x, y);
}

function getVisibleValidation(visible, actual, changing) {
    var from = function (type) { return getType(visible) === type; };
    var to = function (type) { return getType(actual) === type; };
    if (to('immediate')) {
        return actual;
    }
    if (changing) {
        return from('immediate') ? null : visible;
    }
    if (from(null) && to('lostfocus')) {
        return null;
    }
    if (to('lostfocus')) {
        return actual;
    }
    if (from('submit') && to('submit')) {
        return visible;
    }
    return null;
}
function getType(validation) {
    return validation ? validation.behaviour : null;
}
function getLevel(validation) {
    return validation ? validation.level : null;
}
function getIndependent(validation) {
    return validation ? validation.independent : null;
}
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    return (!!a &&
        !!b &&
        a.behaviour === b.behaviour &&
        a.message === b.message &&
        a.independent === b.independent &&
        a.level === b.level);
}

var validationsFeatureFlagsDefault = {
    dropdownsDoNotOpenOnFocusByValidation: false,
    hideTooltipOnSelectionControls: false,
    validationWrapperValidateOnMount: false,
};
var ValidationsFeatureFlagsContext = React.createContext(validationsFeatureFlagsDefault);
ValidationsFeatureFlagsContext.displayName = 'ValidationsFeatureFlagsContext';
ValidationsFeatureFlagsContext.__KONTUR_REACT_UI__ = 'ValidationsFeatureFlagsContext';

var getFullValidationsFlagsContext = function (flags) {
    return __assign(__assign({}, validationsFeatureFlagsDefault), flags);
};

var ValidationWrapperInternal = /** @class */ (function (_super) {
    __extends(ValidationWrapperInternal, _super);
    function ValidationWrapperInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            validation: null,
        };
        _this.isChanging = false;
        _this.context = _this.context;
        _this.customRef = function (instance) {
            var children = _this.props.children;
            _this.setRootNode(instance);
            var child = children; // todo type or maybe React.Children.only
            if (child && child.ref) {
                if (typeof child.ref === 'function') {
                    child.ref(instance);
                }
                if (Object.prototype.hasOwnProperty.call(child.ref, 'current')) {
                    child.ref.current = instance;
                }
            }
            _this.child = instance;
        };
        _this.setRootNode = function (element) {
            _this.rootNode = getRootNode(element);
        };
        _this.getRootNode = function () {
            return _this.rootNode;
        };
        return _this;
    }
    ValidationWrapperInternal.prototype.componentDidMount = function () {
        warning(this.context, 'ValidationWrapper should appears as child of ValidationContainer.\n' +
            'https://tech.skbkontur.ru/kontur-ui/?path=/docs/react-ui-validations_displaying-getting-started--docs');
        if (this.context) {
            this.context.register(this);
        }
        if (this.featureFlags.validationWrapperValidateOnMount && this.context.isValidationCalled()) {
            this.processSubmit();
        }
        else {
            this.applyValidation(this.props.validation);
        }
    };
    ValidationWrapperInternal.prototype.componentWillUnmount = function () {
        this.context.unregister(this);
    };
    ValidationWrapperInternal.prototype.componentDidUpdate = function () {
        this.applyValidation(this.props.validation);
    };
    ValidationWrapperInternal.prototype.focus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var htmlElement, _a, disableSmoothScroll, scrollOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        htmlElement = this.getRootNode();
                        if (!isElement(htmlElement)) return [3 /*break*/, 3];
                        _a = this.context.getSettings(), disableSmoothScroll = _a.disableSmoothScroll, scrollOffset = _a.scrollOffset;
                        if (!!disableSmoothScroll) return [3 /*break*/, 2];
                        return [4 /*yield*/, smoothScrollIntoView(htmlElement, scrollOffset)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.child && typeof this.child.focus === 'function') {
                            this.child.focus({ withoutOpenDropdown: this.featureFlags.dropdownsDoNotOpenOnFocusByValidation });
                        }
                        _b.label = 3;
                    case 3:
                        this.isChanging = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ValidationWrapperInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, dataTid = _a["data-tid"];
        var validation = this.state.validation;
        var clonedChild = children ? (React.cloneElement(children, {
            ref: this.customRef,
            error: !this.isChanging && getLevel(validation) === 'error',
            warning: !this.isChanging && getLevel(validation) === 'warning',
            onBlur: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.handleBlur();
                if (children.props && children.props.onBlur) {
                    (_a = children.props).onBlur.apply(_a, args);
                }
            },
            onChange: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isChanging = true;
                if (children.props && children.props.onChange) {
                    (_a = children.props).onChange.apply(_a, args);
                }
            },
            onValueChange: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isChanging = true;
                if (_this.featureFlags.hideTooltipOnSelectionControls && ReactUiDetection.isSelectionControl(children)) {
                    _this.setValidation(null);
                }
                if (children.props && children.props.onValueChange) {
                    (_a = children.props).onValueChange.apply(_a, args);
                }
            },
        })) : (React.createElement("span", { ref: this.setRootNode }));
        if (ReactUiDetection.isComboBox(clonedChild)) {
            clonedChild = React.cloneElement(clonedChild, {
                onInputValueChange: function () {
                    var _a;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this.isChanging = true;
                    _this.forceUpdate();
                    if (children && children.props && children.props.onInputValueChange) {
                        return (_a = children.props).onInputValueChange.apply(_a, args);
                    }
                },
            });
        }
        return (React.createElement(ValidationsFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = flags;
            return React.cloneElement(_this.props.errorMessage(React.createElement("div", { style: { display: 'inline' } }, clonedChild), !!validation, validation), {
                'data-tid': dataTid,
            });
        }));
    };
    ValidationWrapperInternal.prototype.getControlPosition = function () {
        var htmlElement = this.getRootNode();
        if (isElement(htmlElement)) {
            var rect = htmlElement.getBoundingClientRect();
            return { x: rect.top, y: rect.left };
        }
        return null;
    };
    ValidationWrapperInternal.prototype.processBlur = function () {
        var touched = this.isChanging;
        this.isChanging = false;
        var validation = this.getOnBlurValidation(touched);
        return this.setValidation(validation);
    };
    ValidationWrapperInternal.prototype.processSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isChanging = false;
                return [2 /*return*/, this.setValidation(this.props.validation)];
            });
        });
    };
    ValidationWrapperInternal.prototype.hasError = function () {
        return getLevel(this.state.validation) === 'error';
    };
    ValidationWrapperInternal.prototype.hasWarning = function () {
        return getLevel(this.state.validation) === 'warning';
    };
    ValidationWrapperInternal.prototype.isIndependent = function () {
        return getIndependent(this.state.validation || this.props.validation) === true;
    };
    ValidationWrapperInternal.prototype.handleBlur = function () {
        var _this = this;
        setTimeout(function () {
            _this.processBlur();
            if (!_this.isIndependent()) {
                _this.context.instanceProcessBlur(_this);
            }
            _this.setState({});
        });
    };
    ValidationWrapperInternal.prototype.applyValidation = function (actual) {
        var visible = this.getVisibleValidation(actual);
        this.setValidation(visible);
    };
    ValidationWrapperInternal.prototype.setValidation = function (validation) {
        var _this = this;
        var current = this.state.validation;
        if (current === validation) {
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            _this.setState({ validation: validation }, function () {
                if (Boolean(current) !== Boolean(validation)) {
                    _this.context.onValidationUpdated(_this, !validation);
                }
                resolve();
            });
        });
    };
    ValidationWrapperInternal.prototype.getOnBlurValidation = function (touched) {
        var actual = this.props.validation;
        if (getType(actual) === 'submit') {
            var visible = this.state.validation;
            return !touched && getType(visible) === 'submit' ? visible : null;
        }
        return actual;
    };
    ValidationWrapperInternal.prototype.getVisibleValidation = function (actual) {
        var visible = this.state.validation;
        if (isEqual(visible, actual)) {
            return visible;
        }
        var changing = this.context.isAnyWrapperInChangingMode();
        return getVisibleValidation(visible, actual, changing);
    };
    ValidationWrapperInternal.contextType = ValidationContext;
    return ValidationWrapperInternal;
}(React.Component));

var ValidationWrapper = /** @class */ (function (_super) {
    __extends(ValidationWrapper, _super);
    function ValidationWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationWrapper.prototype.render = function () {
        var _a = this.props, children = _a.children, validationInfo = _a.validationInfo, renderMessage = _a.renderMessage, datTid = _a["data-tid"];
        var validation = validationInfo
            ? {
                level: validationInfo.level || 'error',
                behaviour: validationInfo.type || 'lostfocus',
                message: validationInfo.message,
                independent: validationInfo.independent || false,
            }
            : null;
        return (React.createElement(ValidationWrapperInternal, { "data-tid": datTid, errorMessage: renderMessage || tooltip('right top'), validation: validation }, children));
    };
    ValidationWrapper.__KONTUR_REACT_UI__ = 'ValidationWrapper';
    ValidationWrapper.displayName = 'ValidationWrapper';
    return ValidationWrapper;
}(React.Component));

var ValidationBuilder = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function ValidationBuilder(writer, tokens, path, data) {
        this.writer = writer;
        this.tokens = tokens;
        this.path = path;
        this.data = data;
    }
    ValidationBuilder.prototype.prop = function (lambdaPath, rule) {
        var info = this.getPathInfo(lambdaPath);
        if (isNullable(info)) {
            return;
        }
        var builder = new ValidationBuilder(this.writer, this.tokens, info.path, info.data);
        rule(builder, builder.data);
    };
    ValidationBuilder.prototype.array = function (lambdaPath, rule) {
        var info = this.getPathInfo(lambdaPath);
        if (isNullable(info) || !Array.isArray(info.data)) {
            return;
        }
        var array = info.data;
        for (var i = 0; i < array.length; ++i) {
            var path = __spreadArray(__spreadArray([], info.path, true), [i.toString()], false);
            var builder = new ValidationBuilder(this.writer, this.tokens, path, array[i]);
            rule(builder, builder.data, i, array);
        }
    };
    ValidationBuilder.prototype.invalid = function (isInvalid, messageOrValidationInfo, type, level, independent) {
        var validationWriter = this.writer.getNode(this.path);
        if (validationWriter.isValidated()) {
            return;
        }
        var invalid = isInvalid(this.data);
        if (!invalid) {
            return;
        }
        if (isValidationInfo(messageOrValidationInfo)) {
            validationWriter.set(messageOrValidationInfo);
        }
        else {
            validationWriter.set({ message: messageOrValidationInfo, type: type, level: level, independent: independent });
        }
    };
    ValidationBuilder.prototype.getPathInfo = function (lambdaPath) {
        var path = this.tokens.getOrAdd(lambdaPath);
        var data = this.data;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (isNullable(data)) {
                return null;
            }
            data = data[part];
        }
        return { data: data, path: __spreadArray(__spreadArray([], this.path, true), path, true) };
    };
    return ValidationBuilder;
}());
var isValidationInfo = function (argument) {
    return typeof argument === 'object' && Object.prototype.hasOwnProperty.call(argument, 'message');
};

var ValidationReader = /** @class */ (function () {
    function ValidationReader(node, tokens) {
        this.node = node;
        this.tokens = tokens;
    }
    ValidationReader.prototype.getNode = function (lambdaPath) {
        var path = this.tokens.getOrAdd(lambdaPath);
        return this.getReaderInternal(path);
    };
    ValidationReader.prototype.getNodeByIndex = function (index) {
        return this.getReaderInternal([index.toString()]);
    };
    ValidationReader.prototype.getNodeByKey = function (key) {
        return this.getReaderInternal([key.toString()]);
    };
    ValidationReader.prototype.get = function () {
        return this.node ? this.node.validation : null;
    };
    ValidationReader.prototype.getReaderInternal = function (path) {
        var node = this.getNodeInternal(path);
        return new ValidationReader(node, this.tokens);
    };
    ValidationReader.prototype.getNodeInternal = function (path) {
        var current = this.node;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (!current || !current.children) {
                return null;
            }
            current = current.children[part];
        }
        return current;
    };
    return ValidationReader;
}());

var ValidationWriter = /** @class */ (function () {
    function ValidationWriter(node) {
        this.node = node || { validation: null, children: null };
    }
    ValidationWriter.prototype.getReader = function (tokens) {
        return new ValidationReader(this.node, tokens);
    };
    ValidationWriter.prototype.set = function (validation) {
        this.node.validation = validation;
    };
    ValidationWriter.prototype.isValidated = function () {
        return !!this.node.validation;
    };
    ValidationWriter.prototype.getNode = function (path) {
        var node = this.getNodeInternal(path);
        return new ValidationWriter(node);
    };
    ValidationWriter.prototype.getNodeInternal = function (path) {
        var node = this.node;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (!node.children) {
                node.children = {};
            }
            if (!node.children[part]) {
                node.children[part] = {
                    validation: null,
                    children: null,
                };
            }
            node = node.children[part];
        }
        return node;
    };
    return ValidationWriter;
}());

var classicFunctionRegEx = /^\s*function\s*\(\s*([A-Za-z0-9_$]+)\s*\)\s*\{\s*(?:(?:"use strict"|'use strict');?)?\s*return\s+\1\s*([.[].*?)?\s*;?\s*\}\s*$/;
var arrowFunctionRegEx = /^\s*\(?\s*([A-Za-z0-9_$]+)\s*\)?\s*=>\s*\1\s*([.[].*?)?\s*$/;
function extractPath(lambda) {
    var match = classicFunctionRegEx.exec(lambda) || arrowFunctionRegEx.exec(lambda);
    if (match && match.length === 3) {
        return (match[2] || '').replace(/(^\.\s*)/g, '');
    }
    throw new Error("Not supported or invalid path: <".concat(lambda, ">"));
}
function extractTokens(path) {
    return path.split(/[\s.[\]]+/g).filter(function (x) { return x; });
}
var PathTokensCache = /** @class */ (function () {
    function PathTokensCache() {
        this.cache = new Map();
    }
    PathTokensCache.prototype.getOrAdd = function (lambdaPath) {
        var lambdaString = lambdaPath.toString();
        if (!this.cache.has(lambdaString)) {
            var path = extractPath(lambdaString);
            var tokens = extractTokens(path);
            this.cache.set(lambdaString, tokens);
        }
        return this.cache.get(lambdaString);
    };
    PathTokensCache.prototype.has = function (lambdaPath) {
        var lambdaString = lambdaPath.toString();
        return this.cache.has(lambdaString);
    };
    Object.defineProperty(PathTokensCache.prototype, "size", {
        get: function () {
            return this.cache.size;
        },
        enumerable: false,
        configurable: true
    });
    return PathTokensCache;
}());

function validate(data, validationRule, tokens) {
    var validationWriter = new ValidationWriter();
    var builder = new ValidationBuilder(validationWriter, tokens, [], data);
    validationRule(builder, data);
    return validationWriter.getReader(tokens);
}
function createValidator(rule) {
    var tokens = new PathTokensCache();
    return function (value) {
        return validate(value, rule, tokens);
    };
}

exports.ValidationBuilder = ValidationBuilder;
exports.ValidationContainer = ValidationContainer;
exports.ValidationContext = ValidationContext;
exports.ValidationContextWrapper = ValidationContextWrapper;
exports.ValidationReader = ValidationReader;
exports.ValidationTooltip = ValidationTooltip;
exports.ValidationWrapper = ValidationWrapper;
exports.ValidationWrapperV1 = ValidationWrapper;
exports.ValidationsFeatureFlagsContext = ValidationsFeatureFlagsContext;
exports.createValidator = createValidator;
exports.getFullValidationsFlagsContext = getFullValidationsFlagsContext;
exports.text = text;
exports.tooltip = tooltip;
exports.validationsFeatureFlagsDefault = validationsFeatureFlagsDefault;
//# sourceMappingURL=index.js.map
